<template>
  <div id="vueplayer" :style="getHeight()">
    <div
      v-html="debugHtml"
      style="
        position: absolute;
        left: 0;
        top: 0;
        max-height: 100vh;
        width: 200px;
        z-index: 11111111;
        color: #fff;
        overflow-y: auto;
        display: none;
      "
    ></div>
    <div v-show="displayNotification" class="single-notification">
      <div class="notification-content">
        <span class="notification-close" @click="onHideNotification">x</span>
        <div class="notification-image">
          <img src="../assets/Images/clock1.svg" alt="ni" />
        </div>
        <div>
          <p v-html="notificationText" class="notification-text"></p>
        </div>
      </div>
    </div>
    <div v-show="displayContinueNotification" class="single-notification">
      <div class="notification-content">
        <!--<span class="notification-close" @click="onHideNotification">x</span>-->
        <div class="notification-image">
          <img src="../assets/Images/clock1.svg" alt="ni" />
        </div>
        <div>
          <p class="notification-text">{{ $t("livestage.sessionstarted") }}</p>

          <div class="notification-btn">
            <a
              href="javascript:(0);"
              class="yes"
              @click="onHideContinueNotification(true)"
              >{{ $t("livestage.joinnextSession") }}</a
            >
            <a
              href="javascript:(0);"
              @click="onHideContinueNotification(false)"
              >{{ $t("livestage.continueHere") }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!--page-effect left-menu-gap player-screen-wrap-->
    <input
      type="text"
      id="txtJustFocus"
      style="
        height: 10px;
        width: 110;
        padding: 0;
        position: absolute;
        z-index: 10000;
        visibility: hidden;
      "
    />
    <section
      id="LiveStage"
      @click="stageClicked"
      class="
        session-list-wrapper
        d-flex
        SessionlistMultitracker
        flex-column
        counter-bg
        page-effect
        left-menu-gap
        player-screen-wrap
      "
      :style="getHeight()"
    >
      <!------onAir video header--------->
      <header
        v-show="ShowPlayerHeader || !newDesign"
        :class="ShowPlayerHeader ? 'header-wrap' : 'header-wrap d-none'"
      >
        <div class="container-fluid">
          <div class="header-inner">
            <div class="top-left-area">
              <div v-show="sessionSettingsLoaded" class="top-logo">
                <a
                  v-if="currentLiveStageLogoLink"
                  v-bind:href="currentLiveStageLogoLink"
                  target="_blank"
                >
                  <img
                    v-bind:src="currentLiveStageLogo"
                    alt="on-air-white"
                    width="150"
                    style="on-air-logo"
                  />
                </a>
                <a v-else>
                  <img
                    v-bind:src="currentLiveStageLogo"
                    alt="on-air-white"
                    width="150"
                    style="on-air-logo"
                  />
                </a>
              </div>
              <div v-show="recordingStarted" class="rec-indicator">
                <p>
                  <span class="rec-blink"></span>
                  &nbsp;REC
                </p>
              </div>
            </div>
            <div class="session-name">
              <p clas="mb-0" id="pHeaderSessionName" style="display: block"></p>
            </div>
            <div class="player-header-right">
              <div
                v-show="switchTableVisible"
                class="session-switch"
                @click="displayCurrentTableList()"
              >
                <button>{{ switchSessionText }}</button>
              </div>
              <div
                v-show="displayCountdownTimer && callStarted"
                class="session-end-countdown"
              >
                <p v-show="selectedSessionId != '' || exPageId == 'o2o'">
                  {{ sessionTimeCounterLabel }}:
                  <span id="sessionEndCountdown" class="ml-2"></span>
                </p>
              </div>
              <div
                id="playerResize"
                class="player-resize"
                @click="resizePlayer(true)"
              >
                <img
                  v-show="DisplayMaximizeButton && !isMaximized"
                  id="btn-max"
                  src="@/assets/Images/maximise.svg"
                  alt="on-air-white"
                />
                <img
                  v-show="DisplayMaximizeButton && isMaximized"
                  id="btn-min"
                  src="@/assets/Images/minimize.svg"
                  alt="on-air-white"
                />
                <span v-show="DisplayMaximizeButton" class="window-state">
                  {{ $t("livestage.maximize") }}
                </span>
                <!--<img
              id="btn-min"
              class="d-none"
              src="../../../assets/Images/min-screen.png"
              alt="on-air-white"
                />-->
              </div>
            </div>
          </div>
        </div>
      </header>
      <!--------------->

      <div style="height: 100%">
        <!--------------->
        <div
          id="playerWrap"
          class="agora-player onair-palyer-wrap"
          style="height: 100%"
        >
          <section
            :class="
              ShowPlayerHeader
                ? 'player-main-wrap d-flex body-content player-wrapper-hld'
                : 'player-main-wrap d-flex body-content player-wrapper-hld without-header'
            "
          >
            <div
              class="container live-stage-body"
              v-bind:style="
                'background: url(' +
                LiveStageBackground +
                ') center no-repeat; background-color:#000;' +
                getHeight()
              "
            >
              <!-----------CONCURENT SESSION LIST START---------------->
              <div
                id="divSessionsContainer"
                @click="hideCurrentSessionList()"
                class="container left-right-common-gap session-list-v2"
                style="display: none"
              >
                <div class="multi-session-list-title">
                  <h1
                    class="
                      page-head
                      text-uppercase
                      white-text
                      roundtable-head-page
                    "
                  >
                    Click to Join
                  </h1>
                </div>
                <!-----tracker box--------->
                <!--<div class="track-headding two-track">
                  <div class="row d-md-flex justify-content-between m-0">
                    <div class="track-box">KeyNote</div>

                    <div class="track-box">Leadership talk</div>
                  </div>
                </div>-->
                <!-----tracker box--------->
                <!-------session box---->
                <div
                  id="divSessionsSlider"
                  class="
                    white-box-wrapper
                    multi-session-list-wrap
                    two-session
                    ml-0
                    scroll-area
                  "
                >
                  <div
                    v-for="item in currentSessions"
                    :id="'live_session_' + item.SessionId"
                    :key="item.SessionId"
                    :class="
                      selectedSessionId == item.SessionId
                        ? 'single-sesion-right live-session-right'
                        : 'single-sesion-right'
                    "
                    :sessionType="
                      item.SessionTypeDetails.TypeID < 5
                        ? item.SessionTypeDetails.TypeID
                        : 0
                    "
                  >
                    <div class="top-right-session-wrap">
                      <div :class="'right-session-type ' + item.LinkClass">
                        <span class="mr-2">
                          <svg
                            v-if="
                              item.SessionTypeDetails.TypeID ==
                              GlobalKeysData.OnDemandTypeID
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                          >
                            <defs></defs>
                            <path
                              id="on-demand.svg"
                              class="cls-1"
                              d="M6956,1428a14,14,0,1,1,14-14A14,14,0,0,1,6956,1428Zm0-26.25a12.25,12.25,0,1,0,12.25,12.25A12.244,12.244,0,0,0,6956,1401.75Zm0,21a8.75,8.75,0,1,1,8.75-8.75A8.753,8.753,0,0,1,6956,1422.75Z"
                              transform="translate(-6942 -1400)"
                            />
                          </svg>

                          <svg
                            v-if="
                              item.SessionTypeDetails.TypeID ==
                              GlobalKeysData.LiveStreamTypeID
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="46"
                            height="20"
                            viewBox="0 0 46 20"
                          >
                            <defs></defs>
                            <path
                              id="live-stream.svg"
                              class="cls-1"
                              d="M7127,1424h-42a2.006,2.006,0,0,1-2-2v-16a2.006,2.006,0,0,1,2-2h42a2.006,2.006,0,0,1,2,2v16A2.006,2.006,0,0,1,7127,1424Zm0-18h-42v16h42v-16Zm-35,4a4,4,0,1,1-4,4A4,4,0,0,1,7092,1410Zm9.67,6.39h2.94v1.6H7100v-7.98h1.67v6.38Zm6.31,1.6h-1.66v-7.98h1.66v7.98Zm5.43-2.57,2.05-5.41h1.77l-3.08,7.98h-1.47l-3.09-7.98h1.77Zm10.52-3.8h-3.48v1.5h3.25v1.57h-3.25v1.7h3.56v1.6h-5.23v-7.98h5.15v1.61Z"
                              transform="translate(-7083 -1404)"
                            />
                          </svg>

                          <svg
                            v-if="
                              item.SessionTypeDetails.TypeID ==
                              GlobalKeysData.LivePanelTypeID
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="29"
                            viewBox="0 0 32 29"
                          >
                            <defs></defs>
                            <path
                              id="live-panel.svg"
                              class="cls-1"
                              d="M7039.22,1421.07c-0.76,0-1.9-.05-2.47-0.05a13.947,13.947,0,0,0-3.03-20.6l1.44-1.43A15.938,15.938,0,0,1,7039.22,1421.07Zm-4.57-3.99c-0.57,0-1.49-.03-2.4-0.03a7.871,7.871,0,0,0,1.75-4.97,7.976,7.976,0,0,0-4.68-7.26l1.49-1.49a9.984,9.984,0,0,1,5.19,8.75A9.873,9.873,0,0,1,7034.65,1417.08Zm-3.66-4.96a4.775,4.775,0,0,1-1.47,3.51,5,5,0,0,1-7.06,0,4.775,4.775,0,0,1-1.47-3.51,4.852,4.852,0,0,1,1.47-3.53,4.927,4.927,0,0,1,7.06,0A4.852,4.852,0,0,1,7030.99,1412.12Zm-2.84-2.16a3.01,3.01,0,0,0-5.15,2.15,2.827,2.827,0,0,0,.87,2.12,3.174,3.174,0,0,0,4.28,0,2.865,2.865,0,0,0,.87-2.12A2.982,2.982,0,0,0,7028.15,1409.96Zm-10.15,2.12a7.956,7.956,0,0,0,2.08,5.37c-0.67.37-1.29,0.52-1.86,0.9a9.968,9.968,0,0,1,2.97-15.02l1.49,1.49A7.976,7.976,0,0,0,7018,1412.08Zm-6,0a13.889,13.889,0,0,0,2.75,8.32,9.265,9.265,0,0,0-.47,2.55,15.945,15.945,0,0,1,2.56-23.96l1.44,1.43A13.978,13.978,0,0,0,7012,1412.08Zm6.01,9.32a12.071,12.071,0,0,1,4.02-1.8,17.553,17.553,0,0,1,3.73-.52c3.4,0,6.35.7,8.23,2.03a3.685,3.685,0,0,1,1.83,2.95l-0.01,3.93h-19.62l-0.01-3.77A3.5,3.5,0,0,1,7018.01,1421.4Zm0.25,4.53h15.48l0.08-2.04c0-1.79-5.37-2.82-7.72-2.82-2.64,0-7.93,1.66-7.93,2.99Z"
                              transform="translate(-7010 -1399)"
                            />
                          </svg>

                          <svg
                            v-if="
                              item.SessionTypeDetails.TypeID ==
                              GlobalKeysData.RoundTableTypeID
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="31.21"
                            viewBox="0 0 32 31.21"
                          >
                            <defs></defs>
                            <path
                              id="round-table.svg"
                              class="cls-1"
                              d="M6900.5,1418.06H6898a13.9,13.9,0,0,0,0-8.08h2.5A16.572,16.572,0,0,1,6900.5,1418.06Zm-12.29,9.31a13.56,13.56,0,0,0,6.87-4.13l1.26,2.19a16.11,16.11,0,0,1-6.89,4.12Zm-0.17-26.75,1.25-2.18a16.028,16.028,0,0,1,6.94,4.06l-1.25,2.19A13.566,13.566,0,0,0,6888.04,1400.62Zm6.96,13.37a10,10,0,1,1-10-10A10,10,0,0,1,6895,1413.99Zm-10-7.6a7.6,7.6,0,1,0,7.6,7.6A7.6,7.6,0,0,0,6885,1406.39Zm-9.84-1.86-1.24-2.17a15.92,15.92,0,0,1,6.97-3.97l1.25,2.19A13.641,13.641,0,0,0,6875.16,1404.53Zm6.8,22.88-1.25,2.18a15.874,15.874,0,0,1-6.94-4.06l1.25-2.18A13.579,13.579,0,0,0,6881.96,1427.41Zm-12.46-9.35a16.572,16.572,0,0,1,0-8.08h2.5a13.9,13.9,0,0,0,0,8.08h-2.5Z"
                              transform="translate(-6869 -1398.38)"
                            />
                          </svg>
                        </span>
                        <p>{{ item.SessionTypeDetails.TypeName }}</p>
                      </div>
                      <div class="right-session-status">
                        <p>
                          <span :class="item.StatusClass"></span>
                          {{ item.StatusDisplayText }}
                        </p>
                      </div>
                    </div>
                    <div class="right-session-details">
                      <p
                        data-toggle="tooltip"
                        data-placement="left"
                        :title="item.Name"
                      >
                        {{ item.Name }}
                      </p>
                      <span
                        data-toggle="tooltip"
                        data-placement="left"
                        :title="item.TrackName"
                        class="keynote"
                        >{{ item.TrackName }}</span
                      >
                      <p class="time-session">
                        {{ item.StartTimeLabel }} - {{ item.EndTimeLabel }}
                      </p>
                    </div>
                    <div
                      v-show="item.SessionTypeDetails.TypeID <= 5"
                      class="right-session-button"
                    >
                      <div
                        v-if="
                          (item.SessionTypeDetails.TypeID < 5 ||
                            item.SessionTypeDetails.InPersonURL) &&
                          (!item.IsZoomRTMP ||
                            item.IsHost ||
                            item.IsSpeaker ||
                            (item.IsZoomRTMP &&
                              item.ZoomMeetingStarted &&
                              item.ZoomRTMPStarted))
                        "
                        @click="startSession(item.SessionId, false, $event)"
                        class="btn-manual-proceed ml-0"
                      >
                        {{ $t("livestage.proceed") }}
                      </div>
                      <div v-else class="btn-manual-proceed ml-0 disabled">
                        {{ $t("livestage.proceed") }}
                      </div>
                      <!--<div
                        v-if="
                          IsZoomRTMPOptionsEnabled &&
                          item.SessionTypeDetails.TypeID ==
                            GlobalKeysData.LivePanelTypeID &&
                          item.IsLive &&
                          item.IsZoomRTMP &&
                          item.ZoomMeetingStarted &&
                          (item.IsHost ||
                            (item.IsSpeaker && item.ZoomRTMPStarted))
                        "
                        class="on-demand-session-option"
                        :id="'session_wrap_' + item.SessionId"
                      >
                        <p
                          @click="
                            toggleMoreSessionActions(item.SessionId, $event)
                          "
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                        </p>
                        <div class="on-demand-dropdown d-none">
                          <ul>
                            <li
                              v-if="
                                item.IsHost &&
                                item.ZoomMeetingStarted &&
                                !item.ZoomRTMPStarted
                              "
                              @click="
                                StartRTMPStreaming(item.SessionId, $event)
                              "
                            >
                              Start RTMP Streaming
                            </li>
                            <li
                              v-if="item.IsHost && item.ZoomRTMPStarted"
                              @click="StopRTMPStreaming(item.SessionId, $event)"
                            >
                              Stop RTMP Streaming
                            </li>
                            <li
                              v-if="
                                (item.IsHost || item.IsSpeaker) &&
                                item.ZoomRTMPStarted
                              "
                              @click="
                                startInteractionWithAudience(item.SessionId)
                              "
                            >
                              Interact with Audience
                            </li>
                          </ul>
                        </div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
              <!-----------CONCURENT SESSION LIST END---------------->

              <!-----------counter start---------------->
              <div
                id="divCountdownContainer"
                v-show="
                  !roomId &&
                  (selectedSessionTypeId == 0 || selectedSessionTypeId == 5) &&
                  countdownSeconds > 0
                "
                class="counter-main area upcoming-countdown"
                style="display: none"
              >
                <!-----------------html start 11.08.2020********************-->
                <div class="container session-timer-v2 pb-5">
                  <div class="row">
                    <div class="col-md-12">
                      <!--<h4 class="join-live-head p-4">You are joining a Live Panel Broadcast in 60 second</h4>-->
                      <h4 id="hSessionHeader" class="join-live-head p-3"></h4>
                      <div
                        id="divCountdownSessionStatus"
                        class="live-session-status"
                      >
                        <p>
                          <span class="active-session"></span>
                          Live
                        </p>
                      </div>
                      <div class="clock-circle-wrapper text-center">
                        <div
                          id="upcomingTimer"
                          class="
                            timer-clock
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <!--{{countdownSeconds}}-->
                          <!--<BaseTimer ref="baseTimer" v-show="timeLeft>0" :time-left="timeLeft" />-->
                          <BaseTimer
                            ref="baseTimer"
                            @onTimesUp="onTimesUp($event)"
                          />
                        </div>
                        <h1
                          v-show="upcomingSessionCount == 1"
                          id="hSessionTitle"
                          class="upcoming-session-title"
                        ></h1>
                        <h3
                          v-show="upcomingSessionCount == 1"
                          id="hSessionTrack"
                          class="upcoming-session-track"
                        ></h3>
                        <h5
                          v-show="upcomingSessionCount == 1"
                          id="hSessionTime"
                          class="upcoming-session-time"
                        ></h5>
                        <div class="bottom-icon-hld-wrap">
                          <ul>
                            <li
                              id="liSessionTypeIcons"
                              class="session-type justify-content-center"
                            >
                              <span class="session-type-icon">
                                <img
                                  id="imgOnDemandSessionTypeIcon"
                                  class="imgSessionTypeIcon"
                                  src="../assets/Images/icons/on-demand-white.svg"
                                  alt="On-Demand Video"
                                  title="On-Demand Video"
                                />
                                <img
                                  id="imgLiveStreamSessionTypeIcon"
                                  class="imgSessionTypeIcon"
                                  src="../assets/Images/icons/live-stream-white.svg"
                                  alt="Live Stream"
                                  title="Live Stream"
                                />
                                <img
                                  id="imgLivePanelSessionTypeIcon"
                                  class="imgSessionTypeIcon"
                                  src="../assets/Images/icons/live-panel-white.svg"
                                  alt="Live Panel"
                                  title="Live Panel"
                                />
                                <img
                                  id="imgRoundTableSessionTypeIcon"
                                  class="imgSessionTypeIcon"
                                  src="../assets/Images/icons/round-table-white.svg"
                                  alt="Tound Table"
                                  title="Round Table"
                                />
                                <img
                                  id="imgInPersonSessionTypeIcon"
                                  class="imgSessionTypeIcon"
                                  src="../assets/Images/icons/in-person-white.svg"
                                  alt="Tound Table"
                                  title="Round Table"
                                />
                              </span>
                              <span id="spanSessionType">
                                <span
                                  v-show="
                                    upcomingSessionTypeId == 1 ||
                                    selectedSessionTypeId == 1
                                  "
                                  >On-Demand</span
                                >
                                <span
                                  v-show="
                                    upcomingSessionTypeId == 2 ||
                                    selectedSessionTypeId == 2
                                  "
                                  >Live Stream</span
                                >
                                <span
                                  v-show="
                                    upcomingSessionTypeId == 3 ||
                                    selectedSessionTypeId == 3
                                  "
                                  >Live Panel</span
                                >
                                <span
                                  v-show="
                                    upcomingSessionTypeId == 4 ||
                                    selectedSessionTypeId == 4
                                  "
                                  >Round Table</span
                                >
                                <span
                                  id="inPersonSessionTypeText"
                                  v-show="
                                    upcomingSessionTypeId == 5 ||
                                    selectedSessionTypeId == 5
                                  "
                                  >In-Person</span
                                >
                              </span>
                            </li>
                            <!--<li>
                    <img src="../assets/Images/icons/clock-white-big.svg" />
                    <span id="spanSessionDuration"></span>
                            </li>-->
                            <li
                              class="session-type-join-btn"
                              id="liProceedManuallyWrap"
                            >
                              <a
                                v-if="
                                  (upcomingSessionTypeId == 5 ||
                                    selectedSessionTypeId == 5) &&
                                  InPersonURL
                                "
                                id="aInPersonSessionLink"
                                href="javascript:void(0);"
                                class="btn-manual-proceed"
                                @click="joinInPersonSession(InPersonURL)"
                              >
                                {{ $t("livestage.proceed") }}
                              </a>
                              <div
                                v-else
                                id="btnProceedManually"
                                class="btn-manual-proceed"
                                @click="initLiveStage"
                              >
                                {{ $t("livestage.proceed") }}
                              </div>
                            </li>
                          </ul>
                          <!-- <div style="color: #fff">
                            <h1 id="cTime">1</h1>
                            <h1 id="sTime">2</h1>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="session-rating"
                  v-show="endedSessionCount > 0 && EnableSessionRating"
                >
                  <p>{{ $t("livestage.ratePreviousSession") }}</p>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star-o"></span>
                  <span class="fa fa-star-o"></span>
                  <span class="fa fa-star-o"></span>
                </div>
              </div>
              <!------------counter end--------------->

              <!-----------VIDEO PLAYER START---------------->
              <div
                id="divLiveVideoContainer"
                class="body-content player-wrapper-hld"
                style="display: none"
              >
                <div class="video-wrapper">
                  <video-player
                    ref="videoPlayer"
                    class="vjs-custom-skin"
                    :options="videoPlayerOptions"
                    @volumechange="onVideoPlayerVolumeChange($event)"
                    @play="onVideoPlayerPlay($event)"
                    @ready="onVideoPlayerReady($event)"
                  ></video-player>
                </div>
                <PlayerEmbed
                  v-if="selectedSessionTypeId == GlobalKeysData.OnDemandTypeID"
                  ref="videoEmbeded"
                  id="embedLiveVideo"
                  :showPlayerHeader="ShowPlayerHeader"
                  :style="
                    'display: none; background-color:' +
                    VideoPlayerBackgroundColor +
                    ' !important;'
                  "
                ></PlayerEmbed>

                <!--<div
                  id="ag-button-panel"
                  class="ag-btn-group button-group-wrapper active"
                >
                  <div class="btn-group-left-area show-on-call d-none">
                    <div
                      v-show="IsLive && viewersCountVisible"
                      class="view-count"
                      style="display: block"
                    >
                      <p>
                        <img src="../assets/Images/viewer.png" alt="viewer" />
                        <span class="viewer-count">{{ viewersCount }}</span>
                      </p>
                    </div>
                    <div
                      v-if="[1, 2].include(selectedSessionTypeId)"
                      id="brandLogoBottom"
                      class="brand-logo-wrap"
                    >
                      <div class="brand-logo-inner">
                        <a
                          v-if="currentLiveStageLogoLink"
                          :href="currentLiveStageLogoLink"
                          target="_blank"
                        >
                          <img :src="currentLiveStageLogo" />
                        </a>
                        <img v-else :src="currentLiveStageLogo" />
                      </div>
                    </div>
                  </div>

                  <div class="bottom-right-area">
                    <div
                      id="session-end-countdown"
                      class="session-end-countdown d-none"
                    >
                      <p>
                        <span id="timerLabel" class="ml-2 label">{{
                          timerLabel
                        }}</span>
                        <span id="timerValue">{{ timerValue }}</span>
                      </p>
                    </div>

                    <div
                      v-if="callStarted"
                      class="single-call-handle-butn exit-btn-wrap"
                    >
                      <span
                        :class="
                          'ag-btn exitBtn' +
                          (callStarted ? '' : ' start-call-btn')
                        "
                        style="height: 30px !important"
                      >
                        <i
                          v-show="callStarted"
                          class="ag-icon ag-icon-leave"
                          @click="onConfirmEndCall"
                          >{{ $t("agoracall.leave") }}</i
                        >
                        <i
                          v-show="!callStarted"
                          class="ag-icon ag-icon-leave"
                          @click="onEndCall"
                          >{{ $t("agoracall.join") }}</i
                        >
                      </span>
                    </div>
                  </div>
                </div>-->
              </div>

              <!-----------VIDEO PLAYER END---------------->

              <!-----------LIVE STREAM START---------------->
              <!--v-show="selectedSessionTypeId==GlobalKeysData.LiveStreamTypeID"-->
              <div
                id="divLiveStreamContainer"
                class="body-content player-wrapper-hld"
                style="display: none"
              >
                <div class="video-wrapper">
                  <v-text
                    v-show="ZoomRTMPStarted && !isStreamReady && enableRetry"
                    class="mt-2 pa-2 pl-10 rounded text-subtitle-1 retry-label"
                    style="position: absolute"
                  >
                    <v-icon
                      class="player-btn material-icons-round"
                      @click="retryPlayStream"
                    >
                      replay
                    </v-icon>
                    {{ retryText }}
                  </v-text>
                  <video-player
                    ref="streamPlayer"
                    class="vjs-custom-skin"
                    :options="streamPlayerOptions"
                    @volumechange="onStreamPlayerVolumeChange($event)"
                    @play="onStreamPlayerPlay($event)"
                    @ready="onStreamPlayerReady($event)"
                    @error="onStreamPlayerError($event)"
                  ></video-player>
                </div>
                <PlayerEmbed
                  v-if="
                    selectedSessionTypeId == GlobalKeysData.LiveStreamTypeID
                  "
                  ref="streamEmbeded"
                  id="embedLiveStream"
                  :showPlayerHeader="ShowPlayerHeader"
                  :style="
                    'display: none; background-color:' +
                    VideoPlayerBackgroundColor +
                    ' !important;'
                  "
                ></PlayerEmbed>
              </div>
              <!-----------LIVE STREAM END---------------->

              <!-----------LIVE PANEL START---------------->
              <div
                id="divLivePanelContainer"
                v-show="callStarted"
                class="wrapper meeting"
              >
                <!--<div class="ag-header">
                  <div class="ag-header-lead">
                    <img
                      class="header-logo"
                      :src="require('@/assets/Player/images/ag-logo.png')"
                      alt
                    />
                  </div>
                  <div class="ag-header-msg">
                    Room:&nbsp;
                    <span id="room-name">{{livePlayerChannel}}</span>
                  </div>
                </div>-->
                <div class="ag-main">
                  <div class="ag-container">
                    <LivePlayer
                      v-if="!ZoomWebCall"
                      ref="livePlayer"
                      :roomId="roomId"
                      :exStageUrl="exStageUrl"
                      :allAttendees1="allAttendees"
                      :newDesign="newDesign"
                      :DebugMode="debugMode"
                      :EnableAgoraProxy="enableAgoraProxy"
                      :rememberSettings="rememberSettings"
                      :exPageId="exPageId"
                      :autoRecovery="autoRecovery"
                      :advancedAutoRecovery="advancedAutoRecovery"
                      :displayNetworkError="displayNetworkError"
                      :enableLogUpload="enableLogUpload"
                      :uploadLogLevel="uploadLogLevel"
                      :agoraPlayerClientsideLog="agoraPlayerClientsideLog"
                      :showPlayerHeader="ShowPlayerHeader"
                      :videoProfile="videoProfile"
                      :event_collectionName="event_collectionName"
                      :channel="livePlayerChannel"
                      :transcode="transcode"
                      :baseMode="baseMode"
                      :appId="appId"
                      :eventName="eventName"
                      :uid="uid"
                      :firstName="firstName"
                      :name="name"
                      :instance="instance"
                      :callSwitchingInProcess="callSwitchingInProcess"
                      :endForAllEnabled="endForAllEnabled"
                      :hostOptionsEnabled="hostOptionsEnabled"
                      :hostCanMuteSpeaker="hostCanMuteSpeaker"
                      :hostCanHideSpeaker="hostCanHideSpeaker"
                      :hostCanSpotlightSpeaker="hostCanSpotlightSpeaker"
                      @openSpeakerPanel="openSpeakerPanel"
                      @openAttendeePanel="openAttendeePanel"
                      @requestSpeakerToMute="requestSpeakerToMute"
                      @requestAllSpeakersToMute="requestAllSpeakersToMute"
                      @requestSpotlight="requestSpotlight"
                      @setPlayerSettings="setPlayerSettings"
                      @livePanelOnEnd="livePanelOnEnd"
                      @livePanelOnStart="livePanelOnStart"
                      @goLive="goLive"
                      @displayTablesPopup="displayTablesPopup"
                      @SpeakerPanelOnUpdate="SpeakerPanelOnUpdate"
                      @livePanelOnBeforeStart="livePanelOnBeforeStart"
                      @recordingStatusChanged="recordingStatusChanged"
                      @displaySessionDetails="displaySessionDetails"
                      @startMeeting="startMeeting"
                    ></LivePlayer>

                    <!-- <iframe
                      v-if="ZoomWeb"
                      style="height: 100%"
                      frameborder="0"
                      width="100%"
                      :src="ZoomWebURL"
                      allow="camera;microphone"
                    ></iframe> -->
                    <ZoomWeb
                      v-if="ZoomWebCall"
                      :key="ZoomWebCallKey"
                      :meetingNumber="meetingNumber"
                      :userName="name"
                      :userEmail="email"
                      :tk="tk"
                      :startZoomWebCall="startZoomWebCall"
                      :endZoomWebCall="endZoomWebCall"
                    ></ZoomWeb>
                  </div>
                </div>
              </div>
              <!-----------LIVE PANEL END---------------->

              <!-----------LIVE ROUND TABLES START---------------->
              <div
                v-show="
                  !roomId &&
                  selectedSessionTypeId == GlobalKeysData.RoundTableTypeID &&
                  selectedSessionId != '' &&
                  !callSwitchingInProcess &&
                  allRoundTablesLoaded &&
                  allRTParticipancesLoaded &&
                  showRoundTableList &&
                  exRoundTableId == '' &&
                  ((roundTableList.length > 1 && exRoundTableId == '') ||
                    (roundTableList.length == 1 &&
                      (roundTableList[0].AllowAutoJoin == false ||
                        roundTableList[0].IsTableFull)))
                "
                id="divRoundTablesContainer"
                @click="hideCurrentTableList()"
                :style="getHeight()"
              >
                <section
                  class="body-content round-table-page round-table-List-wrap"
                >
                  <div
                    class="container-fluid"
                    style="height: 100%; display: inline-block"
                  >
                    <div class="row new-addendee-list bg-transparent">
                      <div id="headerText" class="col-md-12 align-center">
                        <div class="switch-table-back" style="display: none">
                          <a
                            ><img
                              src="../assets/Images/chat-assets/back-to-list.svg"
                            /><span>Back</span></a
                          >
                        </div>
                        <h1
                          v-show="roundTableList.length > 0"
                          class="
                            page-head
                            text-uppercase
                            white-text
                            roundtable-head-page
                          "
                        >
                          {{ $t("livestage.roundtable") }}
                        </h1>
                      </div>
                      <div class="col-md-6 d-none">
                        <div class="row justify-content-end">
                          <div class="col-md-5 mb-3 mb-md-0 pr-1"></div>
                          <div class="col-md-4 mb-3 mb-md-0 pl-1">
                            <div
                              class="
                                position-relative
                                fixed-w
                                full-width
                                filter-hld
                              "
                            >
                              <select>
                                <option data-tag value="All">All</option>
                                <option data-tag value>Virtual Expo</option>
                                <option data-tag value>test topic</option>
                                <option data-tag value>topic2</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-none"
                      v-show="openRoundTablesCount > 0"
                    >
                      <!--v-show="
                          roundTableList.length > 1 ||
                          (roundTableList.length == 1 &&
                            roundTableList[0].AllowAutoJoin == false)
                        "-->
                      <div class="legend">
                        <ul
                          class="
                            p-0
                            m-0
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <li class="white-text">
                            <span class="busy">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="34"
                                height="25"
                                viewBox="0 0 34 25"
                              >
                                <path
                                  id="occupied.svg"
                                  fill="#1a5493"
                                  d="M833,280a3,3,0,0,1-3-3V263a2.985,2.985,0,0,1,.927-2.161A2.967,2.967,0,0,1,830,261H808a2.967,2.967,0,0,1-.927-0.161A2.985,2.985,0,0,1,808,263v14a3,3,0,0,1-6,0V263a3,3,0,0,1,3-3,2.967,2.967,0,0,1,.927.161A2.995,2.995,0,0,1,808,255h22a2.995,2.995,0,0,1,2.073,5.161A2.967,2.967,0,0,1,833,260a3,3,0,0,1,3,3v14A3,3,0,0,1,833,280Zm-5-3H810V263h18v14Z"
                                  transform="translate(-802 -255)"
                                  class="cls-1"
                                />
                              </svg>
                            </span>
                            Occupied
                          </li>
                          <li class="white-text">
                            <span class="free">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="34"
                                height="25"
                                viewBox="0 0 34 25"
                              >
                                <path
                                  id="vacant.svg"
                                  fill="#aab8c0"
                                  d="M997,280a3,3,0,0,1-3-3V263a2.985,2.985,0,0,1,.927-2.161A2.967,2.967,0,0,1,994,261H972a2.967,2.967,0,0,1-.927-0.161A2.985,2.985,0,0,1,972,263v14a3,3,0,0,1-6,0V263a3,3,0,0,1,3-3,2.967,2.967,0,0,1,.927.161A2.995,2.995,0,0,1,972,255h22a2.995,2.995,0,0,1,2.073,5.161A2.967,2.967,0,0,1,997,260a3,3,0,0,1,3,3v14A3,3,0,0,1,997,280Zm-5-3H974V263h18v14Z"
                                  transform="translate(-966 -255)"
                                />
                              </svg>
                            </span>
                            {{ $t("livestage.vacant") }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <section
                      class="new-round-table scroll-area"
                      style="height: calc(100% - 80px)"
                    >
                      <div class="container-fluid clsRoundtableSpl p-0">
                        <div
                          class="row d-md-flex flex-md-wrap table-list"
                          v-show="
                            allRTParticipancesLoaded &&
                            (roundTableList.length > 1 ||
                              (roundTableList.length == 1 &&
                                (roundTableList[0].AllowAutoJoin == false ||
                                  roundTableList[0].IsTableFull)))
                          "
                        >
                          <div
                            v-for="rt in roundTableList"
                            :key="'rt_' + rt.TableId"
                            :class="'col-lg-2 col-md-4 col-6 exhibitors-box-hld edit-table-btn'"
                            style="min-width: 222px"
                          >
                            <RoundTable
                              :id="'table_' + rt.TableId"
                              pageId="rt"
                              :table="rt"
                              @JoinRT="startRoundTable"
                              style="height: 275px; width: 190px"
                            >
                            </RoundTable>
                          </div>
                          <!--<div
                            v-for="rt in roundTableList"
                            v-bind:key="rt.TableId"
                            v-bind:class="
                              'col-lg-2 col-md-4 col-6 exhibitors-box-hld ls-table-box edit-table-btn' +
                              rt.TableId
                            "
                          >
                            <div
                              :class="
                                rt.TableId == selectedRoundTableId
                                  ? 'new-exhibitors-box selected-rt'
                                  : 'new-exhibitors-box'
                              "
                              v-on:click="startRoundTable(rt.TableId)"
                              data-tag="JoinRoundTableVideo"
                            >
                              <a>
                                <h3
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  :title="rt.Name"
                                >
                                  {{ rt.Name }}
                                </h3>
                                <div class="img-hld">
                                  <img
                                    v-bind:src="rt.imgsrc"
                                    v-bind:alt="rt.Name"
                                  />
                                </div>
                              </a>
                              <h4 v-bind:class="rt.LabelCss">
                                <a href="#">{{ rt.tableLabel }}</a>
                              </h4>
                            </div>
                          </div>-->
                        </div>
                        <!--<div
                            v-show="
                              roundTableList.length == 0 && allRoundTablesLoaded
                            "
                            class="table-not-mapped-msg"
                          >
                            <h4>You are not mapped to any Table(s).</h4>
                            <h4>Please wait or contact the Event Planner.</h4>
                          </div>-->
                        <div
                          v-show="
                            roundTableList.length == 0 && allRoundTablesLoaded
                          "
                          v-html="LiveStageEndMessage"
                          class="live-stage-end-message"
                        ></div>
                      </div>
                    </section>
                  </div>
                </section>
                <!--<RoundTable ref="roundTable" :topicId="rtTopicId"></RoundTable>-->
              </div>
              <!-----------LIVE ROUND TABLES END---------------->

              <!-----------SESSION ENDED START---------------->
              <div
                id="divSessionEndedContainer"
                v-show="!roomId && selectedSessionTypeId == -1"
                class="counter-main area"
              >
                <!-----------------html start 11.08.2020********************-->
                <div class="container session-timer-v2 pb-5">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        v-if="LiveStageEndMessage == ''"
                        class="
                          timer-clock
                          d-flex1
                          justify-content-center
                          align-items-center
                        "
                      >
                        <h3
                          id="hSessionEndedText"
                          style="margin-top: 200px; color: #fff"
                          class="join-live-head p-4"
                        >
                          {{ $t("livestage.sessionnotactive") }}
                        </h3>
                        <h4 style="margin-top: 0px" class="join-live-head p-4">
                          <router-link id="hSessionEndedLink" to="/sessions">{{
                            $t("livestage.clickhere")
                          }}</router-link
                          >&nbsp;{{ $t("livestage.toviewAllSesssions") }}
                        </h4>
                      </div>
                      <div
                        v-else
                        v-html="LiveStageEndMessage"
                        class="live-stage-end-message"
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  class="session-rating"
                  v-show="endedSessionCount > 0 && EnableSessionRating"
                >
                  <p>{{ $t("livestage.ratePreviousSession") }}</p>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star-o"></span>
                  <span class="fa fa-star-o"></span>
                  <span class="fa fa-star-o"></span>
                </div>
              </div>
              <!-----------SESSION ENDED END---------------->
            </div>
          </section>
          <!--v-show="!(selectedSessionTypeId==0 && countdownSeconds>0)"-->
          <right-pannel
            id="rightPanel"
            ref="rightPanel"
            v-show="
              (selectedSessionTypeId > 0 &&
                selectedSessionTypeId != 5 &&
                ShowPlayerRightPanel) ||
              stageUrl == '/stageview'
            "
            :newDesign="newDesign"
            :stageUrl="stageUrl"
            :rememberSettings="rememberSettings"
            :callStarted="callStarted"
            :ShowPlayerHeader="ShowPlayerHeader"
            :playerResizeVisible="DisplayMaximizeButton"
            :isFullScreen="isMaximized"
            :playersettings="playerSettings"
            :agendaFilterOption="agendaFilterOption"
            :clientId="clientId"
            :eventId="eventId"
            :roomId="roomId"
            :IsZoomRTMPOptionsEnabled="IsZoomRTMPOptionsEnabled"
            :allAttendees="allAttendees"
            @volumeChanged="volumeChanged($event)"
            @resizePlayer="resizePlayer"
            @getPlayerSettings="getPlayerSettings()"
            @AttendeeEnabled="AttendeeEnabled"
            @updateRightPanelSettings="updateRightPanelSettings($event)"
            @applyAudioVideoSettings="applyAudioVideoSettings($event)"
            @startSession="startSession"
            @startMeeting="startMeeting"
            @setNextMeetingData="setNextMeetingData"
            @unreadChatCountChanged="unreadChatCountChanged"
            @unreadQnACountChanged="unreadQnACountChanged"
          ></right-pannel>
        </div>

        <div
          v-show="showAgendaFileterPopup"
          id="agendaFileterDecisionPopup"
          class="agenda-filter-modal player-modal"
          style="display: none"
        >
          <div class="agenda-filter-modal-wrapper">
            <div class="agenda-filter-popup" role="document">
              <div class="custom-modal-body agenda-filter-body">
                <div class="custom-modal-content">
                  <div class="row agenda-filter-popup-title">
                    <h3>SELECT STAGE</h3>
                  </div>
                  <div class="filter-type-wrapper">
                    <div class="single-content-type">
                      <div
                        @click="selectFilterType(2)"
                        :class="
                          selectedUserAgendaType == 2
                            ? 'filter-type-box fullagenda'
                            : 'filter-type-box fullagenda'
                        "
                      >
                        <div class="filter-type-box-top">
                          {{ $t("livestage.fullAgenda") }}
                        </div>
                        <div class="filter-type-box-middle">
                          <!--{{ sessionList.length }}<br />SESSIONS-->
                          <img
                            src="../assets/Player/images/FullAgenda.svg"
                            height="50"
                          />
                        </div>
                        <div class="filter-type-box-bottom">
                          {{ $t("livestage.enter") }}
                        </div>
                      </div>
                    </div>
                    <div class="single-content-type">
                      <div
                        @click="selectFilterType(1)"
                        :class="
                          selectedUserAgendaType == 1
                            ? 'filter-type-box myagenda'
                            : 'filter-type-box myagenda'
                        "
                      >
                        <div class="filter-type-box-top">
                          {{ $t("livestage.myAgenda") }}
                        </div>
                        <div class="filter-type-box-middle">
                          <!--{{ mySessions.length }}<br />SESSIONS-->
                          <img
                            src="../assets/Player/images/MyAgenda.svg"
                            height="50"
                          />
                        </div>
                        <div class="filter-type-box-bottom">
                          {{ $t("livestage.enter") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--<div class="row filter-button-wrapper">
                    <a
                      v-if="
                        (selectedUserAgendaType == 1 &&
                          mySessions.length > 0) ||
                        (selectedUserAgendaType == 2 && sessionList.length > 0)
                      "
                      href="javascript:(0);"
                      class="filter-button"
                      @click="applyAgendaType()"
                      >ENTER</a
                    >
                    <router-link v-else class="filter-button" to="/sessions"
                      >GO TO SESSIONS</router-link
                    >
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ComponentSessionDetails
        v-if="newDesign && selectedSession"
        :id="'popupSessionDetails'"
        v-bind:key="selectedSession.SessionId"
        v-bind:IsPlayerPopup="true"
        v-bind:SessionID="selectedSession.SessionId"
        v-bind:SessionTypeID="selectedSession.TypeID"
        v-bind:IsLive="selectedSession.IsLive"
        v-bind:LinkClass="selectedSession.LinkClass"
        v-bind:TopicId="selectedSession.TopicId"
        v-bind:Title="selectedSession.Name"
        v-bind:Location="selectedSession.Location"
        v-bind:DescriptionShort="selectedSession.DescriptionShort"
        v-bind:StartTimeLabel="selectedSession.StartTimeLabel"
        v-bind:EndTimeLabel="selectedSession.EndTimeLabel"
        v-bind:StartTime="selectedSession.StartTime"
        v-bind:EndTime="selectedSession.EndTime"
        v-bind:TimeZone="timeZone"
        v-bind:Description="selectedSession.Description"
        v-bind:MappedHosts="selectedSession.MappedHosts"
        v-bind:MappedSpeakers="selectedSession.MappedSpeakers"
        v-bind:SpeakerLength="selectedSession.SpeakerLength"
        v-bind:IsUpcoming="selectedSession.IsUpcoming"
        v-bind:Resources="selectedSession.Resources"
        v-bind:IsMyAgenda="mySessions.includes(selectedSession.SessionId)"
        v-bind:AllowAddRemoveMyAgenda="false"
        v-bind:InPersonLabel="selectedSession.InPersonLabel"
        v-bind:InPersonIcon="selectedSession.InPersonIcon"
        v-bind:InPersonURL="selectedSession.InPersonURL"
      ></ComponentSessionDetails>

      <div
        id="popupPageLeaveConfirm"
        class="modal fade"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18.03"
                  height="18.031"
                  viewBox="0 0 18.03 18.031"
                >
                  <path
                    id="close.svg"
                    fill="#242432"
                    d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                    transform="translate(-1412 -516)"
                  />
                </svg>
              </button>
              <div class="session-details p-4">
                <p>{{ $t("livestage.suretoleave") }}</p>
                <div>
                  <a
                    href="javascript:void(0)"
                    class="button-no"
                    @click="onCancelPageLeave"
                    >{{ $t("livestage.cancel") }}</a
                  >
                  <a
                    href="javascript:void(0)"
                    class="button-yes"
                    @click="onPageLeave"
                    >{{ $t("livestage.leave") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      v-show="displayLoading"
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <!-- <div class="item-c item-1"></div>
        <div class="item-c item-2"></div>
        <div class="item-c item-3"></div>
        <div class="item-c item-4"></div>-->
        <!--<svg
          width="32px"
          height="32px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>-->
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <!-- </p> -->
    </div>

    <div
      id="RetryJoinInZoom"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 20px; font-weight: 600; color: #1e1f26">
                Please try again.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="cancelRetryJoinInZoom"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="retryJoinInZoom"
                  >Retry</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="endedByHostPopup"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 16px; font-weight: 600; color: #1e1f26">
                This meeting has been ended by host.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="closeEndedByHostPopup"
                  >Ok</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="endedRequestPopup"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 16px; font-weight: 600; color: #1e1f26">
                You have joined in another device.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="closeEndeRequestPopup"
                  >Ok</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="rtTableFullRetryPopup"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 16px; font-weight: 600; color: #1e1f26">
                It looks like the table is full, please try after sometime.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="retryCancelRoundTable"
                  >Go Back</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="retryStartRoundTable"
                  >Try Now</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="stayHereConfirmPopup"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 500px">
        <div class="modal-content">
          <div class="modal-body">
            <!--<button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>-->

            <div class="retry-modal p-4">
              <p style="font-size: 16px; font-weight: 600; color: #1e1f26">
                You're already in this meeting from another device.
              </p>
              <p style="font-size: 16px; font-weight: 600; color: #1e1f26">
                Do you wish to transfer to this device and continue here?
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="stayHereCancel"
                  >NO</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="stayHere"
                  >YES</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="rtmpDialog.state"
      persistent
      transition="dialog-bottom-transition"
      width="800"
    >
      <rtmpComponent
        :key="rtmpDialog.key"
        ref="rtmpComponent"
        v-bind:rtmpOptions="rtmpDialog.rtmpOptions"
        @rtmpActions="rtmpActions"
      />
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase";
import "firebase/auth";
//import vueCustomScrollbar from "vue-custom-scrollbar";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import APIs from "@/components/APIInit";
//import store from "./store";
import * as Cookies from "js-cookie";
import LivePlayer from "./Player/components/AgoraVideoCall";
import { AGORA_APP_ID } from "./Player/agora.config";
import RightPannel from "./Player/components/RightPannel.vue";
//import RoundTable from "./Player/components/RoundTable.vue";
import ComponentSessionDetails from "@/components/ComponentSessionDetails.vue";
import rtmpComponent from "@/components/RTMPComponent.vue";
import RoundTable from "@/components/RoundTable.vue";
////import "bulma/css/bulma.css";
//import "@/assets/Player/fonts/css/icons.css";
import analytics from "@/components/Analytics";
import VideoPlayer from "@/components/VideoPlayer.vue";
import PlayerEmbed from "./Player/components/PlayerEmbed";
import ZoomWeb from "@/views/ZoomWeb.vue";
import BaseTimer from "../components/BaseTimer";
//import chat from "@/views/Player/utils/firebase_chat";
import moment from "moment-timezone";
import router from "@/router";
import axios from "axios";
import common from "@/common";
import { bus } from "@/main";
import browserDetect from "vue-browser-detect-plugin";
import Vue from "vue";
Vue.use(browserDetect);

let vm;
let networkTimer;
let sessionSwitchTimer;
let currentSessionTimer;
let scheduleSessionTimer;
let scheduleRTTimer;
let rtAutoJoinTimer;
let joinHereTimer;
let retryPlayStreamTimer;
let currentSessionListener;
let currentSessionParticipancesListener;
let currentRTListener;
var ZoomRTMPParticipantsListener;
let realtimeDB;
var routeReferer = "";
export default {
  components: {
    //"loading-bar": loadingBar
    //SessionAutoFlow: SessionAutoFlow,
    LivePlayer,
    //RoundTable,
    RightPannel,
    VideoPlayer,
    PlayerEmbed,
    BaseTimer,
    //vueCustomScrollbar,
    ComponentSessionDetails,
    rtmpComponent,
    RoundTable,
    ZoomWeb,
  },
  props: {
    roomId: {
      type: String,
      default: "",
    },
    exStageUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      rtmpDialog: {
        key: 0,
        lastUpdateTimeStamp: 0,
        sessionId: "",
        session: null,

        rtmpOptions: {
          title: "Welcome",
          state: false,
          startProcessing: false,
          stopProcessing: false,
          sessionId: "",
          uid: "",
          event_collectionName: "",

          hasZoomLink: false,
          rtmpStartLink: false,
          rtmpStopLink: false,
          rtmpAudienceLink: false,
          viewersCount: 0,
          zoomUrl: "",
          streamUrl: "",
          ZoomMeetingStarted: false,
          ZoomRTMPStarted: false,
          chatEnabled: false,
          qnaEnabled: false,
          //attendeeEnabled: false,
        },
      },
      stageUrl: "/livestage",
      enableRetry: true,
      retryCounter: 0,
      retryInterval: 10,
      //retryText: "Retrying in 10 seconds",
      hasError: false,
      isPlaying: false,
      isStreamReady: false,
      ZoomRTMPStarted: false,

      IsZoomRTMPOptionsEnabled: false,
      newDesign: true,
      autoRecovery: false,
      advancedAutoRecovery: false,
      displayNetworkError: false,
      enableLogUpload: false,
      uploadLogLevel: false,
      agoraPlayerClientsideLog: false,
      enableAgoraProxy: false,
      rememberSettings: false,

      timeZone: "",
      debugHtml: "",
      debugMode: false,
      endForAllEnabled: true,
      ZoomWebEmbedEnabled: false,
      ZoomWebEmbedExternalURL: "",
      HideLiveStreamLeaveButton: false,
      VideoPlayerBackgroundColor: "",
      VideoPlayerPlayButtonColor: "",
      ShowPlayerHeader: false,
      ShowPlayerRightPanel: true,
      ShowJoinButton: true,
      AutoStartRecording: false,
      presence: null,
      muteRequest: 0,
      unmuteRequest: 0,
      muteAllRequest: 0,
      unmuteAllRequest: 0,
      spotlightRequest: 0,
      leaveRequest: 0,

      meetingTimeCounterLabel: "",
      meetingTimeEndsInLabel: this.$t("livestage.meetingendsin"),
      sessionTimeCounterLabel: "",
      sessionTimeEndsInLabel: this.$t("livestage.sessionendsin"),
      sessionTimeExceedsByLabel: this.$t("livestage.timeexceedsby"),
      backStageTimeEndsInLabel: "Time to Go-live", //this.$t("livestage.backstagetimeendsin"),
      backStageTimeExceedsByLabel: "Session Started", //this.$t("livestage.backstagetimeexceedsby"),
      backStageTimeExceedsBySuffix: "ago", //this.$t("livestage.timeexceedsuffix"),
      speakerCount: 0,
      IsBackStage: false,
      IsManualFlow: false,
      IsManuallyStopped: false,
      exPageId: "", //"":livestage, "sn":session, "rt":roundtable, "o2o":one to one meeting, "e2o", exhibitor meeting
      exExhibitorRT: false,
      exSponsorRT: false,
      exParams: "",
      exSessionId: "",
      exRoundTableId: "",
      exMeetingId: "",
      o2oMeeting: null,
      exExhibitorId: "",
      exAttendee1Id: "",
      exAttendee2Id: "",
      autoJoinSession: false,
      isE2OMeetingRep: false,
      callSwitchingInProcess: false,
      loadSessionsComplete: false,
      notificationSent: false,
      rtPageUrl: "",
      zoomErrorMsg:
        "An error has occurred with this Zoom live panel session. Please try again in sometime.",

      prevSessionRunning: false,
      goToNextSession: true,
      displayNotification: false,
      displayContinueNotification: false,
      notificationText: "",
      //defaultNotificationMessage: "This session is about to end in 2 mins",
      defaultNotificationMessage:
        this.$t("livestage.defaultNotificationMessage") + " {{countdown}}",
      defaultDisplayBeforeSessionEndSecs: 120,
      hideNotificationClicked: false,
      hideContinueNotificationClicked: false,
      sessionTimeExceeded: false,
      headerText: this.$t("livestage.headertext"),
      settings: {
        maxScrollbarLength: 100,
      },
      event_collectionName: "",
      //timerInterval: null,
      //timeLimit: 20,
      countdownSeconds: 0,
      //TIME_LIMIT: 0,
      //timePassed: 0,
      hasConnection: true,
      //downLink: 0.5,
      rightPanelVisible: true,
      //recIndicatorVisible: false,
      switchTableVisible: false,
      recordingStarted: false,
      showViewersCount: false,
      DisplayAudienceCounter: false,
      //broadcastSettings: {
      //  AttendeeEnabled: false,
      //  QnAEnabled: false,
      //  ChatEnabled: false,
      //  RaiseHandEnabled: false,
      //  SpeakerInfoEnabled: false,
      //},
      LiveStageLogo:
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media",
      SessionSettingsLogo:
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media",
      SessionLogo: "",
      RoundTableLogo: "",

      LiveStageLogoLink: "https://e2m.live",
      SessionSettingsLogoLink: "https://e2m.live",
      RoundTableSettingsLogoLink: "",
      SessionLogoLink: "",
      RoundTableLogoLink: "",

      LiveStageBackground:
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2Ftimer-bg.jpg?alt=media",
      EnableSessionRating: false,

      DisplayMaximizeButton: false,
      StartLiveStageInMaximizedMode: false,
      displayCountdownTimer: false,
      DisplaySessionTimer: false,
      LiveStageEndMessage: "",

      playerSettings: {
        cameraOptions: [],
        camera: {},
        cameraOld: {},
        microphoneOptions: [],
        microphone: {},
        microphoneOld: {},
        speakerOptions: [],
        speaker: {},
        videoProfile: "360p_7",
      },

      ChannelPrefix: "OAUAT",

      sessionsLoaded: false,
      sessionList: [],
      speakerProfiles: [],
      allAttendees: {},
      callStarted: false,
      selectedSessionId: "",
      selectedSession: null,
      selectedRoundTableId: "",
      selectedRoundTable: null,
      currentSessionList: [],
      selectedSessionTypeId: 0,
      prevSessionTypeId: 0,
      prevSessionId: 0,
      upcomingSessionCount: 0,
      upcomingSessionTypeId: 0,
      upcomingSessionId: "",
      upcomingSession: null,
      endedSessionCount: 0,
      roundTableList: [],
      currentStage: 0,
      showRoundTableList: false,
      allRTParticipancesLoaded: false,
      allRoundTablesLoaded: false,
      sessionSettingsLoaded: false,
      roundTablesLoadedCount: 0,
      openRoundTablesCount: 0,
      mySessionsLoaded: false,
      mySessions: [],
      hasZoomTable: false,
      agendaFilterOption: 0, // 0: FullAgenda (Default), 1: MyAgenda, 2: Both
      allowAgendaTypeFilterInAutoFlow: false,
      userAgendaFilterPending: true,
      agendaFileterPending: true,
      showAgendaFileterPopup: false,
      selectedUserAgendaType: 2,
      InPersonURL: "",
      sessionAttendeeCount: 0,

      GlobalKeysData: {
        IsBroadcastInNewTab: 1,
        IsVideoInNewTab: 0,
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        InPersonTypeID: 5,
        O2OTypeID: 6,
        E2OTypeID: 7,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
      rtSettings: {
        HostLegend: this.$t("livestage.host"),
        SeatGrabText: this.$t("livestage.grabseat"),
        AudienceViewText: this.$t("livestage.spectate"),
        TableFullText: this.$t("livestage.tablefull"),
      },
      sendLiveHeartBit: false,
      heartBitInterval: 15,

      //src: "https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8",
      src: "",
      //src:
      //  "https://dj3v9tj2zkf41.cloudfront.net/ws-demo/BNI/vod/DEMO_VOD_02.m3u8",
      videoPlayerOptions: {
        autoplay: true,
        controls: true,
        //"pointer-events": "none",
        //controlBar: {
        //  timeDivider: true,
        //  durationDisplay: true,
        //},
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      streamPlayerOptions: {
        autoplay: false,
        controls: false,
        //controlBar: {
        //  timeDivider: false,
        //  durationDisplay: false,
        //},
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      //sid: "",
      //LivePanel
      PlayButtonText: "",
      livePlayerChannel: "",
      videoProfile: "360p_7",
      //transcode: Cookies.get("transcode") || "interop",
      //transcode: "interop",
      transcode: "live",
      //baseMode: Cookies.get("baseMode") || "avc",
      //baseMode: "avc",
      baseMode: "al",
      volumeLevel: 100,
      tempVolumeLevel: 0,
      muted: false,

      uid: "",
      isMaximized: false,
      instance: "",
      email: "",
      firstName: "",
      lastName: "",
      name: "",
      company: "",
      country: "",
      designation: "",
      profilePictureURL: "",
      phone: "",
      userIP: "",

      rtTopicId: 0,
      clientId: "",
      eventId: "",
      eventName: "",
      roundtableSettings: {
        isSpeakerTabVisible: false,
        isAttendeeTabVisible: false,
        isQnATabVisible: false,
        isChatTabVisible: false,
        isRaiseHandTabVisible: false,
        SeatGrabText: this.$t("livestage.grabseat"),
        AllowAudienceViewText: this.$t("livestage.spectate"),
        TableFullText: this.$t("livestage.tablefull"),
        ShowFilter: false,
        ShowSearch: false,

        AllowScreenShare: false,
        AllowRecording: false,
        AutoStartRecording: false,
      },
      appId: "",
      allowLeavePage: false,
      redirectToPath: "",
      //sessionListeners: [],
      //roundTableListeners: [],
      MeetingTimeExceptionSeconds: 0, //330 * 60,
      hostOptionsEnabled: false,
      hostCanMuteSpeaker: false,
      hostCanHideSpeaker: false,
      hostCanSpotlightSpeaker: false,
      leaveAndJoinViaAPI: true,
      leaveTypeId: 0,
      leaveDocId: "",
      displayLoading: true,
      retryType: "",
      tempSessionId: null,
      tempTableId: null,
      ZoomWebCall: false,
      ZoomWebCallKey: 0,
      ZoomWebURL: "",
      meetingNumber: "",
      tk: "",
      startZoomWebCall: false,
      endZoomWebCall: false,
    };
  },

  //beforeRouteLeave(to, from, next) {
  //to.params.sid
  //  // If the form is dirty and the user did not confirm leave,
  //  // prevent losing unsaved changes by canceling navigation
  //  if (this.confirmLeave()) {
  //    next(true);
  //  } else {
  //    // Navigate to next view
  //    next(false);
  //  }
  //  alert();
  //},

  beforeRouteLeave(to, from, next) {
    if (vm.allowLeavePage) {
      vm.allowLeavePage = false;
      $("#app").removeClass("player");
      $("body").removeClass("player");
      next(true);
    } else {
      if (vm.callStarted) {
        //let fullPath = "http://google.com";
        let fullPath = location.origin + to.fullPath;
        window.open(fullPath, "_blank");
      } else {
        $("#app").removeClass("player");
        $("body").removeClass("player");
        next(true);
        //vm.redirectToPath = to.fullPath;
        //$("#popupPageLeaveConfirm").modal("show");
      }
      //next(false);
    }
  },

  computed: {
    videoPlayer() {
      return vm.$refs.videoPlayer.player;
    },
    videoPlayerEmbeded() {
      return vm.$refs.videoEmbeded.embededPlayer;
    },
    streamPlayer() {
      return vm.$refs.streamPlayer.player;
    },
    streamPlayerEmbeded() {
      return vm.$refs.streamEmbeded.embededPlayer;
    },
    livePlayer() {
      return vm.$refs.livePlayer.player;
      //this.$nextTick(() => {
      //  //let vm = this
      //  //console.log(vm.$refs) // Shows the mapRef object reference
      //  //console.log(vm.$refs.mapRef) // returns undefined ???
      //});
    },
    roundTable() {
      return vm.$refs.roundTable.player;
    },
    baseTimer() {
      return vm.$refs.baseTimer.timer;
    },
    rightPanel() {
      return vm.$refs.rightPanel.panel;
    },
    rtmpComponent() {
      return vm.$refs.rtmpComponent.rtmpComp;
    },
    switchSessionText() {
      //if (vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID) {
      return "Switch Table";
      //} else {
      //  return "Switch Session";
      //}
    },
    retryText() {
      return "Retrying in " + vm.retryCounter + " seconds";
    },
    //countdownSeconds1() {
    //  return vm.countdownSeconds;
    //},
    //timeLeft() {
    //  //alert("countdownSeconds:" + vm.countdownSeconds);
    //  //alert("timePassed:" + vm.timePassed);
    //  //if (vm.timeLimit - vm.timePassed > 1) {
    //  //  return vm.timeLimit - vm.timePassed;
    //  //} else {
    //  //  return 0;
    //  //}
    //  return 0;
    //},
    currentLiveStageLogo() {
      let logo = vm.LiveStageLogo;
      if (vm.selectedSessionTypeId <= 0) {
        if (vm.SessionSettingsLogo != "") {
          logo = vm.SessionSettingsLogo;
        }
      } else {
        if ([1, 2, 3, 5].includes(vm.selectedSessionTypeId)) {
          if (vm.SessionLogo != "") {
            logo = vm.SessionLogo;
          } else if (vm.SessionSettingsLogo != "") {
            logo = vm.SessionSettingsLogo;
          }
        } else if (vm.selectedSessionTypeId == 4) {
          if (vm.RoundTableLogo != "") {
            logo = vm.RoundTableLogo;
          } else if (vm.SessionLogo != "") {
            logo = vm.SessionLogo;
          } else if (vm.SessionSettingsLogo != "") {
            logo = vm.SessionSettingsLogo;
          }
        } else if (vm.selectedSessionTypeId == 7) {
          // Exhibitor Logo
        }
      }
      return logo;
    },
    currentLiveStageLogoLink() {
      let link = vm.LiveStageLogoLink;
      if ([1, 2, 3, 5].includes(vm.selectedSessionTypeId)) {
        if (vm.SessionSettingsLogoLink != "") {
          link = vm.SessionSettingsLogoLink;
        }
      } else if (
        vm.selectedSessionTypeId == 4 &&
        vm.exPageId == "" &&
        vm.exPageId == "sn"
      ) {
        if (vm.RoundTableSettingsLogoLink != "") {
          link = vm.RoundTableSettingsLogoLink;
        } else if (vm.SessionSettingsLogoLink != "") {
          link = vm.SessionSettingsLogoLink;
        }
      }
      link = "";
      return link;
    },
    currentLiveStageLogoLink1() {
      let link = "";
      if ([1, 2, 3].includes(vm.selectedSessionTypeId)) {
        if (vm.SessionLogo != "") {
          if (vm.SessionLogoLink != "") link = vm.SessionLogoLink;
        } else if (vm.SessionSettingsLogo != "") {
          if (vm.SessionSettingsLogoLink != "") {
            link = vm.SessionSettingsLogoLink;
          }
        }
      } else if (vm.selectedSessionTypeId == 4) {
        if (vm.RoundTableLogo != "") {
          if (vm.RoundTableLogoLink != "") {
            link = vm.RoundTableLogoLink;
          }
        } else if (vm.SessionSettingsLogo != "") {
          if (vm.SessionSettingsLogoLink != "") {
            link = vm.SessionSettingsLogoLink;
          }
        }
      } else {
        // Exhibitor Link
      }
      //alert(link);
      return link;
    },
    currentSessions() {
      vm.currentSessionElementId = "";
      let currentSessionList = [];
      if (
        vm.sessionSettingsLoaded &&
        vm.sessionsLoaded &&
        vm.mySessionsLoaded
      ) {
        //if (vm.sessionId != "") {
        //alert(vm.sessionId);
        //alert(vm.sessionList.length);
        //alert("agendaFilterOption:" + vm.agendaFilterOption);
        //let cTime = parseInt(new Date().getTime() / 1000);
        //alert(vm.exPageId);
        //alert("Sessions:" + vm.sessionList.length);
        //alert("mySessions:" + vm.mySessions.length);
        //alert(cTime)
        vm.sessionList.forEach(function (item) {
          let flag = true;
          //alert(vm.sessionId);
          if (vm.agendaFilterOption == 1) {
            //alert("off");
            flag = false;
            if (vm.mySessions.includes(item.SessionId)) {
              flag = true;
            }
          }
          if (flag) {
            //if (
            //  vm.exPageId == "" ||
            //  (item.StartTime < startTime && item.EndTime > endTime) ||
            //  (item.StartTime >= startTime && item.StartTime <= endTime) ||
            //  (item.EndTime >= startTime && item.EndTime <= endTime)
            //)
            //alert(item.SessionStartTime)
            //alert("add");
            //if (
            //  item.SessionStartTime <= cTime &&
            //  item.SessionEndTime >= cTime
            //)
            if (item.IsLive) {
              //alert(flag);
              //item.SelectedSessionClass = "";
              //if (vm.selectedSessionId == item.SessionId) {
              //  item.SelectedSessionClass = "live-session-right";
              //  vm.currentSessionElementId = "rp_session_" + item.SessionId;
              //}

              //var currentTime = parseInt(new Date().getTime() / 1000);
              //item.IsLive = false;
              //if (currentTime < item.StartTime) {
              //  item.LinkClass = "upcoming-status";
              //  item.StatusDisplayText = "Upcoming";
              //  item.StatusClass = "upcoming-session-indicate";
              //} else if (
              //  currentTime > item.StartTime &&
              //  currentTime < item.EndTime
              //) {
              //  item.IsLive = true;
              //  item.StatusDisplayText = "Live";
              //  item.StatusClass = "live-session-indicate";
              //  item.LinkClass = "ongoing-status";
              //} else if (currentTime > item.EndTime) {
              //  item.StatusDisplayText = "Session Ended";
              //  item.StatusClass = "end-session-indicate";
              //  item.LinkClass = "finish-status";
              //}
              currentSessionList.push(item);
            }
          }
        });
        //}
      }
      //alert("Current:" + currentSessionList.length);
      return currentSessionList;
    },
  },
  watch: {
    "rtmpDialog.lastUpdateTimeStamp"() {
      if (vm.rtmpDialog.session) {
        let session = vm.rtmpDialog.session;
        vm.rtmpDialog.rtmpOptions.hasZoomLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        vm.rtmpDialog.rtmpOptions.ZoomMeetingStarted =
          session.ZoomMeetingStarted;
        vm.rtmpDialog.rtmpOptions.ZoomRTMPStarted = session.ZoomRTMPStarted;
        if (session.IsZoomRTMP) {
          if (session.IsHost || session.IsSpeaker) {
            vm.rtmpDialog.rtmpOptions.hasZoomLink = true;
          }
          if (session.IsHost) {
            vm.rtmpDialog.rtmpOptions.rtmpStartLink = true;
          }
          if (session.IsHost && session.ZoomRTMPStarted) {
            vm.rtmpDialog.rtmpOptions.rtmpStopLink = true;
          }
          if (session.ZoomRTMPStarted) {
            vm.rtmpDialog.rtmpOptions.rtmpAudienceLink = true;
          }
        }
      }
    },
    "rtmpDialog.rtmpOptions.ZoomRTMPStarted"(val) {
      if (val) {
        let session = vm.rtmpDialog.session;
        if (session) {
          if (
            session.IsZoomRTMP &&
            session.ZoomMeetingStarted &&
            session.ZoomRTMPStarted
          ) {
            //vm.onStartSession(session.SessionId);
            setTimeout(() => {
              vm.retryPlayStream();
            }, 100);
          }
        }
      }
    },
    isMaximized: function () {
      if (this.isMaximized) {
        $(".window-state").html(this.$t("livestage.restore"));
      } else {
        $(".window-state").html(this.$t("livestage.maximize"));
      }
      vm.AdjustPlayeHeight();
    },
    ShowPlayerHeader() {
      vm.AdjustPlayeHeight();
    },
    hasConnection: function (val) {
      vm.livePlayer.changeConnectionState(val);
      if (val) {
        if (vm.selectedSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
          vm.startVideoPlayer();
        } else if (
          vm.selectedSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID
        ) {
          vm.startLiveStream();
        } else if (
          vm.selectedSessionTypeId == vm.GlobalKeysData.LivePanelTypeID
        ) {
          if (!vm.livePlayer.manuallyStopped && vm.selectedSessionId != "") {
            //vm.startLivePanel();
            $("#divLivePanelContainer").show();
            $("#divLivePanelContainer").removeClass("d-none");
            $("#divSessionsContainer").hide();
            $("#divSessionsContainer").removeClass("multi-session-popup");
            ////if (vm.callStarted) {
            //vm.livePlayer.ReStartCall();
            ////}
          } else {
            vm.initLiveStage();
          }
        } else if (
          vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID
        ) {
          if (!vm.livePlayer.manuallyStopped && vm.selectedRoundTableId != "") {
            $("#divLivePanelContainer").show();
            $("#divLivePanelContainer").removeClass("d-none");
            $("#divSessionsContainer").hide();
            $("#divSessionsContainer").removeClass("multi-session-popup");
            //if (vm.callStarted) {
            //vm.livePlayer.ReStartCall();
            //}
          } else {
            if (vm.roundTableList.length == 0) {
              vm.initLiveStage();
            }
          }
        }
      }
    },
    selectedSessionTypeId: function (val) {
      //alert("prevSessionTypeId:" + vm.selectedSessionTypeId);
      //alert("selectedSessionId:" + vm.selectedSessionId);
      //alert("selectedSessionId:" + vm.selectedSessionId);
      //if (val == 0 || val == -1) {
      if (vm.prevSessionTypeId > 0) {
        //alert("vm.prevSessionTypeId:" + vm.prevSessionTypeId);
        if (val == -1) {
          //$("#divSessionEndedContainer").show();
          vm.endPreviousSession();
          //alert("val:" + val);
        } else if (val == 0) {
          if (vm.countdownSeconds > 5) {
            vm.endPreviousSession();
          }
        }
      }
      if (val == 0) {
        $("#hSessionTitle").html("");
      } else if (val == -1) {
        if (vm.isMaximized) {
          if (
            !(vm.StartLiveStageInMaximizedMode && !vm.DisplayMaximizeButton)
          ) {
            vm.resizePlayer();
          }
        }
      }
      vm.showHideSessionTypeIcon(val);
    },
    upcomingSessionTypeId: function (val) {
      vm.showHideSessionTypeIcon(val);
    },
    mySessions: function () {
      //alert(vm.mySessions.length);
      if (vm.mySessions.length > 0) {
        vm.selectedUserAgendaType = 1;
      }
    },
    DisplaySessionTimer: function (val) {
      vm.displayCountdownTimer = val;
    },
    sessionSettingsLoaded: function (val) {
      if (val == true) {
        //alert("watch");
        vm.prepareMySession();
      }
      if (val && vm.sessionsLoaded && vm.mySessionsLoaded) {
        vm.hideLoader();
      }
    },
    sessionsLoaded: function (val) {
      if (val && vm.mySessionsLoaded && vm.sessionSettingsLoaded) {
        vm.hideLoader();
      }
    },
    mySessionsLoaded: function (val) {
      if (val && vm.sessionsLoaded && vm.sessionSettingsLoaded) {
        vm.hideLoader();
      }
    },
    allRoundTablesLoaded: function (val) {
      if (val) {
        vm.hideLoader();
      }
    },
    loadSessionsComplete: function (val) {
      if (val) {
        vm.startSession(vm.exSessionId);
      }
    },
    callStarted(val) {
      if (vm.selectedSessionTypeId != 7) {
        common.enablePlayerMenuToggle(val);
      }
      if (val) {
        vm.collectLeaderboardPoint();
      }
      vm.$emit("onCallStarted", val);
    },
    ShowPlayerRightPanel(val) {
      if (val) {
        $("#divLiveVideoContainer").removeClass("show-volume");
        $("#divLiveStreamContainer").removeClass("show-volume");
      } else {
        $("#divLiveVideoContainer").addClass("show-volume");
        $("#divLiveStreamContainer").addClass("show-volume");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    routeReferer = from.name;
    next(true);
  },
  beforeCreate() {
    //var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //alert(obj.client[0].id);
    //alert(obj.eventid);
    //alert("beforeCreate");

    //alert("beforeCreate" + vm.roomId);
    if (this && !this.roomId) {
      common.toggleTopMenu(false);
      common.toggleLeftMenu(false);
      //$("#topmenu").hide();
      //$("#leftmenu").hide();
    }
    //alert("beforeCreate");
  },
  created() {
    vm = this;
    if (vm.exStageUrl) {
      vm.stageUrl = vm.exStageUrl;
    }
    if (vm && !vm.roomId) {
      common.toggleTopMenu(false);
      common.toggleLeftMenu(false);
      //$("#topmenu").hide();
      //$("#leftmenu").hide();
    }
    vm.loadGeneralSettings();

    //alert(vm.appId)
    $("#app").addClass("player");
    $("body").addClass("player");
    $(":root").css("--header-height", "110px");
    vm.appId = AGORA_APP_ID;
    if (!vm.appId) {
      return alert("Get App ID first!");
    }
    //vm.resizePlayer();
    setTimeout(() => {
      //vm.resizePlayer();
      //if (!vm.newDesign) {
      //  vm.resizePlayer();
      //} else {
      //  vm.AdjustPlayeHeight();
      //}
    }, 10);
    //$("#txtJustFocus").focus();
    //vm.heartBitInterval = 15;

    //window.addEventListener("beforeunload", function (e) {
    //  vm.leaveRoundTable(vm.selectedRoundTableId, vm.uid);
    //  console.log(e);
    //});
    //alert(navigator.userAgent);
    //window.addEventListener("beforeunload", vm.beforeWindowUnload(event));
    //window.addEventListener("beforeunload", (event) => {
    //  console.log(event);
    //  //vm.beforeWindowUnload(event);
    //  vm.leaveRoundTable(vm.selectedRoundTableId, vm.uid);
    //  //event.preventDefault();
    //  //// Chrome requires returnValue to be set.
    //  //event.returnValue = "";
    //});
    //alert("created");
    vm.startInternetConnectionHandler();
    vm.disableRightClick();
    //vm.getSessionSettings();
    //vm.getRTSettings();
    //vm.getO2OMeetingSettings();

    if (location.origin.startsWith("http://localhost")) {
      //vm.heartBitInterval = 600;
      //alert("localhost");
      vm.videoProfile = "480p_1";
      if (vm.rememberSettings) {
        if (Cookies.get("VideoProfile")) {
          vm.videoProfile = Cookies.get("VideoProfile");
        }
      }
      vm.instance = "localhost";
    }
    vm.playerSettings.videoProfile = vm.videoProfile;
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj != undefined && obj != null) {
      vm.timeZone = obj.tzone;
      vm.clientId = obj.client[0].id;
      vm.eventId = obj.eventid;
      if (
        obj.eventcollectionname != undefined &&
        obj.eventcollectionname != null &&
        obj.eventcollectionname != ""
      ) {
        vm.event_collectionName = obj.eventcollectionname;
        vm.uid = obj.user[0].id;
        vm.loadSessionSettings();
        vm.getAllAttendees();
        //$("#btnLoadMenu").click();

        if (!vm.roomId) {
          common.toggleTopMenu(true);
          common.toggleLeftMenu(false);
          //$("#topmenu").show();
          //$("#leftmenu").hide();

          db.collection(obj.eventcollectionname)
            .doc("Menu")
            .get()
            .then((doc) => {
              var data = doc.data();
              $.each(data.AllMenu, function (key, value) {
                if (value.MenuID == 1004) {
                  vm.rtPageUrl = value.PageUrl;
                  //alert(vm.rtPageUrl);
                }
                if (value.MenuID == 1022) {
                  vm.headerText = value.DisplayLabel;
                }
              });
              $.each(data.LeftMenu, function (key, value) {
                if (value.MenuID == 1004) {
                  vm.rtPageUrl = value.PageUrl;
                  //alert(vm.rtPageUrl);
                }
                if (value.MenuID == 1022) {
                  vm.headerText = value.DisplayLabel;
                }
              });
              if (obj.eventname != undefined && obj.eventname != "") {
                document.title = vm.headerText + " - " + obj.eventname;
              }
            });
          if (obj.eventname != undefined && obj.eventname != "") {
            document.title = vm.headerText + " - " + obj.eventname;
          }
        }
        vm.email = obj.user[0].Email;
        vm.firstName = obj.user[0].fname;
        vm.lastName = obj.user[0].lname;
        vm.name = obj.user[0].name;
        vm.company = obj.user[0].company;
        vm.designation = obj.user[0].title;
        vm.phone = obj.user[0].phone;
        vm.profilePictureURL = vm.getCDNUrl(obj.user[0].profilepic);
        vm.readExParams();
        //alert(vm.exPageId);
        if (!vm.exPageId && vm.roomId) {
          vm.selectedSessionTypeId = 100;
          vm.exPageId = "chat";
        }
        if (
          vm.exPageId != "o2o" &&
          vm.exPageId != "e2o" &&
          vm.exPageId != "chat"
        ) {
          vm.LoadRoundTableSettings();
        }
        vm.initLiveStage();
        //this.uid = Math.random().toString().substring(3, 4); //this.getUrlParameter("uid");
        //var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj != undefined && obj != null) {
          //this.uid = obj.user[0].id;
          Cookies.set("id", this.uid);
          Cookies.set("channel", "channel");
          Cookies.set("baseMode", "avc");
          Cookies.set("transcode", "interop");
          //Cookies.set("videoProfile", "480p_1");
        }
        //Cookies.set("id", "1");
        //Cookies.set("channel", this.channel);
        //Cookies.set("baseMode", this.baseMode);
        //Cookies.set("transcode", this.transcode);
        //Cookies.set("videoProfile", this.videoProfile);
      }
    }
    vm.userIP = "";
  },
  mounted() {
     var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    // alert("isIOS: " + vm.$browserDetect.isIOS);
    // alert("isChromeIOS: " + vm.$browserDetect.isChromeIOS);
    if (document.addEventListener) {
      document.addEventListener(
        "fullscreenchange",
        vm.exitFullScreenHandler,
        false
      );
      document.addEventListener(
        "mozfullscreenchange",
        vm.exitFullScreenHandler,
        false
      );
      document.addEventListener(
        "MSFullscreenChange",
        vm.exitFullScreenHandler,
        false
      );
      document.addEventListener(
        "webkitfullscreenchange",
        vm.exitFullScreenHandler,
        false
      );
    }
    if (screen.width >= 768 && screen.width <= 1024) {
      //vm.ipadScreen = true;
      common.checkAppDownloadScreenByDevice("ipad");
    } else if (screen.width < 767) {
      common.checkAppDownloadScreenByDevice("mobile");
    }
    //setTimeout(() => {
    //  vm.createPresence(
    //    "/OA_UAT_C1594146761016E1609999528809/SessionList/Sessions/4420000/Participances/221000",
    //    true
    //  );
    //}, 2000);
    //setTimeout(() => {
    //  vm.createPresence(
    //    "/OA_UAT_C1594146761016E1609999528809/SessionList/Sessions/4420000/Participances/221000",
    //    false
    //  );
    //}, 10000);
    //var constraints = (window.constraints = {
    //  audio: true,
    //  video: true,
    //});
    //navigator.mediaDevices
    //  .getUserMedia(constraints)
    //  .then(function (stream) {
    //    var videoTracks = stream.getVideoTracks();
    //    console.log("Got stream with constraints:", constraints);
    //    console.log("Using video device: " + videoTracks[0].label);
    //    stream.onremovetrack = function () {
    //      console.log("Stream ended");
    //    };
    //    window.stream = stream; // make variable available to browser console
    //    //video.srcObject = stream;
    //  })
    //  .catch(function (error) {
    //    if (error.name === "ConstraintNotSatisfiedError") {
    //      //errorMsg('The resolution ' + constraints.video.width.exact + 'x' +
    //      //constraints.video.height.exact + ' px is not supported by your device.');
    //    } else if (error.name === "PermissionDeniedError") {
    //      //errorMsg('Permissions have not been granted to use your camera and ' +
    //      //    'microphone, you need to allow the page access to your devices in ' +
    //      //    'order for the demo to work.');
    //    }
    //    //errorMsg('getUserMedia error: ' + error.name, error);
    //  });
    //let MediaDeviceInfo = navigator.mediaDevices.enumerateDevices;
    //let aaa = MediaDeviceInfo.map((device) => device.label);
    //setTimeout(() => {
    //  alert(aaa);
    //}, 10000);
    //return navigator.mediaDevices && navigator.mediaDevices.enumerateDevices;
    //navigator.getUserMedia =
    //  navigator.getUserMedia ||
    //  navigator.webkitGetUserMedia ||
    //  navigator.mozGetUserMedia;
    //// Start video camera
    //navigator.getUserMedia(
    //  {
    //    video: true,
    //    audio: true,
    //  },
    //  function (stream) {
    //    document.getElementById("videotag").srcObject = stream;
    //  },
    //  function (error) {
    //    console.error(error);
    //  }
    //);
    $("#btnAddUserView").click();
    //window.Tawk_API.hideWidget();
    //setTimeout(() => {
    //  vm.showNotification(
    //    "Please don't go anywhere.<br />You'll be joining your virtual table shortly."
    //  );
    //}, 5000);
    //if (vm.StartLiveStageInMaximizedMode) {
    //  setTimeout(() => {
    //    vm.resizePlayer();
    //  }, 50);
    //}
    //window.addEventListener("beforeunload", function (e) {
    //  console.log(e);
    //  console.log("beforeunload");
    //});
    //window.onbeforeunload(function () {
    //  alert("window.onbeforeunload (function(){");
    //});
    //chat.test();
    //alert("mounted");
    //vm.sid = "1333000"; //this.$route.params.id;
    //this.startVideoPlayer();
    // window.Tawk_API.onLoad = function () {
    //   window.Tawk_API.hideWidget();
    // };
    //vm.fetchScript();
  },
  beforeUpdate() {
    //alert("beforeUpdate");
    //vm.countdownSeconds = 12;
  },

  updated() {
    var elmnt = document.getElementById("topmenu");
    if (elmnt) {
      //alert("imgBanner:" + elmnt.clientHeight);
      var numericH = elmnt.clientHeight.toString().replace("px", "").trim();
      $(":root").css("--header-height", parseInt(numericH) + "px");
      //$(":root").css("--header-height", "0px");
    } else {
      //alert("imgBanner not exists");
      $(":root").css("--header-height", "0px");
    }
  },

  beforeDestroy() {
    //alert("beforeDestroy");
    common.enablePlayerMenuToggle(false);
    vm.rightPanel.leaveRTMChannel();
    if (
      vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID &&
      vm.selectedRoundTableId != ""
    ) {
      if (vm.selectedRoundTableId != "") {
        vm.leaveRoundTable(vm.selectedRoundTableId, vm.uid);
      }
    } else {
      if (vm.selectedSessionId != "") {
        vm.leaveSession(vm.selectedSessionId, vm.uid);
      }
    }
    //vm.roundTableListeners.forEach(function (item) {
    //  if (item) {
    //    item();
    //  }
    //});
    vm.roundTableList.forEach(function (rt) {
      if (rt.Listener) {
        rt.Listener();
      }
    });

    if (networkTimer) {
      clearInterval(networkTimer);
    }
    if (sessionSwitchTimer) {
      clearInterval(sessionSwitchTimer);
    }
    if (currentSessionTimer) {
      clearInterval(currentSessionTimer);
    }
    if (scheduleSessionTimer) {
      clearInterval(scheduleSessionTimer);
    }
    if (scheduleRTTimer) {
      clearInterval(scheduleRTTimer);
    }
    if (rtAutoJoinTimer) {
      clearInterval(rtAutoJoinTimer);
    }
    if (joinHereTimer) {
      clearInterval(joinHereTimer);
    }
    if (retryPlayStreamTimer) {
      clearInterval(retryPlayStreamTimer);
    }
    if (currentSessionListener) {
      currentSessionListener();
    }
    if (currentSessionParticipancesListener) {
      currentSessionParticipancesListener();
    }
    if (currentRTListener) {
      currentRTListener();
    }
    if (ZoomRTMPParticipantsListener) {
      ZoomRTMPParticipantsListener();
      ZoomRTMPParticipantsListener = null;
    }

    if (realtimeDB) {
      if (realtimeDB.ConnectRef) {
        realtimeDB.ConnectRef();
        realtimeDB.ConnectRef = undefined;
      }
      if (realtimeDB.DisconnectRef) {
        realtimeDB.DisconnectRef();
        realtimeDB.DisconnectRef = undefined;
      }
      realtimeDB();
      realtimeDB = undefined;
    }

    $("#app").removeClass("player-full-screen");
    common.toggleTopMenu(true);
    common.toggleLeftMenu(true);
    if ($("#topmenu")) {
      $("#topmenu").removeClass("d-none");
    }
    if ($("#leftMenuParent")) {
      $("#leftMenuParent").removeClass("d-none");
    }
  },
  //beforeRouteLeave: function (to, from, next) {
  //  // Indicate to the SubComponent that we are leaving the route
  //  vm.prepareToExit();
  //  // Make sure to always call the next function, otherwise the hook will never be resolved
  //  // Ref: https://router.vuejs.org/en/advanced/navigation-guards.html
  //  next();
  //},
  methods: {
    getHeight() {
      return common.getHeaderHeight(vm.roomId != "");
    },
    currentPlayerLogo() {
      let logo = vm.LiveStageLogo;
      if (vm.selectedSessionTypeId <= 0) {
        if (vm.SessionSettingsLogo != "") {
          logo = vm.SessionSettingsLogo;
        }
      } else {
        if ([1, 2, 3, 5].includes(vm.selectedSessionTypeId)) {
          if (vm.SessionLogo != "") {
            logo = vm.SessionLogo;
          } else if (vm.SessionSettingsLogo != "") {
            logo = vm.SessionSettingsLogo;
          }
        } else if (vm.selectedSessionTypeId == 4) {
          if (vm.RoundTableLogo != "") {
            logo = vm.RoundTableLogo;
          } else if (vm.SessionLogo != "") {
            logo = vm.SessionLogo;
          } else if (vm.SessionSettingsLogo != "") {
            logo = vm.SessionSettingsLogo;
          }
        } else if (vm.selectedSessionTypeId == 7) {
          // Exhibitor Logo
        }
      }
      return logo;
    },
    currentPlayerLogoLink() {
      let link = vm.LiveStageLogoLink;
      if ([1, 2, 3, 5].includes(vm.selectedSessionTypeId)) {
        if (vm.SessionSettingsLogoLink != "") {
          link = vm.SessionSettingsLogoLink;
        }
      } else if (
        vm.selectedSessionTypeId == 4 &&
        (vm.exPageId == "" || vm.exPageId == "sn" || vm.exPageId == "rt")
      ) {
        if (vm.RoundTableSettingsLogoLink != "") {
          link = vm.RoundTableSettingsLogoLink;
        } else if (vm.SessionSettingsLogoLink != "") {
          link = vm.SessionSettingsLogoLink;
        }
      }
      return link;
    },
    showHideSessionTypeIcon(sessionType) {
      $(".imgSessionTypeIcon").addClass("d-none");
      if (sessionType == 1) {
        $("#imgOnDemandSessionTypeIcon").removeClass("d-none");
      } else if (sessionType == 2) {
        $("#imgLiveStreamSessionTypeIcon").removeClass("d-none");
      } else if (sessionType == 3) {
        $("#imgLivePanelSessionTypeIcon").removeClass("d-none");
      } else if (sessionType == 4) {
        $("#imgRoundTableSessionTypeIcon").removeClass("d-none");
      } else if (sessionType == 5) {
        $("#imgInPersonSessionTypeIcon").removeClass("d-none");
      }
    },
    showLoader: function () {
      //alert("showLoader");
      if ($("#divLoading")) {
        $("#divLoading").show();
      }
      vm.displayLoading = true;
    },
    hideLoader: function () {
      ////alert("hideLoader");
      ////if (timerLoader != null) {
      ////clearTimeout(this.timerLoader);
      //// alert("outside");
      if ($("#divLoading")) {
        //alert("inside");
        $("#divLoading").hide();
      }
      ////}
      vm.displayLoading = false;
    },
    applyAgendaType() {
      vm.userAgendaFilterPending = false;
      vm.showAgendaFileterPopup = false;
    },
    selectFilterType(filterType) {
      vm.selectedUserAgendaType = filterType;
      vm.userAgendaFilterPending = false;
      vm.showAgendaFileterPopup = false;
    },
    onCancelPageLeave() {
      $("#popupPageLeaveConfirm").modal("hide");
    },
    onPageLeave() {
      vm.IsManuallyStopped = true;
      $("#popupPageLeaveConfirm").modal("hide");
      //alert(vm.selectedSessionTypeId);
      if (vm.selectedSessionTypeId == 1) {
        vm.stopVideoPlayer();
      } else if (vm.selectedSessionTypeId == 2) {
        vm.stopLiveStream();
      }
      setTimeout(() => {
        //alert(vm.selectedSessionId);
        //alert(vm.stageUrl);
        //vm.initLiveStage();
        vm.exPageId = "";
        vm.exSessionId = "";
        router.push(vm.stageUrl);
        vm.exSessionId = "";
        vm.initLiveStage();
      }, 100);

      //vm.allowLeavePage = true;
      //router.push(vm.redirectToPath);
    },
    prepareToExit: function () {
      console.log(
        "Preparing to exit sub component, stopping 'twoSecondsTimerEvents'"
      );
      //clearInterval(this.twoSecondsTimerEvents)
    },
    //readUserIP() {
    //  let apiUrl="";//TAKE IT FROM CONFIG
    //  $.ajax({
    //    url: apiUrl,
    //    headers: {
    //      "Content-Type": "application/json",
    //    },
    //    type: "POST",
    //    mode: "cors",
    //    credentials: "include",
    //    crossDomain: true,
    //    dataType: "json",
    //    processData: false,
    //    data: JSON.stringify(StarRecPostData),
    //    success: function (data) {
    //      //alert(data);
    //      //alert("Recording Started 1");
    //      let lStatusCode = -1;
    //      if (typeof data != "undefined") {
    //        //alert("Recording Started 2");
    //        lStatusCode = data.status;
    //        //alert("Start rec data.status: "+data.status);
    //      }
    //      if (lStatusCode == 0) {
    //        //alert("Recording Started 3");
    //        if (typeof data.result.resourceId != "undefined") {
    //          vm.RecResourceId = data.result.resourceId;
    //          //alert("data.result.resourceId:" + data.result.resourceId);
    //        }
    //        if (typeof data.result.sid != "undefined") {
    //          vm.RecSid = data.result.sid;
    //          //alert("data.result.sid:" + data.result.sid);
    //        }
    //        vm.recordingStarted = true;
    //        vm.setRecordingParamToFirebase(1);
    //      }
    //    },
    //    error: function (e) {
    //      console.log(e);
    //    },
    //  });
    //},

    getAllAttendees() {
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let rqstData = {};
      rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },

        data: {
          search: [],
          filter: [],
          sort: { sortBy: "FirstName", sortOrder: "asc" },
          pagination: {
            Page: 1,
            PageSize: 2000,
          },
          origin: "COMPACT",
        },
      };
      axios
        .post(APIs.AttendeeSearch, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          vm.allAttendees = {};
          responseData.data.result.map((attendee) => {
            if (attendee.AttendeeId && attendee.Name) {
              vm.allAttendees[attendee.AttendeeId] = {
                FirstName: attendee.FirstName.trim(),
                Name: attendee.Name.trim(),
                AttendeeId: attendee.AttendeeId,
                ProfilePictureURL: vm.getCDNUrl(attendee.ProfilePictureURL),
                Company: attendee.Company,
                Designation: attendee.Designation,
              };
            }
          });
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    readExParams() {
      //alert("readExParams");
      let id = vm.$route.params.id;
      let tid = vm.$route.params.tid;
      if (id) {
        vm.exParams = id;
        //alert(this.exParams)
        //this.playingFromExternalPage=true;

        // exPageId:"",//"":livestage, "sn":session, "rt":roundtable, "o2o":one to one meeting, "e2o", exhibitor meeting

        if (vm.exParams.endsWith("_rt")) {
          vm.exPageId = "rt";
          vm.exRoundTableId = vm.exParams.replace("_rt", "");
          vm.redirectToPath = "/roundtable";
        } else if (vm.exParams.endsWith("_exrt")) {
          vm.exPageId = "rt";
          vm.exExhibitorRT = true;
          vm.exRoundTableId = vm.exParams.replace("_exrt", "");
          vm.redirectToPath = "/exhibitorsview";
          //alert(vm.$store.getters.getSelExhibitor);
          if (vm.$store.getters.getSelExhibitor) {
            if (routeReferer == "RoundtableList") {
              vm.redirectToPath =
                "/roundtable/" +
                vm.$store.getters.getSelExhibitor +
                "/exhibitor";
            }
          }
          //alert(vm.redirectToPath);
        } else if (vm.exParams.endsWith("_sprt")) {
          vm.exPageId = "rt";
          vm.exSponsorRT = true;
          vm.exRoundTableId = vm.exParams.replace("_sprt", "");
          vm.redirectToPath = "/SponsorsDetailsNew";
        } else if (vm.exParams.endsWith("_o2o")) {
          vm.selectedSessionTypeId = 6;
          vm.exPageId = "o2o";
          vm.exMeetingId = vm.exParams.replace("_o2o", "");
          vm.exAttendee1Id = "";
          vm.exAttendee2Id = "";
          vm.redirectToPath = "/mymeetings";
        } else if (vm.exParams.endsWith("_e2o")) {
          vm.selectedSessionTypeId = 7;
          vm.exPageId = "e2o";
          vm.exExhibitorId = "";
          vm.exAttendee1Id = "";
          vm.exAttendee2Id = "";
          //133000-221000_e2o
          let pArray = vm.exParams.split("_");
          if (pArray.length > 0) {
            let pIDArray = pArray[0].split("-");
            if (pIDArray.length > 0) {
              vm.exExhibitorId = pIDArray[0];
            }
            if (pIDArray.length > 1) {
              vm.exAttendee1Id = pIDArray[1];
            }
            if (vm.exExhibitorId != "" && vm.exAttendee1Id != "") {
              vm.exMeetingId =
                vm.exExhibitorId + "-" + vm.exAttendee1Id + "_e2o";
              //alert("exMeetingId:" + vm.exMeetingId);
            }
          }
          if (vm.exAttendee1Id == vm.uid) {
            vm.isE2OMeetingRep = true;
          } else {
            vm.exAttendee2Id = vm.uid;
          }
          vm.redirectToPath = "/exhibitorsview";
          //alert(vm.redirectToPath);
        } else if (vm.exParams.endsWith("_chat")) {
          vm.selectedSessionTypeId = 100;
          vm.exPageId = "chat";
          vm.roomId = vm.exParams.replace("_chat", "");
        } else {
          vm.exSessionId = vm.exParams.replace("_sn", "");
          vm.exSessionId = vm.exSessionId.replace("#", "");
          vm.autoJoinSession = true;
          vm.exPageId = "sn";
          if (tid) {
            vm.exRoundTableId = tid;
            vm.redirectToPath = "/roundtable";
          } else {
            // alert("exPageId:"+vm.exPageId)
            // alert("exSessionId:"+vm.exSessionId)
            vm.redirectToPath = "/sessions";
          }
        }
      }
    },
    onHideNotification() {
      vm.hideNotificationClicked = true;
      vm.hideNotification();
    },
    hideNotification() {
      vm.displayNotification = false;
    },
    showNotification(text) {
      vm.displayNotification = true;
      vm.notificationText = text;
    },
    onHideContinueNotification(val) {
      vm.hideContinueNotificationClicked = true;
      vm.hideContinueNotification(val);
    },
    hideContinueNotification(val) {
      if (val) {
        vm.endPreviousSession();
        setTimeout(() => {
          vm.goToNextSession = val;
          vm.displayContinueNotification = false;
        }, 2000);
      } else {
        vm.goToNextSession = val;
        vm.displayContinueNotification = false;
      }
    },
    showContinueNotification() {
      vm.displayContinueNotification = true;
    },
    endPreviousSession() {
      if (vm.prevSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
        vm.stopVideoPlayer();
      } else if (vm.prevSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID) {
        vm.stopLiveStream();
      } else if (vm.prevSessionTypeId == vm.GlobalKeysData.LivePanelTypeID) {
        vm.stopLivePlayer();
      } else if (vm.prevSessionTypeId == vm.GlobalKeysData.RoundTableTypeID) {
        vm.stopRoundTable();
      }
    },
    confirmLeave() {
      return window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
    },

    beforeWindowUnload(e) {
      console.log(e);
      //alert("beforeWindowUnload");
      //if (vm.confirmLeave()) {
      // Cancel the event
      vm.leaveRoundTable(vm.selectedRoundTableId, vm.uid);
      //e.preventDefault();
      //// Chrome requires returnValue to be set
      //e.returnValue = "";
      //}
    },
    disableRightClick() {
      //let canvas = document.querySelector("#divLiveStreamContainer");
      //if (canvas) {
      //  canvas.addEventListener("contextmenu", (event) =>
      //    event.preventDefault()
      //  );
      //}
    },
    stageClicked() {
      vm.rightPanel.collapse();
      vm.livePlayer.hidePopup();
      $(".on-demand-dropdown").addClass("d-none");
    },
    openRightPanel(tab) {
      if (vm.selectedSessionId > 0) {
        vm.rightPanel.openRightPanel(tab);
      }
    },
    onTimesUp() {
      //alert(vm.ShowJoinButton);
      //if (vm.ShowJoinButton) {
      //  setTimeout(() => {
      //    vm.onUpcommingEnd();
      //  }, 1000);
      //  if (vm.upcomingSessionTypeId == vm.GlobalKeysData.InPersonTypeID) {
      //    vm.startInPersonSession(0);
      //  } else {
      //    if (vm.upcomingSessionCount == 1) {
      //      $("#divCountdownContainer").hide();
      //      vm.startSession(vm.upcomingSessionId);
      //    }
      //    //if (vm.currentSessions.length == 1) {
      //    ////  //$("#divCountdownContainer").show();
      //    ////  $("#liProceedManuallyWrap").show();
      //    //}
      //    else {
      //    vm.initLiveStage();
      //      //$("#divCountdownContainer").hide();
      //      //$("#divSessionsContainer").show();
      //    }
      //  }
      //} else {
      //alert(vm.upcomingSessionCount);
      //if (vm.upcomingSessionCount == 1) {
      if (vm.currentSessions.length == 1) {
        setTimeout(() => {
          vm.onUpcommingEnd();
        }, 1000);
        //vm.startInPersonSession(0);
        if (vm.upcomingSessionTypeId != vm.GlobalKeysData.InPersonTypeID) {
          $("#divCountdownContainer").hide();
          if (
            vm.upcomingSession &&
            vm.IsZoomRTMPOptionsEnabled &&
            vm.upcomingSession.IsZoomRTMP &&
            (vm.upcomingSession.IsHost || vm.upcomingSession.IsSpeaker)
          ) {
            $("#divSessionsContainer").show();
          } else {
            vm.startSession(vm.upcomingSessionId);
          }
        }
      } else {
        vm.initLiveStage();
      }
      //setTimeout(() => {
      //  if (vm.currentSessions.length > 1) {
      //    $("#divCountdownContainer").hide();
      //    $("#divSessionsContainer").show();
      //  } else {
      //    $("#liProceedManuallyWrap").show();
      //  }
      //}, 1000);
      //}
    },
    formattedTimeLeft(timeLeft) {
      let seconds = timeLeft % 60;
      timeLeft = parseInt(timeLeft / 60);
      let minutes = timeLeft % 60;
      timeLeft = parseInt(timeLeft / 60);
      let hours = timeLeft;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (hours < 10) {
        hours = `0${hours}`;
      }
      return `${hours}:${minutes}:${seconds}`;
    },
    startInternetConnectionHandler() {
      if (networkTimer) {
        clearInterval(networkTimer);
      }
      networkTimer = setInterval(function () {
        //alert("aaaa: " + vm.baseTimer.remainingTime());
        var sessionTimeLeft = 0;
        if (vm.upcomingSession) {
          var currentTime = parseInt(new Date().getTime() / 1000);
          sessionTimeLeft = vm.upcomingSession.StartTimeS - currentTime;
        }
        if (sessionTimeLeft > 0) {
          var countdownTimeLeft = vm.baseTimer.remainingTime();
          // $("#cTime").html(vm.formattedTimeLeft(countdownTimeLeft));
          // $("#sTime").html(vm.formattedTimeLeft(sessionTimeLeft) + vm.callStarted);
          if (sessionTimeLeft > 0 && countdownTimeLeft - sessionTimeLeft > 1) {
            //alert("Reset timer")
            //location.reload();
            vm.countdownSeconds = sessionTimeLeft;
            vm.baseTimer.createTimer(vm.countdownSeconds);
          }
        } else if (vm.baseTimer.remainingTime() > 0) {
          vm.baseTimer.createTimer(0);
        }
        var ifConnected = window.navigator.onLine;
        //vm.downLink = window.navigator.connection.downlink;

        //alert(vm.downLink);
        //alert(
        //  "onLine:" +
        //    window.navigator.onLine +
        //    "\nrtt:" +
        //    window.navigator.connection.rtt +
        //    "\ndownlink:" +
        //    window.navigator.connection.downlink
        //);
        //vm.debugHtml +=
        //  "<br>onLine:" +
        //  window.navigator.onLine +
        //  "<br>rtt:" +
        //  window.navigator.connection.rtt +
        //  "<br>downlink:" +
        //  window.navigator.connection.downlink;
        //if (vm.debugMode) {
        //vm.debugHtml += "<br>Speaker Count: " + vm.speakerCount;
        ////}
        //$.ajax({
        //  url: vm.APIs.ServerTimeApi,
        //  headers: {
        //    apikey: "ws2000rb28082019",
        //  },
        //  type: "GET",
        //  crossDomain: true,
        //  success: function (data) {
        //    console.log(data);
        //    alert("SUCCESS");
        //    vm.hasConnection = true;
        //  },
        //  error: function (err) {
        //    console.log(err);
        //    alert(err);
        //  },
        //});

        //headers: {
        //  apikey: "ws2000rb28082019",
        //},
        if (ifConnected) {
          if (!vm.hasConnection) {
            //document.location.reload();
            //https://us-central1-e2monair.cloudfunctions.net/app/api/getservertime/
            axios
              .get(APIs.ServerTimeApi)
              .then((responseData) => {
                console.log(responseData);
                vm.hasConnection = true;
                //alert("HAS CONNECTION");
              })
              .catch(function (err) {
                console.log("getservertime:" + err);
              });
            //$.ajax({
            //  url: APIs.ServerTimeApi,
            //  type: "GET",
            //  crossDomain: true,
            //  success: function () {
            //    //console.log(data);
            //    //alert("SUCCESS");
            //    vm.hasConnection = true;
            //  },
            //  error: function (err) {
            //    console.log(err);
            //    //alert(err);
            //  },
            //});
            //console.log("Connection is back.");
            //$(".live-area").removeClass("internet-off");
            //$("#internetDisconnect").hide();
            //$("#coverSlide").hide();
            //$("#coverSlideText").text("");
          } else {
            //console.log('Connection is on.');
            //var nx = 0;
          }
          $("#appOffline").hide();
        } else {
          vm.hasConnection = false;
          $("#appOffline").show();
          //$(".live-area").addClass("internet-off");
          //console.log("Connection is lost.");
          //$("#internetDisconnect").show();
          //$("#coverSlideText").text("No internet connection");
          //$("#coverSlide").show();
        }
      }, 1000);
    },
    volumeChanged(volumeLevel) {
      //vm.player.currentTime(0);
      //vm.player.removeTechControlsListeners_();
      //alert(volumeLevel);
      vm.volumeLevel = volumeLevel;
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
        vm.videoPlayer.volume(volumeLevel / 100);
      } else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID ||
        (vm.selectedSessionTypeId == vm.GlobalKeysData.LivePanelTypeID &&
          vm.selectedSession.IsZoomRTMP)
      ) {
        vm.streamPlayer.volume(volumeLevel / 100);
      } else {
        vm.livePlayer.changePlayerVolume(volumeLevel);
      }
    },
    updateRightPanelSettings(event) {
      //alert(event.key + ":" + event.value);
      //alert(
      //  event.sessionTypeId + ":" + event.sessionId + ":" + event.roundTableId
      //);
      let colId = "";
      let docId = "";
      if (
        event.sessionTypeId == 1 ||
        event.sessionTypeId == 2 ||
        event.sessionTypeId == 3 ||
        event.sessionTypeId == 5
      ) {
        colId = "Session";
        docId = event.sessionId;
      } else if (event.sessionTypeId == 4) {
        colId = "RoundTable";
        docId = event.roundTableId;
      } else if (event.sessionTypeId == 6) {
        colId = "OneToOneMeeting";
        docId = event.meetingId;
      } else if (event.sessionTypeId == 7) {
        colId = "ExhibitorMeeting";
        docId = event.meetingId;
      }
      //if (event.sessionTypeId == 3 || event.sessionTypeId == 4) {
      let broadcastSettings = {
        AttendeeEnabled: false,
        QnAEnabled: false,
        ChatEnabled: false,
        RaiseHandEnabled: false,
        SpeakerInfoEnabled: false,
        SessionListEnabled: false,
      };
      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection(colId)
        .doc(docId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            broadcastSettings.SessionListEnabled = data.SessionListEnabled
              ? data.SessionListEnabled
              : false;
            broadcastSettings.SpeakerInfoEnabled = data.SpeakerInfoEnabled
              ? data.SpeakerInfoEnabled
              : false;
            broadcastSettings.AttendeeEnabled = data.AttendeeEnabled
              ? data.AttendeeEnabled
              : false;
            broadcastSettings.QnAEnabled = data.QnAEnabled
              ? data.QnAEnabled
              : false;
            broadcastSettings.ChatEnabled = data.ChatEnabled
              ? data.ChatEnabled
              : false;
            broadcastSettings.RaiseHandEnabled = data.RaiseHandEnabled
              ? data.RaiseHandEnabled
              : false;
            broadcastSettings[event.key] = event.value;
            db.collection(vm.event_collectionName)
              .doc("UserVideoActivity")
              .collection(colId)
              .doc(docId)
              .update(broadcastSettings);

            vm.showViewersCount = broadcastSettings.AttendeeEnabled;
          }
          //else {
          //              vm.livePlayer.applyBroadcastSettings(broadcastSettings);
          //              db.collection(vm.event_collectionName)
          //                .doc("UserVideoActivity")
          //                .collection(colId)
          //                .doc(docId)
          //                .set(broadcastSettings);
          //            }
        })
        .catch(function (error) {
          console.log(error);
        });
      //}
    },
    applyAudioVideoSettings(event) {
      vm.livePlayer.applyAudioVideoSettings(event);
    },
    getPlayerSettings() {
      vm.livePlayer.getPlayerSettings();
    },
    AttendeeEnabled(val) {
      vm.showViewersCount = val;
      vm.livePlayer.AttendeeEnabled(val);
      vm.DisplayViewersCount(val);
    },
    DisplayViewersCount(val) {
      if (!val) {
        val = vm.showViewersCount;
      }
      if (val && !vm.DisplayAudienceCounter) {
        val = false;
      }
      if (
        vm.selectedSession &&
        vm.selectedSession.IsHost &&
        vm.selectedSession.IsSpeaker
      ) {
        val = true;
      }
      if (val) {
        if ($("#divLiveVideoContainer") && vm.selectedSessionTypeId == 1) {
          $("#divLiveVideoContainer").removeClass("hide-viewers-count");
        } else if (
          $("#divLiveStreamContainer") &&
          (vm.selectedSessionTypeId == 2 || vm.selectedSessionTypeId == 3)
        ) {
          $("#divLiveStreamContainer").removeClass("hide-viewers-count");
        }
      } else {
        if ($("#divLiveVideoContainer") && vm.selectedSessionTypeId == 1) {
          $("#divLiveVideoContainer").addClass("hide-viewers-count");
        } else if (
          $("#divLiveStreamContainer") &&
          (vm.selectedSessionTypeId == 2 || vm.selectedSessionTypeId == 3)
        ) {
          $("#divLiveStreamContainer").addClass("hide-viewers-count");
        }
      }
    },
    setPlayerSettings(playerSettings) {
      vm.playerSettings = playerSettings;
    },
    requestAllSpeakersToMute(e) {
      let requestType = e.type;
      let forceMute = e.forceMute;
      var participancesCollectionName = "";
      var collection = "";
      var docId = "";
      if ([1, 2, 3].includes(vm.selectedSessionTypeId)) {
        participancesCollectionName =
          "/" +
          vm.event_collectionName +
          "/SessionList/Sessions/" +
          vm.selectedSessionId;
        collection = "SessionList/Sessions";
        docId = vm.selectedSessionId;
      } else if (vm.selectedSessionTypeId == 4) {
        participancesCollectionName =
          "/" +
          vm.event_collectionName +
          "/RoundTableList/RoundTables/" +
          vm.selectedRoundTableId;
        collection = "RoundTableList/RoundTables";
        docId = vm.selectedRoundTableId;
      } else {
        participancesCollectionName =
          "/" + vm.event_collectionName + "/UserVideoActivity";
        if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
          participancesCollectionName += "/OneToOneMeeting";
          collection = "UserVideoActivity/OneToOneMeeting";
        } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
          participancesCollectionName += "/ExhibitorMeeting";
          collection = "UserVideoActivity/ExhibitorMeeting";
        }
        participancesCollectionName += "/" + vm.exMeetingId;
        docId = vm.exMeetingId;
      }
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      if (participancesCollectionName != "") {
        if (requestType == 0) {
          let requestData = {
            collection: collection,
            instance: vm.event_collectionName,
            data: {
              MuteRequest: new Date().getTime(),
              ForceMute: forceMute,
              RequestedBy: vm.uid,
              id: docId,
            },
          };
          axios
            .put(APIs.WriteObject, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //alert("Mute all");
              console.log(responseData);
            })
            .catch(function (error) {
              console.error("Error on mute all: ", error);
            });
        } else {
          let requestData = {
            collection: collection,
            instance: vm.event_collectionName,
            data: {
              UnmuteRequest: new Date().getTime(),
              RequestedBy: vm.uid,
              id: docId,
            },
          };
          axios
            .put(APIs.WriteObject, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //alert("Unmute all");
              console.log(responseData);
            })
            .catch(function (error) {
              console.error("Error on unmute all: ", error);
            });
        }
      }
    },
    requestSpeakerToMute(e) {
      //alert(uid);
      let uid = e.uid;
      let requestType = e.type;
      let forceMute = e.forceMute;
      var collection = "";
      console.log(uid);
      var participancesCollectionName = "";
      if ([1, 2, 3].includes(vm.selectedSessionTypeId)) {
        participancesCollectionName =
          "/" +
          vm.event_collectionName +
          "/SessionList/Sessions/" +
          vm.selectedSessionId +
          "/Participances/" +
          uid;
        collection =
          "SessionList/Sessions/" + vm.selectedSessionId + "/Participances";
      } else if (vm.selectedSessionTypeId == 4) {
        participancesCollectionName =
          "/" +
          vm.event_collectionName +
          "/RoundTableList/RoundTables/" +
          vm.selectedRoundTableId +
          "/Participances/" +
          uid;
        collection =
          "RoundTableList/RoundTables/" +
          vm.selectedRoundTableId +
          "/Participances";
      } else {
        participancesCollectionName =
          "/" + vm.event_collectionName + "/UserVideoActivity";
        if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
          participancesCollectionName += "/OneToOneMeeting";
          collection =
            "UserVideoActivity/OneToOneMeeting/" +
            vm.exMeetingId +
            "/Participances";
        } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
          participancesCollectionName += "/ExhibitorMeeting";
          collection =
            "UserVideoActivity/OneToOneMeeting/" +
            vm.exMeetingId +
            "/Participances";
        }
        participancesCollectionName +=
          "/" + vm.exMeetingId + "/Participances/" + uid;
      }
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      if (participancesCollectionName != "") {
        if (requestType == 0) {
          let requestData = {
            collection: collection,
            instance: vm.event_collectionName,
            data: {
              MuteRequest: new Date().getTime(),
              ForceMute: forceMute,
              RequestedBy: vm.uid,
              id: uid,
            },
          };
          axios
            .put(APIs.WriteObject, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //alert("Mute");
              console.log(responseData);
            })
            .catch(function (error) {
              console.error("Error on mute: ", error);
            });
        } else {
          let requestData = {
            collection: collection,
            instance: vm.event_collectionName,
            data: {
              UnmuteRequest: new Date().getTime(),
              RequestedBy: vm.uid,
              id: uid,
            },
          };
          axios
            .put(APIs.WriteObject, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //alert("Unmute");
              console.log(responseData);
            })
            .catch(function (error) {
              console.error("Error on unmute: ", error);
            });
        }

        //db.doc(participancesCollectionName)
        //  .get()
        //  .then((doc) => {
        //    if (doc.exists) {
        //      //alert("Exists");
        //      if (requestType == 0) {
        //        db.doc(participancesCollectionName)
        //          .update({
        //            MuteRequest: new Date().getTime(),
        //            ForceMute: forceMute,
        //            RequestedBy: vm.uid,
        //          })
        //          .then(function () {
        //            //alert("Muted");
        //          })
        //          .catch(function (error) {
        //            console.log("Error on mute: " + error);
        //          });
        //      } else {
        //        db.doc(participancesCollectionName)
        //          .update({
        //            UnmuteRequest: new Date().getTime(),
        //            RequestedBy: vm.uid,
        //          })
        //          .then(function () {
        //            //alert("Unmute");
        //          })
        //          .catch(function (error) {
        //            console.log("Error on unmute: " + error);
        //          });
        //      }
        //    }
        //  })
        //  .catch(function (error) {
        //    console.error("Error getting participance: ", error);
        //  });
      }
    },
    requestSpotlight(e) {
      let uid = e.uid;
      let requestType = e.type;
      var participancesCollectionName = "";
      var collection = "";
      var docId = "";
      if ([1, 2, 3].includes(vm.selectedSessionTypeId)) {
        participancesCollectionName =
          "/" +
          vm.event_collectionName +
          "/SessionList/Sessions/" +
          vm.selectedSessionId;
        collection = "SessionList/Sessions";
        docId = vm.selectedSessionId;
      } else if (vm.selectedSessionTypeId == 4) {
        participancesCollectionName =
          "/" +
          vm.event_collectionName +
          "/RoundTableList/RoundTables/" +
          vm.selectedRoundTableId;
        collection = "RoundTableList/RoundTables";
        docId = vm.selectedRoundTableId;
      } else {
        participancesCollectionName =
          "/" + vm.event_collectionName + "/UserVideoActivity";
        if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
          participancesCollectionName += "/OneToOneMeeting";
          collection = "UserVideoActivity/OneToOneMeeting";
        } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
          participancesCollectionName += "/ExhibitorMeeting";
          collection = "UserVideoActivity/ExhibitorMeeting";
        }
        participancesCollectionName += "/" + vm.exMeetingId;
        docId = vm.exMeetingId;
      }
      if (participancesCollectionName != "") {
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          collection: collection,
          instance: vm.event_collectionName,
          data: {
            SpotlightRequest: new Date().getTime(),
            SpotlightId: requestType == 1 ? uid : 0,
            RequestedBy: vm.uid,
            id: docId,
          },
        };
        axios
          .put(APIs.WriteObject, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            //alert("Spotlight Success");
            console.log(responseData);
          })
          .catch(function (error) {
            console.error("Error on Spotlight: ", error);
          });
      }
    },
    openSpeakerPanel(uid) {
      vm.rightPanel.openSpeakerPanel(uid);
    },
    openAttendeePanel() {
      vm.rightPanel.openAttendeePanel();
    },
    livePanelOnEnd(tableId, forceEnd) {
      vm.IsManuallyStopped = true;
      vm.callStarted = false;
      //router.push(vm.stageUrl);
      // alert(forceEnd);
      //alert(vm.exPageId);
      // alert(vm.stageUrl);
      // alert(vm.redirectToPath);
      if (forceEnd) {
        if (vm.exPageId == "" || vm.exPageId == "sn") {
          router.push(vm.stageUrl);
        } else {
          router.push(vm.redirectToPath);
        }
        vm.exPageId = "";
        vm.exSessionId = "";
        $("#divRoundTablesContainer").hide();
        $("#divRoundTablesContainer").removeClass("multi-session-popup");
      }
      vm.stageClicked();
      vm.showLoader();
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID) {
        vm.leaveRoundTable(tableId, vm.uid);
      } else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID ||
        vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID
      ) {
        vm.leaveMeeting();
      } else if (vm.selectedSessionTypeId == 100) {
        bus.$emit("closeVideoChat");
        return;
      } else {
        vm.leaveSession(vm.selectedSessionId, vm.uid);
      }
      vm.rightPanel.leaveRTMChannel();
      vm.rightPanel.stopPoll();

      if (vm.exPageId != "") {
        if (this.isMaximized) {
          //vm.resizePlayer();
        }
        //if (!vm.newDesign) {
        //  if (this.isMaximized) {
        //    vm.resizePlayer();
        //  }
        //}

        if (["sn", "rt", "o2o", "e2o"].includes(vm.exPageId)) {
          //alert(vm.exPageId);
          if (!vm.callSwitchingInProcess && vm.hasConnection) {
            if (vm.exPageId == "sn") {
              //if (vm.sessionTimeExceeded) {
              //alert("LEAVE");
              //router.push(vm.stageUrl);
              vm.exPageId = "";
              vm.exSessionId = "";
              vm.initLiveStage();
              // } else {
              //   setTimeout(() => {
              //     //if (
              //     //  vm.selectedSessionTypeId ==
              //     //  vm.GlobalKeysData.RoundTableTypeID
              //     //) {
              //     //  vm.selectedRoundTableId = "";
              //     //  $("#divLivePanelContainer").hide();
              //     //  $("#divRoundTablesContainer").show();
              //     //  //$("#divRoundTablesContainer").addClass(
              //     //  //  "multi-session-popup"
              //     //  //);
              //     //} else {
              //     vm.initLiveStage();
              //     //}
              //   }, 2000);
              // }
            } else if (vm.exPageId != "sn") {
              $("#endedByHostPopup").modal("hide");
              //if (vm.hasConnection) {
              vm.allowLeavePage = true;
              //if (vm.rtPageUrl && vm.selectedSessionTypeId == 4) {
              //  router.push(vm.rtPageUrl);
              //} else {
              router.push(vm.redirectToPath);
              //}
              //}
            }
            //else if (vm.exPageId == "sn" && forceEnd) {
            //  vm.allowLeavePage = true;
            //  router.push(vm.redirectToPath);
            //} else if (vm.exPageId == "sn" && vm.speakerCount == 0) {
            //  let currentTime = parseInt(new Date().getTime() / 1000);
            //  let timeLeft = 0;
            //  if (vm.selectedSession) {
            //    timeLeft = vm.selectedSession.EndTimeS - currentTime;
            //  }
            //  if (timeLeft <= 0) {
            //    vm.allowLeavePage = true;
            //    router.push(vm.redirectToPath);
            //  }
            //}
            //setTimeout(() => {
            //  if (vm.exPageId == "sn" && vm.speakerCount == 0) {
            //    let currentTime = parseInt(new Date().getTime() / 1000);
            //    let timeLeft = 0;
            //    if (vm.selectedSession) {
            //      timeLeft = vm.selectedSession.EndTimeS - currentTime;
            //    }
            //    if (timeLeft <= 0) {
            //      vm.allowLeavePage = true;
            //      router.push(vm.redirectToPath);
            //    }
            //  }
            //}, 2000);
            console.log(forceEnd);
          }
        }
        //if (vm.exPageId == "sn") {
        //  router.push("/sessions");
        //} else if (vm.exPageId == "rt") {
        //  if (vm.exExhibitorRT) {
        //    router.push("/exhibitorsview");
        //  } else {
        //    router.push(vm.redirectToPath);
        //  }
        //} else if (vm.exPageId == "o2o") {
        //  router.push("/mymeetings");
        //} else if (vm.exPageId == "e2o") {
        //  router.push("/exhibitorsview");
        //}
      } else {
        if (!vm.callSwitchingInProcess) {
          //alert("Go To initLiveStage");
          if (vm.sessionTimeExceeded) {
            vm.exPageId = "";
            vm.exSessionId = "";
            vm.initLiveStage();
          } else {
            setTimeout(() => {
              //if (
              //  vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID
              //) {
              //  vm.selectedRoundTableId = "";
              //  $("#divLivePanelContainer").hide();
              //  $("#divRoundTablesContainer").show();
              //  //$("#divRoundTablesContainer").addClass("multi-session-popup");
              //} else {
              vm.initLiveStage();
              //}
            }, 2000);
          }
        }
      }
    },
    livePanelOnBeforeStart() {
      $(".session-switch").addClass("disabled");
    },
    livePanelOnStart() {
      vm.callStarted = true;
      $(".session-switch").removeClass("disabled");
      if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID ||
        vm.exPageId == "rt"
      ) {
        //alert("livePanelOnStart");
        if (!vm.leaveAndJoinViaAPI) {
          vm.joinRoundTable(
            vm.selectedRoundTableId,
            vm.uid,
            vm.selectedRoundTable.AllowAutoJoin,
            vm.selectedRoundTable.AvailSeatType
          );
        }
      }
      if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID &&
        vm.exPageId == "o2o"
      ) {
        vm.displayCountdownTimer = vm.DisplaySessionTimer;
        vm.joinMeeting(true);
      } else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID &&
        vm.exPageId == "e2o"
      ) {
        vm.joinMeeting(true);
      } else if (vm.selectedSessionTypeId == 100 && vm.exPageId == "chat") {
        vm.joinMeeting(true);
      } else {
        vm.joinSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
      }
      vm.rightPanel.joinRTMChannel();
      if (
        vm.selectedSession &&
        vm.selectedSession.SessionTypeDetails &&
        vm.selectedSession.SessionTypeDetails.AudiencePoll
      ) {
        vm.rightPanel.startPoll();
      }
    },
    //collectLeaderboardPoint() {
    //  var actionTypeCode = vm.getActionTypeCode();
    //  vm.postLeaderboardAction(actionTypeCode);
    //},
    collectLeaderboardPoint() {
      //OnDemandTypeID: 1,
      //LiveStreamTypeID: 2,
      //LivePanelTypeID: 3,
      //RoundTableTypeID: 4,
      //InPersonTypeID: 5,
      //O2OTypeID: 6,
      //E2OTypeID: 7,
      var actionTypeCode = "";
      if ([1, 2, 3, 5].includes(vm.selectedSessionTypeId)) {
        actionTypeCode = "SNVW";
      } else if (vm.selectedSessionTypeId == 4) {
        if (vm.exParams.endsWith("_rt")) {
          actionTypeCode = "RTOT";
        } else if (vm.exParams.endsWith("_exrt")) {
          actionTypeCode = "RTEB";
        } else if (vm.exParams.endsWith("_sprt")) {
          actionTypeCode = "RTSB";
        } else {
          actionTypeCode = "RTSN";
        }
      } else if (vm.selectedSessionTypeId == 6) {
        actionTypeCode = "O2OA";
      } else if (vm.selectedSessionTypeId == 7) {
        actionTypeCode = "EBRV";
      } else if (vm.selectedSessionTypeId == 8) {
        actionTypeCode = "SBRV";
      }
      if (actionTypeCode) {
        vm.postLeaderboardAction(actionTypeCode);
      }
      //return actionTypeCode;
    },
    goLive(sessionId) {
      vm.startSession(sessionId, true);
    },
    SpeakerPanelOnUpdate(speakerIdList) {
      vm.speakerCount = speakerIdList.length;
      vm.rightPanel.UpdateSpeakerPanel(speakerIdList);
      //alert("userType:" + userType);
      //alert("vm.speakerCount:" + vm.speakerCount);
      //if (userType == 4 && vm.speakerCount == 0) {
      //  vm.livePanelOnEnd("", false);
      //}
    },
    recordingStatusChanged(recordingStarted) {
      vm.recordingStarted = recordingStarted;
    },
    displaySessionDetails() {
      $("#popupSessionDetails").modal("show");
    },
    loadGeneralSettings() {
      db.collection("OA_UAT")
        .doc("GeneralSettings")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.NewDesign
            ) {
              vm.newDesign = doc.data().PlayerSettings.NewDesign;
              //alert(vm.newDesign);
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.DebugMode
            ) {
              vm.debugMode = doc.data().PlayerSettings.DebugMode;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.HostOptionsEnabled
            ) {
              vm.hostOptionsEnabled =
                doc.data().PlayerSettings.HostOptionsEnabled;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.HostCanMuteSpeaker
            ) {
              vm.hostCanMuteSpeaker =
                doc.data().PlayerSettings.HostCanMuteSpeaker;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.HostCanHideSpeaker
            ) {
              vm.hostCanHideSpeaker =
                doc.data().PlayerSettings.HostCanHideSpeaker;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.HostCanSpotlightSpeaker
            ) {
              vm.hostCanSpotlightSpeaker =
                doc.data().PlayerSettings.HostCanSpotlightSpeaker;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.RememberSettings
            ) {
              vm.rememberSettings = doc.data().PlayerSettings.RememberSettings;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.AutoRecovery
            ) {
              vm.autoRecovery = doc.data().PlayerSettings.AutoRecovery;
              //alert(vm.autoRecovery);
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.AdvancedAutoRecovery
            ) {
              vm.advancedAutoRecovery =
                doc.data().PlayerSettings.AdvancedAutoRecovery;
              //alert(vm.advancedAutoRecovery);
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.DisplayNetworkError
            ) {
              vm.displayNetworkError =
                doc.data().PlayerSettings.DisplayNetworkError;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.EnableLogUpload
            ) {
              vm.enableLogUpload = doc.data().PlayerSettings.EnableLogUpload;
              //alert(vm.enableLogUpload);
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.UploadLogLevel
            ) {
              vm.uploadLogLevel = doc.data().PlayerSettings.UploadLogLevel;
              //alert(vm.uploadLogLevel);
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.AgoraPlayerClientsideLog
            ) {
              vm.agoraPlayerClientsideLog =
                doc.data().PlayerSettings.AgoraPlayerClientsideLog;
              //alert(vm.agoraPlayerClientsideLog);
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.IsZoomRTMPOptionsEnabled
            ) {
              vm.IsZoomRTMPOptionsEnabled =
                doc.data().PlayerSettings.IsZoomRTMPOptionsEnabled;
            }
            if (
              doc.data().PlayerSettings &&
              doc.data().PlayerSettings.EnableAgoraProxy
            ) {
              vm.enableAgoraProxy = doc.data().PlayerSettings.EnableAgoraProxy;
            }
          }
        });
    },
    loadSessionSettings() {
      db.collection(vm.event_collectionName)
        .doc("Settings")
        .collection("Sessions")
        .doc("SessionsSettings")
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            if (data) {
              if (data.ZoomWebEmbedEnabled) {
                vm.ZoomWebEmbedEnabled = data.ZoomWebEmbedEnabled;
              }
              if (data.ZoomWebEmbedExternalURL) {
                vm.ZoomWebEmbedExternalURL = data.ZoomWebEmbedExternalURL;
              }
              if (data.HideLiveStreamLeaveButton) {
                vm.HideLiveStreamLeaveButton = data.HideLiveStreamLeaveButton;
              }
              if (data.VideoPlayerBackgroundColor) {
                vm.VideoPlayerBackgroundColor = data.VideoPlayerBackgroundColor;
              }
              if (data.VideoPlayerPlayButtonColor) {
                vm.VideoPlayerPlayButtonColor = data.VideoPlayerPlayButtonColor;
              }
              if (data.ShowPlayerHeader != undefined) {
                vm.ShowPlayerHeader = data.ShowPlayerHeader;
              }
              if (vm.ShowPlayerHeader && vm.newDesign) {
                vm.ShowPlayerHeader = false;
              }
              if (data.ShowPlayerRightPanel != undefined) {
                vm.ShowPlayerRightPanel = data.ShowPlayerRightPanel;
              }
              if (data.ShowJoinButton != undefined) {
                vm.ShowJoinButton = data.ShowJoinButton;
              }
              if (data.StartLiveStageInMaximizedMode != undefined) {
                vm.StartLiveStageInMaximizedMode =
                  data.StartLiveStageInMaximizedMode;
              }
              if (vm.newDesign) {
                if (vm.StartLiveStageInMaximizedMode) {
                  //vm.rightPanel.setPlayerFullScreen(true);
                }
              }
              if (data.DisplayMaximizeButton) {
                vm.DisplayMaximizeButton = data.DisplayMaximizeButton;
              } else {
                vm.DisplayMaximizeButton = false;
              }
              if (data.AutoStartRecording != undefined) {
                vm.AutoStartRecording = data.AutoStartRecording;
              }
              if (data.AgendaFilterOption != undefined) {
                vm.agendaFilterOption = parseInt(data.AgendaFilterOption);
              }
              if (data.AllowAgendaTypeFilterInAutoFlow != undefined) {
                vm.allowAgendaTypeFilterInAutoFlow = parseInt(
                  data.AllowAgendaTypeFilterInAutoFlow
                );
              }
              if (data.LiveStageLogo) {
                vm.SessionSettingsLogo = data.LiveStageLogo;
              }
              if (data.LiveStageLogoHyperlink) {
                vm.SessionSettingsLogoLink = data.LiveStageLogoHyperlink;
              }
              if (vm.StartLiveStageInMaximizedMode) {
                if (!vm.isMaximized) {
                  vm.resizePlayer();
                }
              }
            }
          } else {
            //alert();
            vm.ShowPlayerHeader = true;
            if (vm.ShowPlayerHeader && vm.newDesign) {
              vm.ShowPlayerHeader = false;
            }
            vm.ShowPlayerRightPanel = true;
            vm.ShowJoinButton = true;
            vm.DisplayMaximizeButton = false;
            vm.DisplaySessionTimer = false;
            vm.AutoStartRecording = false;
            if (vm.newDesign) {
              if (vm.StartLiveStageInMaximizedMode) {
                //vm.rightPanel.setPlayerFullScreen(true);
              }
            }
          }
        })
        .catch(function () {
          console.log("Session settings missing");
        });
    },
    applyLiveStageSettings() {
      db.collection(vm.event_collectionName)
        .doc("Settings")
        .collection("Sessions")
        .doc("SessionsSettings")
        .get()
        .then((doc) => {
          let settings = {
            ActiveSpeakerFocus: false,
            ActiveSpeakerMinVolume: 10,
            ActiveSpeakerSorting: false,
            //DebugMode: false,
            DisplayAudienceCounter: false,
            DisplayCompanyAndTitleInVideoTile: true,
            VideoProfile: "480p_1",
          };
          if (vm.rememberSettings) {
            if (Cookies.get("VideoProfile")) {
              settings.VideoProfile = Cookies.get("VideoProfile");
            }
          }
          if (doc.exists) {
            let data = doc.data();
            if (data) {
              //let PlayerSettings = data.PlayerSettings;
              //alert("applyLiveStageSettings");
              //setVideoProfile
              //alert(PlayerSettings.ActiveSpeakerFocus);
              //if (PlayerSettings) {
              if (data.ActiveSpeakerFocus) {
                settings.ActiveSpeakerFocus = data.ActiveSpeakerFocus;
              }

              if (data.ActiveSpeakerMinVolume) {
                settings.ActiveSpeakerMinVolume = data.ActiveSpeakerMinVolume;
              }

              if (data.ActiveSpeakerSorting) {
                settings.ActiveSpeakerSorting = data.ActiveSpeakerSorting;
              }

              //if (data.DebugMode) {
              //  settings.DebugMode = data.DebugMode;
              //}
              if (data.DisplayAudienceCounter) {
                settings.DisplayAudienceCounter = data.DisplayAudienceCounter;
                vm.DisplayAudienceCounter = data.DisplayAudienceCounter;
              }

              if (data.DisplayCompanyAndTitleInVideoTile) {
                settings.DisplayCompanyAndTitleInVideoTile =
                  data.DisplayCompanyAndTitleInVideoTile;
              }

              if (!Cookies.get("VideoProfile")) {
                if (data.VideoProfile) {
                  settings.VideoProfile = data.VideoProfile;
                }
              }
              //}
              vm.videoProfile = settings.VideoProfile;
              vm.playerSettings.videoProfile = settings.VideoProfile;
              //alert(
              //  "vm.playerSettings.videoProfile:" +
              //    vm.playerSettings.videoProfile
              //);

              if (data.EnableSessionRating != undefined) {
                vm.EnableSessionRating = data.EnableSessionRating;
              }
              if (
                data.PlayButtonText &&
                data.PlayButtonText.trim().length > 0
              ) {
                vm.PlayButtonText = data.PlayButtonText;
              }

              if (
                data.LiveStageBackgroundLandscape != undefined &&
                data.LiveStageBackgroundLandscape != null &&
                data.LiveStageBackgroundLandscape != ""
              ) {
                vm.LiveStageBackground = data.LiveStageBackgroundLandscape;
              }
              if (
                data.LiveStageLogo != undefined &&
                data.LiveStageLogo != null &&
                data.LiveStageLogo != ""
              ) {
                vm.SessionSettingsLogo = data.LiveStageLogo;
              }
              //alert(data.LiveStageLogoHyperlink);
              if (
                data.LiveStageLogoHyperlink != undefined &&
                data.LiveStageLogoHyperlink != null &&
                data.LiveStageLogoHyperlink != ""
              ) {
                vm.SessionSettingsLogoLink = data.LiveStageLogoHyperlink;
              }
              if (data.DisplayMaximizeButton) {
                vm.DisplayMaximizeButton = data.DisplayMaximizeButton;
                //if (vm.DisplayMaximizeButton) {
                //  if (data.StartLiveStageInMaximizedMode != undefined) {
                //    vm.StartLiveStageInMaximizedMode =
                //      data.StartLiveStageInMaximizedMode;
                //    if (vm.StartLiveStageInMaximizedMode) {
                //      vm.resizePlayer();
                //    }
                //  }
                //}
              } else {
                vm.DisplayMaximizeButton = false;
              }
              if (data.ShowPlayerHeader != undefined) {
                vm.ShowPlayerHeader = data.ShowPlayerHeader;
              }
              if (vm.ShowPlayerHeader && vm.newDesign) {
                vm.ShowPlayerHeader = false;
              }

              if (data.ShowPlayerRightPanel != undefined) {
                vm.ShowPlayerRightPanel = data.ShowPlayerRightPanel;
              }
              if (data.ShowJoinButton != undefined) {
                vm.ShowJoinButton = data.ShowJoinButton;
              }
              if (data.StartLiveStageInMaximizedMode != undefined) {
                vm.StartLiveStageInMaximizedMode =
                  data.StartLiveStageInMaximizedMode;
              }
              if (data.AutoStartRecording != undefined) {
                vm.AutoStartRecording = data.AutoStartRecording;
              }
              if (vm.StartLiveStageInMaximizedMode) {
                if (!vm.isMaximized) {
                  //vm.resizePlayer();
                }
                //if (vm.isMaximized) {
                //  if (!vm.newDesign) {
                //    vm.resizePlayer();
                //  }
                //}
              }
              //if (vm.newDesign) {
              //  if (vm.StartLiveStageInMaximizedMode) {
              //    vm.rightPanel.setPlayerFullScreen(true);
              //  }
              //}
              if (data.DisplaySessionTimer != undefined) {
                vm.DisplaySessionTimer = data.DisplaySessionTimer;
              }

              if (
                data.LiveStageEndMessage != undefined &&
                data.LiveStageEndMessage != null &&
                data.LiveStageEndMessage != ""
              ) {
                vm.LiveStageEndMessage = data.LiveStageEndMessage;
                vm.LiveStageEndMessage = vm.LiveStageEndMessage.trim().replace(
                  "_blank",
                  ""
                );
              }

              //if (data.AgendaFilterOption != undefined) {
              //  vm.agendaFilterOption = parseInt(data.AgendaFilterOption);
              //}
              //if (data.AllowAgendaTypeFilterInAutoFlow != undefined) {
              //  vm.allowAgendaTypeFilterInAutoFlow = parseInt(
              //    data.AllowAgendaTypeFilterInAutoFlow
              //  );
              //}
            }
          } else {
            //alert("aaa");
            vm.ShowPlayerHeader = true;
            if (vm.ShowPlayerHeader && vm.newDesign) {
              vm.ShowPlayerHeader = false;
            }
            vm.ShowPlayerRightPanel = true;
            vm.ShowJoinButton = true;
            vm.DisplayMaximizeButton = false;
            vm.StartLiveStageInMaximizedMode = false;
            vm.DisplaySessionTimer = false;
            vm.AutoStartRecording = false;
          }
          vm.sessionSettingsLoaded = true;
          vm.livePlayer.initPlayerSettings(settings);
        })
        .catch(function () {
          console.log("Session settings missing");
        });
    },
    applyPlayerBroadcastSettings(
      sessionTypeId,
      sessionId,
      roundTableId,
      isZoomRTMP
    ) {
      //alert("applyPlayerBroadcastSettings:" + sessionTypeId);
      //alert("applyPlayerBroadcastSettings:" + sessionId);
      //alert("applyPlayerBroadcastSettings:" + roundTableId);
      if (isZoomRTMP == undefined) {
        isZoomRTMP = false;
      }
      let broadcastSettings = {
        AttendeeEnabled: false,
        QnAEnabled: false,
        ChatEnabled: true,
        RaiseHandEnabled: false,
        SpeakerInfoEnabled: false,
        SessionListEnabled: false,
      };
      let colId = "";
      let docId = "";
      if (
        sessionTypeId == 1 ||
        sessionTypeId == 2 ||
        sessionTypeId == 3 ||
        sessionTypeId == 5
      ) {
        colId = "Session";
        docId = sessionId;
      } else if (sessionTypeId == 4) {
        colId = "RoundTable";
        docId = roundTableId;
      } else if (sessionTypeId == 6) {
        colId = "OneToOneMeeting";
        docId = vm.exMeetingId;
      } else if (sessionTypeId == 7) {
        colId = "ExhibitorMeeting";
        docId = vm.exMeetingId;
      } else if (sessionTypeId == 100) {
        colId = "ChatRoom";
        docId = vm.roomId;
      }
      //if (sessionTypeId == 4 || sessionTypeId == 6 || sessionTypeId == 7) {
      //  broadcastSettings.ChatEnabled = true;
      //}
      if (isZoomRTMP) {
        broadcastSettings.QnAEnabled = true;
        //broadcastSettings.ChatEnabled = true;
      }
      //if (sessionTypeId == 3 || sessionTypeId == 4) {
      if (sessionTypeId == 1 || sessionTypeId == 2) {
        if (
          vm.selectedSession &&
          vm.selectedSession.MappedHosts &&
          vm.selectedSession.MappedSpeakers
        ) {
          if (
            vm.selectedSession.MappedHosts.length == 0 &&
            vm.selectedSession.MappedSpeakers.length == 0
          ) {
            broadcastSettings = {
              AttendeeEnabled: true,
              QnAEnabled: true,
              ChatEnabled: true,
              RaiseHandEnabled: true,
              SpeakerInfoEnabled: true,
              SessionListEnabled: true,
            };
          }
        }
      } else if (sessionTypeId == 100) {
        broadcastSettings = {
          AttendeeEnabled: false,
          QnAEnabled: true,
          ChatEnabled: true,
          RaiseHandEnabled: false,
          SpeakerInfoEnabled: false,
          SessionListEnabled: false,
        };
      }
      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection(colId)
        .doc(docId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            if (
              data.AttendeeEnabled == undefined &&
              data.QnAEnabled == undefined &&
              data.ChatEnabled == undefined &&
              data.RaiseHandEnabled == undefined &&
              data.SpeakerInfoEnabled == undefined &&
              data.SessionListEnabled == undefined
            ) {
              db.collection(vm.event_collectionName)
                .doc("UserVideoActivity")
                .collection(colId)
                .doc(docId)
                .set(broadcastSettings)
                .then(function () {
                  //alert("Added");
                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {
              broadcastSettings.AttendeeEnabled = data.AttendeeEnabled;
              broadcastSettings.QnAEnabled = data.QnAEnabled;
              broadcastSettings.ChatEnabled = data.ChatEnabled;
              broadcastSettings.RaiseHandEnabled = data.RaiseHandEnabled;
              broadcastSettings.SpeakerInfoEnabled = data.SpeakerInfoEnabled;
              broadcastSettings.SessionListEnabled = data.SessionListEnabled;
              //console.log("broadcastSettings:" + broadcastSettings);
            }
            vm.rightPanel.applyBroadcastSettings(broadcastSettings);
            vm.showViewersCount = broadcastSettings.AttendeeEnabled;
          } else {
            db.collection(vm.event_collectionName)
              .doc("UserVideoActivity")
              .collection(colId)
              .doc(docId)
              .set(broadcastSettings)
              .then(function () {
                //alert("Added");
              })
              .catch(function (error) {
                console.log(error);
              });
            vm.rightPanel.applyBroadcastSettings(broadcastSettings);
            vm.showViewersCount = broadcastSettings.AttendeeEnabled;
          }
        });
      //}
    },
    displayTablesPopup() {
      vm.displayCurrentTableList();
    },
    displayCurrentTableList() {
      if ($("#tableSwitch") && $("#tableSwitch").hasClass("disabled")) {
        return;
      }
      if (vm.roundTableList.length > 1) {
        $("#divRoundTablesContainer").addClass("multi-session-popup");
      }
    },
    hideCurrentTableList() {
      $("#divSessionsContainer").removeClass("multi-session-popup");
      $("#divRoundTablesContainer").removeClass("multi-session-popup");
    },
    displayCurrentSessionList() {
      //if ($("#sessionSwitch") && $("#sessionSwitch").hasClass("disabled")) {
      //  return;
      //}
      vm.updateSessionStatus();
      //if (vm.currentSessionCount > 1) {
      //  $("#divSessionsContainer").addClass("multi-session-popup");
      //}
    },
    hideCurrentSessionList() {
      $("#divRoundTablesContainer").removeClass("multi-session-popup");
      $("#divSessionsContainer").removeClass("multi-session-popup");
    },
    updateSessionStatus() {
      let cTime = parseInt(new Date().getTime() / 1000);
      vm.sessionList.forEach(function (objSession) {
        //var speakers = objSession.MappedSpeakers.filter(function (item) {
        //  return item.AttendeeId == vm.uid;
        //});
        //if (cTime < objSession.StartTimeS) {
        //  if (
        //    objSession.SessionTypeDetails.TypeID ==
        //      vm.GlobalKeysData.LivePanelTypeID &&
        //    speakers.length > 0
        //  ) {
        //    objSession.IsLive = true;
        //    objSession.LinkClass = "ongoing-status";
        //  } else {
        //    objSession.LinkClass = "upcoming-status";
        //  }
        //  //objSession.LinkClass = "upcoming-status";
        //  objSession.StatusDisplayText = vm.$t("livestage.upcoming");
        //  objSession.StatusClass = "upcoming-session";
        //} else
        if (cTime > objSession.StartTimeS && cTime < objSession.EndTimeS) {
          if (
            vm.IsZoomRTMPOptionsEnabled &&
            objSession.IsZoomRTMP &&
            !objSession.ZoomRTMPListener
          ) {
            vm.ZoomRTMPStatusListener(objSession);
          }
          if (
            !objSession.IsZoomRTMP ||
            objSession.IsHost ||
            objSession.IsSpeaker
          ) {
            objSession.IsLive = true;
            objSession.StatusDisplayText = vm.$t("livestage.live");
            objSession.StatusClass = "active-session";
            objSession.LinkClass = "ongoing-status";
          } else {
            objSession.IsLive = true;
            objSession.StatusDisplayText = vm.$t("livestage.live");
            objSession.StatusClass = "active-session";
            if (objSession.IsZoomRTMP && objSession.ZoomRTMPStarted) {
              objSession.LinkClass = "ongoing-status";
            } else {
              objSession.LinkClass = "upcoming-status";
            }

            //if (objSession.ZoomRTMPStarted) {
            //  objSession.IsLive = true;
            //  objSession.LinkClass = "ongoing-status";
            //} else {
            //  objSession.IsLive = false;
            //  objSession.LinkClass = "upcoming-status new-btn-design-disabled";
            //}
            //objSession.StatusClass = "active-session";
            //objSession.StatusDisplayText = vm.$t("livestage.live");
          }
        } else if (cTime > objSession.EndTimeS) {
          if (
            objSession.SessionTypeDetails.TypeID ==
              vm.GlobalKeysData.LivePanelTypeID &&
            objSession.IsLive &&
            objSession.IsZoomRTMP
          ) {
            if (objSession.ZoomRTMPListener) {
              objSession.ZoomRTMPListener();
              objSession.ZoomRTMPListener = null;
            }
          }
          if (
            objSession.SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd &&
            objSession.SessionTypeDetails.TypeID ==
              vm.GlobalKeysData.LivePanelTypeID &&
            objSession.LinkClass == "ongoing-status"
          ) {
            vm.tryConvertLivePanelToOnDemandVideo(objSession.SessionId);
          }
          objSession.IsLive = false;
          //if (
          //  objSession.SessionTypeDetails.TypeID ==
          //  vm.GlobalKeysData.OnDemandTypeID
          //) {
          //  objSession.IsLive = true;
          //  objSession.LinkClass = "ongoing-status";
          //} else {
          objSession.LinkClass = "finish-status";
          //}
          objSession.StatusClass = "finish-session";
          objSession.StatusDisplayText = vm.$t("livestage.sessionended");
        }
        //if (vm.exPageId != "" || vm.exSessionId != "")
        //if (cTime < item.SessionStartTime) {
        //  item.LinkClass = "upcoming-status";
        //  item.StatusDisplayText = vm.$t("livestage.upcoming");
        //  item.StatusClass = "upcoming-session";
        //} else if (
        //  cTime > item.SessionStartTime &&
        //  cTime < item.SessionEndTime
        //) {
        //  item.IsLive = true;
        //  item.StatusDisplayText = vm.$t("livestage.live");
        //  item.StatusClass = "active-session";
        //  item.LinkClass = "ongoing-status";
        //} else if (cTime > item.SessionEndTime) {
        //  item.StatusDisplayText = vm.$t("livestage.sessionended");
        //  item.StatusClass = "finish-session";
        //  item.LinkClass = "finish-status";
        //}

        //if (
        //  item.SessionStartTime <= cTime &&
        //  item.SessionEndTime >= cTime
        //) {
        //  //alert(flag);
        //  //item.SelectedSessionClass = "";
        //  //if (vm.selectedSessionId == item.SessionId) {
        //  //  item.SelectedSessionClass = "live-session-right";
        //  //  vm.currentSessionElementId = "rp_session_" + item.SessionId;
        //  //}

        //  //var currentTime = parseInt(new Date().getTime() / 1000);
        //  //item.IsLive = false;
        //  //if (currentTime < item.StartTime) {
        //  //  item.LinkClass = "upcoming-status";
        //  //  item.StatusDisplayText = "Upcoming";
        //  //  item.StatusClass = "upcoming-session-indicate";
        //  //} else if (
        //  //  currentTime > item.StartTime &&
        //  //  currentTime < item.EndTime
        //  //) {
        //  //  item.IsLive = true;
        //  //  item.StatusDisplayText = "Live";
        //  //  item.StatusClass = "live-session-indicate";
        //  //  item.LinkClass = "ongoing-status";
        //  //} else if (currentTime > item.EndTime) {
        //  //  item.StatusDisplayText = "Session Ended";
        //  //  item.StatusClass = "end-session-indicate";
        //  //  item.LinkClass = "finish-status";
        //  //}

        //}
      });

      vm.sessionList = vm.sessionList.filter(function () {
        return true;
      });
    },
    tryConvertLivePanelToOnDemandVideo(sessionId) {
      //alert(sessionId);
      let channelName = "OAUAT_" + vm.eventId.substring("1") + "_" + sessionId;
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: {
          recEventId: vm.eventId.substring("1"),
          sessionId: sessionId,
          channelId: channelName,
        },
      };
      axios
        .post(APIs.LivePanelToOnDemandVideo, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          console.log(responseData);
          //console.log(responseData);
          if (responseData && responseData.data.status == 0) {
            //alert(responseData.data.msg);
            //let objSessions = vm.allSessions.filter(function (item) {
            //  return item.SessionId == sessionId;
            //});
            //if (objSessions.length > 0) {
            //  objSessions[0].SessionTypeDetails.TypeID = 1;
            //  objSessions[0].SessionTypeDetails.TypeName = "On Demand";
            //  objSessions[0].SessionTypeDetails.VideoURL =
            //    responseData.data.msg;
            //  objSessions[0].IsLive = true;
            //}
          }
        })
        .catch((error) => {
          //alert();
          console.log(error);
        });
    },
    initLiveStage() {
      vm.speakerCount = 0;
      vm.callStarted = false;
      vm.IsBackStage = false;
      vm.callSwitchingInProcess = false;
      vm.recordingStarted = false;
      vm.notificationText = "";
      vm.prevSessionRunning = false;
      vm.goToNextSession = true;
      vm.displayNotification = false;
      vm.hideNotificationClicked = false;
      vm.displayContinueNotification = false;
      vm.hideContinueNotificationClicked = false;
      vm.sessionTimeExceeded = false;
      vm.countdownSeconds = 0;
      vm.sessionsLoaded = false;
      vm.mySessionsLoaded = false;
      vm.currentStage = 0;
      vm.allRTParticipancesLoaded = false;
      vm.allRoundTablesLoaded = false;
      vm.sessionSettingsLoaded = false;
      vm.roundTablesLoadedCount = 0;
      vm.switchTableVisible = false;

      vm.userAgendaFilterPending = true;
      vm.agendaFileterPending = true;
      vm.showAgendaFileterPopup = false;
      vm.selectedUserAgendaType = 2;

      vm.sessionList = [];
      vm.roundTableList.forEach(function (rt) {
        if (rt.Listener) {
          rt.Listener();
        }
      });
      vm.roundTableList = [];
      vm.selectedSessionId = "";
      vm.selectedSession = null;
      vm.selectedSessionTypeId = 0;
      vm.upcomingSessionTypeId = 0;
      vm.upcomingSessionCount = 0;
      vm.upcomingSession = null;

      if (currentSessionListener) {
        currentSessionListener();
      }
      if (currentSessionParticipancesListener) {
        currentSessionParticipancesListener();
      }
      if (currentRTListener) {
        currentRTListener();
      }
      if (currentSessionTimer) {
        clearInterval(currentSessionTimer);
      }
      if (scheduleSessionTimer) {
        clearInterval(scheduleSessionTimer);
      }
      if (scheduleRTTimer) {
        clearInterval(scheduleRTTimer);
      }
      if (rtAutoJoinTimer) {
        clearInterval(rtAutoJoinTimer);
      }
      if (retryPlayStreamTimer) {
        clearInterval(retryPlayStreamTimer);
      }

      $("#sessionEndCountdown").hide();
      $("#divLiveVideoContainer").hide();
      $("#divLiveStreamContainer").hide();
      $("#divLivePanelContainer").hide();
      $("#divLivePanelContainer").addClass("d-none");
      $("#divRoundTablesContainer").hide();
      $("#divRoundTablesContainer").removeClass("multi-session-popup");
      //$("#divSessionEndedContainer").hide();

      vm.applyLiveStageSettings();
      if (vm.exPageId == "" || vm.exPageId == "sn") {
        if (vm.sessionSettingsLoaded) {
          vm.prepareMySession();
        }
        vm.loadAllSessions();
        vm.initSessionAutoSwitchTimer();
      } else {
        //alert(vm.exPageId)
        //vm.loadAllSessions();
        if (vm.exPageId == "rt") {
          vm.selectedSessionTypeId = 4;
          vm.displayRoundTables();
        } else {
          if (vm.exPageId == "o2o") {
            vm.selectedSessionTypeId = 6;
            setTimeout(() => {
              vm.startOneToOneMeeting();
            }, 5000);
          } else if (vm.exPageId == "e2o") {
            vm.selectedSessionTypeId = 7;
            setTimeout(() => {
              vm.startExhibitorMeeting();
            }, 5000);
            vm.showLoader();
          } else if (vm.exPageId == "chat") {
            $("#divSessionsContainer").hide();
            vm.selectedSessionTypeId = 100;
            setTimeout(() => {
              vm.startVideoChat();
            }, 2000);
            vm.showLoader();
          }
        }
      }
    },
    startUpcomingSessionClock() {
      vm.currentStage = 1;
      //alert(vm.upcomingSessionTypeId);
      //alert(vm.countdownSeconds);
      vm.baseTimer.createTimer(vm.countdownSeconds);
    },

    prepareMySession() {
      //alert("prepareMySession:" + vm.agendaFilterOption);
      vm.mySessions = [];
      if (vm.agendaFilterOption == 0) {
        vm.mySessionsLoaded = true;
      } else {
        //if (vm.event_collectionName && vm.uid) {
        //  db.collection(vm.event_collectionName)
        //    .doc("AttendeeList")
        //    .collection("Attendees")
        //    .doc(vm.uid)
        //    .collection("MappedSessions")
        //    .get()
        //    .then((querySnapshot) => {
        //      alert(querySnapshot.docs.length);
        //      querySnapshot.forEach((doc) => {
        //        vm.mySessions.push(doc.id);
        //      });
        //      vm.mySessionsLoaded = true;
        //    });
        //}

        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
            eventId: vm.eventId,
          },
          data: {
            AttendeeId: vm.uid,
          },
        };
        axios
          .post(APIs.MyAgenda, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            //alert("MyAgenda");
            //console.log(responseData);
            ////console.log(responseData);
            if (
              responseData &&
              responseData.data &&
              responseData.data.status == 0 &&
              responseData.data.sessions
            ) {
              //alert(responseData.data.sessions.length);
              responseData.data.sessions.map(function (item) {
                //alert(item.SessionId);
                vm.mySessions.push(item.SessionId);
              });
            }
            vm.mySessionsLoaded = true;
          })
          .catch((error) => {
            //alert("MyAgenda:" + error);
            console.log(error);
            vm.mySessionsLoaded = true;
          });
      }
    },

    //External Page Access
    loadAllSessions(requestId) {
      //alert("loadAllSessions");
      vm.sessionList = [];
      vm.speakerProfiles = [];
      vm.endedSessionCount = 0;
      let currentTime = parseInt(new Date().getTime() / 1000);

      if (vm.event_collectionName != "") {
        db.collection(vm.event_collectionName)
          .doc("SpeakerList")
          .collection("Speakers")
          .get()
          .then((querySnapshotSpk) => {
            vm.speakerProfiles = [];
            querySnapshotSpk.forEach((doc) => {
              var profile = doc.data().Profile;
              profile = profile == undefined ? "" : profile;
              var speakerId = doc.data().SpeakerId;
              var hideInList = doc.data().HideInList
                ? doc.data().HideInList
                : false;
              vm.speakerProfiles.push({
                SpeakerId: speakerId,
                Profile: profile,
                HideInList: hideInList,
              });
            });
            let sessionListRef = db
              .collection(vm.event_collectionName)
              .doc("SessionList")
              .collection("Sessions")
              .where("IsPublished", "==", true);

            //if (vm.exPageId == "") {
            sessionListRef = sessionListRef.orderBy("StartDate", "asc");
            //} else if (vm.exSessionId != "") {
            //  sessionListRef = sessionListRef.where(
            //    "SessionId",
            //    "==",
            //    vm.exSessionId
            //  );
            //}
            sessionListRef.get().then((querySnapshot) => {
              //alert("querySnapshot:" + querySnapshot.docs.length);
              querySnapshot.forEach((doc) => {
                let data = doc.data();
                let sessions = vm.sessionList.filter(function (item) {
                  return item.SessionId == data.SessionId;
                });
                if (sessions.length == 0) {
                  var objSession = new Object();
                  //alert(data.StartDate)
                  objSession.SessionStartTime = data.StartDate.seconds;
                  objSession.SessionEndTime = data.EndDate.seconds;

                  objSession.StartTimeS = data.StartDate.seconds;
                  objSession.EndTimeS = data.EndDate.seconds;
                  if (vm.exPageId != "" && vm.exSessionId != "") {
                    //alert("aaaaa")
                    if (data.SessionTypeDetails.TypeID == 1) {
                      let duration =
                        objSession.EndTimeS - objSession.StartTimeS;
                      objSession.EndTimeS =
                        parseInt(new Date().getTime() / 1000) + duration;
                      //data.EndDate.setDate(new Date() + 365);
                    } else if (data.SessionTypeDetails.TypeID == 3) {
                      // if([1, 2].includes(objSession.AttendeeType))
                      // {
                      //data.StartDate.setDate(new Date() - 365);
                      objSession.StartTimeS =
                        data.StartDate.seconds - 365 * 24 * 60 * 60;
                      // }
                    }
                  }
                  //alert(objSession.StartTimeS)
                  if (vm.exPageId == "") {
                    if (currentTime > data.EndDate.seconds) {
                      vm.endedSessionCount++;
                    }
                  }
                  let dtt = new Date(data.StartDate.seconds * 1000);
                  // alert(dtt);
                  var dtYear = dtt.getFullYear();
                  var dtMonth = dtt.getMonth();
                  var dtDay = dtt.getDate();
                  var dateTabLabel = dtt.toString().substring(0, 10);
                  objSession.DateTabLabel = dateTabLabel;
                  objSession.DateTabId =
                    "menu" +
                    objSession.DateTabLabel.replace(" ", "").replace(" ", "");
                  objSession.StartDate = new Date(dtYear, dtMonth, dtDay);

                  objSession.StartTime = objSession.StartDate.getTime();
                  objSession.EndDate = new Date(dtYear, dtMonth, dtDay);
                  objSession.EndDate.setDate(objSession.EndDate.getDate() + 1);
                  objSession.EndTime = objSession.EndDate.getTime();
                  objSession.CurrentClass = "";
                  // objSession.StartTimeS = data.StartDate.seconds;
                  // objSession.EndTimeS = data.EndDate.seconds;

                  objSession.Name = data.Name;
                  objSession.SessionId = data.SessionId;
                  objSession.DescriptionShort = data.DescriptionShort;
                  objSession.Description = data.Description;
                  objSession.Resources = data.Resources;
                  objSession.SessionTypeDetails = data.SessionTypeDetails;
                  if (objSession.SessionTypeDetails) {
                    if (
                      objSession.SessionTypeDetails
                        .ConvertToOnDemandVideoOnSessionEnd == undefined
                    ) {
                      objSession.SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd = false;
                    }
                    objSession.SessionTypeDetails.ShowAgenda = objSession
                      .SessionTypeDetails.ShowAgenda
                      ? objSession.SessionTypeDetails.ShowAgenda
                      : true;
                    objSession.TypeID = objSession.SessionTypeDetails.TypeID;
                  }
                  objSession.Track = data.Track;
                  if (!objSession.Track) {
                    objSession.Track = { TrackID: "", TrackName: "" };
                  }
                  objSession.TrackName = objSession.Track.TrackName;

                  //objSession.EndedByHost = false;
                  //if (data.EndedByHost) {
                  //  objSession.EndedByHost = data.EndedByHost;
                  //}
                  objSession.EndRequest = false;
                  objSession.MePresent = false;
                  if (data.EndRequest) {
                    objSession.EndRequest = data.EndRequest;
                  }
                  objSession.Logo = "";
                  if (data.SessionLogo) {
                    objSession.Logo = data.SessionLogo;
                  }
                  if (!objSession.Logo) {
                    objSession.Logo = vm.SessionSettingsLogo;
                  }
                  objSession.LogoLink = "";
                  if (data.SessionLogoLink) {
                    objSession.LogoLink = data.SessionLogoLink;
                  }
                  if (!objSession.LogoLink) {
                    objSession.LogoLink = vm.SessionSettingsLogoLink;
                  }

                  objSession.IsHost = false;
                  objSession.IsSpeaker = false;
                  objSession.MappedHosts =
                    data.MappedHosts == undefined ? [] : data.MappedHosts;
                  let streamingClient = "Web";
                  if (data.StreamingClient) {
                    streamingClient = data.StreamingClient;
                  }
                  if (streamingClient.toLowerCase().trim() == "web") {
                    if (objSession.MappedHosts.length > 1) {
                      objSession.MappedHosts = [objSession.MappedHosts[0]];
                    }
                  }
                  objSession.MappedCoHosts = data.MappedCoHost
                    ? [data.MappedCoHost]
                    : [];

                  objSession.MappedSpeakers =
                    data.MappedSpeakers == undefined ? [] : data.MappedSpeakers;
                  var activeSpeakers = objSession.MappedSpeakers.filter(
                    function (item) {
                      return !item.HideInList;
                    }
                  );
                  objSession.SpeakerLength = activeSpeakers.length;

                  objSession.MappedHosts.forEach(function (item) {
                    item.ProfilePictureURL = vm.getCDNUrl(
                      item.ProfilePictureURL
                    );
                    //if (
                    //  item.ProfilePictureURL == undefined ||
                    //  item.ProfilePictureURL == ""
                    //) {
                    //  item.ProfilePictureURL = avatarImageUrl;
                    //}
                    if (item.AttendeeId == vm.uid) {
                      objSession.IsHost = true;
                    }
                    if (!item.ProfilePictureURL) {
                      item.ProfilePictureURL = "";
                    }
                    item.NameInitial = common.getInitials(item.Name);
                    var filteredList = vm.speakerProfiles.filter(function (
                      spkr
                    ) {
                      return item.AttendeeId == spkr.SpeakerId;
                    });
                    if (filteredList.length > 0) {
                      item.HideInList = filteredList[0].HideInList;
                    }
                  });
                  objSession.MappedCoHosts.forEach(function (item) {
                    item.ProfilePictureURL = vm.getCDNUrl(
                      item.ProfilePictureURL
                    );
                    //if (
                    //  item.ProfilePictureURL == undefined ||
                    //  item.ProfilePictureURL == ""
                    //) {
                    //  item.ProfilePictureURL = avatarImageUrl;
                    //}
                    if (item.AttendeeId == vm.uid) {
                      objSession.IsHost = true;
                    }
                    if (!item.ProfilePictureURL) {
                      item.ProfilePictureURL = "";
                    }
                    item.NameInitial = common.getInitials(item.Name);
                    var filteredList = vm.speakerProfiles.filter(function (
                      spkr
                    ) {
                      return item.AttendeeId == spkr.SpeakerId;
                    });
                    if (filteredList.length > 0) {
                      item.HideInList = filteredList[0].HideInList;
                    }
                  });
                  objSession.MappedSpeakers.forEach(function (item) {
                    item.ProfilePictureURL = vm.getCDNUrl(
                      item.ProfilePictureURL
                    );
                    //if (
                    //  item.ProfilePictureURL == undefined ||
                    //  item.ProfilePictureURL == ""
                    //) {
                    //  item.ProfilePictureURL = avatarImageUrl;
                    //}
                    if (item.AttendeeId == vm.uid) {
                      objSession.IsSpeaker = true;
                    }
                    if (!item.ProfilePictureURL) {
                      item.ProfilePictureURL = "";
                    }
                    item.NameInitial = common.getInitials(item.Name);
                    var filteredList = vm.speakerProfiles.filter(function (
                      spkr
                    ) {
                      return item.AttendeeId == spkr.SpeakerId;
                    });
                    if (filteredList.length > 0) {
                      item.HideInList = filteredList[0].HideInList;
                    }
                  });

                  objSession.IsUpcoming = false;
                  //alert(objSession.SessionId);
                  //alert(objSession.MappedHosts);
                  //alert(objSession.MappedSpeakers);
                  objSession.AttendeeType = 4;

                  objSession.NotificationMessage =
                    vm.defaultNotificationMessage;
                  objSession.DisplayBeforeSessionEndSecs =
                    vm.defaultDisplayBeforeSessionEndSecs;
                  objSession.ShowSessionEndNotificationMessage = false;

                  if (
                    data.NotificationMessage &&
                    data.NotificationMessage.length > 0
                  ) {
                    objSession.NotificationMessage = data.NotificationMessage;
                  }

                  let displayBeforeSessionEndSecs = 0;
                  if (data.DisplayBeforeSessionEndSecs) {
                    displayBeforeSessionEndSecs = parseInt(
                      data.DisplayBeforeSessionEndSecs
                    );
                  }
                  if (displayBeforeSessionEndSecs > 0) {
                    objSession.DisplayBeforeSessionEndSecs =
                      displayBeforeSessionEndSecs;
                  }

                  if (data.ShowSessionEndNotificationMessage) {
                    objSession.ShowSessionEndNotificationMessage =
                      data.ShowSessionEndNotificationMessage;
                  }
                  //alert(vm.uid);
                  let host = objSession.MappedHosts.filter(function (item) {
                    return item.AttendeeId == vm.uid;
                  });
                  if (host.length > 0) {
                    objSession.AttendeeType = 1;
                  } else {
                    let speaker = objSession.MappedSpeakers.filter(function (
                      item
                    ) {
                      return item.AttendeeId == vm.uid;
                    });
                    if (speaker.length > 0) {
                      objSession.AttendeeType = 2;
                    }
                  }
                  //objSession.IamInThesession = IamInThesession;
                  //objSession.broadcastUrlForSession = broadcastUrlForSession;
                  objSession.StartTimeLabel = vm.getFormattedTime(
                    data.StartDate.seconds
                  );
                  objSession.EndTimeLabel = vm.getFormattedTime(
                    data.EndDate.seconds
                  );
                  objSession.IsLive = false;
                  objSession.Location = "";
                  objSession.TopicId = "";
                  if (objSession.SessionTypeDetails.TypeID == 4) {
                    objSession.TopicId =
                      objSession.SessionTypeDetails.RoundTableTopic.TopicId;
                    vm.checkMySeatTypeInMappedTables(
                      objSession.SessionId,
                      objSession.SessionTypeDetails.RoundTableTopic.TopicId
                    );
                  }
                  objSession.StreamingClient = doc.data().StreamingClient;
                  if (!objSession.StreamingClient) {
                    objSession.StreamingClient = "Web";
                  }
                  objSession.Zoom_Detail = doc.data().Zoom_Detail;
                  objSession.IsZoomRTMP = doc.data().IsZoomRTMP
                    ? doc.data().IsZoomRTMP
                    : false;
                  objSession.ZoomMeetingStarted = doc.data().MeetingStarted
                    ? doc.data().MeetingStarted
                    : false;
                  objSession.ZoomRTMPMUX_detail = doc.data().ZoomRTMPMUX_detail;
                  objSession.ZoomRTMPStarted = doc.data().ZoomRTMPStarted
                    ? doc.data().ZoomRTMPStarted
                    : false;
                  //if (objSession.SessionId == "99903301") {
                  //  alert(objSession.SessionId);
                  //}

                  if (currentTime < objSession.StartTimeS) {
                    objSession.IsUpcoming = true;
                    objSession.LinkClass = "upcoming-status";
                    objSession.StatusDisplayText = vm.$t("livestage.upcoming");
                    objSession.StatusClass = "upcoming-session";
                  } else if (
                    currentTime > objSession.StartTimeS &&
                    currentTime < objSession.EndTimeS
                  ) {
                    if (
                      !objSession.IsZoomRTMP ||
                      objSession.IsHost ||
                      objSession.IsSpeaker
                    ) {
                      objSession.IsLive = true;
                      objSession.StatusDisplayText = vm.$t("livestage.live");
                      objSession.StatusClass = "active-session";
                      objSession.LinkClass = "ongoing-status";
                    } else {
                      objSession.IsLive = true;
                      objSession.StatusDisplayText = vm.$t("livestage.live");
                      objSession.StatusClass = "active-session";
                      if (objSession.IsZoomRTMP && objSession.ZoomRTMPStarted) {
                        objSession.LinkClass = "ongoing-status";
                      } else {
                        objSession.LinkClass = "upcoming-status";
                      }
                    }
                  } else if (currentTime > objSession.EndTimeS) {
                    //if (
                    //  objSession.SessionTypeDetails.TypeID ==
                    //  vm.GlobalKeysData.OnDemandTypeID
                    //) {
                    //  objSession.IsLive = true;
                    //  objSession.StatusDisplayText = "Session Ended";
                    //  objSession.StatusClass = "finish-session";
                    //  objSession.LinkClass = "ongoing-status";
                    //} else {
                    objSession.StatusDisplayText = vm.$t(
                      "livestage.sessionended"
                    );
                    objSession.StatusClass = "finish-session";
                    objSession.LinkClass = "finish-status";
                    //}
                  }
                  vm.sessionList.push(objSession);
                }
              });
              //alert(vm.sessionList.length);
              vm.sessionsLoaded = true;
              if (requestId) {
                vm.loadSessionsComplete = true;
              }
            });
          });
      }
    },
    checkMySeatTypeInMappedTables(sessionId, topicId) {
      if (sessionId && topicId && sessionId != "" && topicId != "") {
        db.collection(vm.event_collectionName)
          .doc("RoundTableList")
          .collection("RoundTables")
          .where("IsPublished", "==", true)
          .where("Topic.TopicId", "==", topicId)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var isMappedasAttendee = false;
              var isHost = false;
              let table = doc.data();
              var preassinedAtt = table.MappedAttendees;
              var preAssisgnedAtt = preassinedAtt.filter(function (value) {
                return value.AttendeeId == vm.uid;
              });
              if (preAssisgnedAtt.length > 0) {
                isMappedasAttendee = true;
              }
              var host = table.Host;
              if (host != undefined) {
                if (host.length > 0) {
                  if (
                    host[0].AttendeeId != undefined &&
                    host[0].AttendeeId == vm.uid
                  ) {
                    isHost = true;
                  }
                }
              }
              var sessions = vm.sessionList.filter(function (value) {
                return value.SessionId == sessionId;
              });
              if (sessions.length > 0) {
                if (isHost) {
                  sessions[0].AvailSeatType = 1;
                } else if (isMappedasAttendee) {
                  sessions[0].AvailSeatType = 3;
                } else {
                  sessions[0].AvailSeatType = 4;
                }
              }
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    initSessionAutoSwitchTimer() {
      if (sessionSwitchTimer) {
        clearInterval(sessionSwitchTimer);
      }
      sessionSwitchTimer = setInterval(function () {
        vm.upcomingSessionCount = vm.getUpcomingSessionCount();
        if (vm.currentSessions.length == 0) {
          if (!vm.callStarted) {
            if ($("#divSessionsContainer").is(":visible")) {
              $("#divSessionsContainer").hide();
              $("#divSessionsContainer").removeClass("multi-session-popup");
              vm.initLiveStage();
            }
          }
          //console.log("callStarted: " + vm.callStarted);
          //console.log("selectedSessionTypeId: " + vm.selectedSessionTypeId);
          //console.log("selectedSessionId: " + vm.selectedSessionId);
        }
        if (
          vm.sessionSettingsLoaded &&
          vm.sessionsLoaded &&
          vm.mySessionsLoaded
        ) {
          if (vm.sessionList.length > 0) {
            if (vm.exPageId == "") {
              if (vm.agendaFileterPending) {
                if (vm.agendaFilterOption == 0) {
                  //Full Agenda
                  vm.agendaFileterPending = false;
                } else if (vm.agendaFilterOption == 1) {
                  //My Agenda
                  vm.agendaFileterPending = false;
                  vm.sessionList = vm.sessionList.filter(function (item) {
                    return vm.mySessions.includes(item.SessionId);
                  });
                } else {
                  //All
                  if (
                    vm.userAgendaFilterPending &&
                    vm.allowAgendaTypeFilterInAutoFlow
                  ) {
                    vm.showAgendaFileterPopup = true;
                  } else {
                    vm.userAgendaFilterPending = false;
                    vm.showAgendaFileterPopup = false;
                    vm.agendaFileterPending = false;
                    //if (
                    //  !vm.allowAgendaTypeFilterInAutoFlow &&
                    //  vm.mySessions.length > 0
                    //) {
                    //  vm.selectedUserAgendaType = 1;
                    //}
                    if (vm.selectedUserAgendaType == 1) {
                      vm.sessionList = vm.sessionList.filter(function (item) {
                        return vm.mySessions.includes(item.SessionId);
                      });
                    }
                  }
                }
              }
            } else {
              vm.agendaFileterPending = false;
            }
            //alert(vm.exPageId);
            //vm.countdownSeconds--;
            if (!vm.agendaFileterPending && vm.goToNextSession) {
              vm.goToNextSession = false;
              //alert("initSessionAutoSwitchTimer");
              //if (vm.exPageId == "" || !vm.hideContinueNotificationClicked) {
              //  vm.tryAutoSwitchSession();
              //} else
              if (vm.exPageId == "sn" && vm.hideContinueNotificationClicked) {
                //router.push(vm.stageurl);
                vm.exPageId = "";
                vm.exSessionId = "";
                vm.initLiveStage();
              } else {
                vm.tryAutoSwitchSession();
              }
            }
            //var currentTime = parseInt(new Date().getTime() / 1000);
            //let sessionEndsIn = vm.upcomingSession.StartTimeS - currentTime;
            //$("#sessionEndCountdown").html(vm.formatTimeForClock(sessionEndsIn));
            vm.updateSessionStatus();

            //let sessionCount = vm.getCurrentSessionCount();
            //if (sessionCount == 0) {
            //  alert(
            //    "selectedSessionId:" +
            //      vm.selectedSessionId +
            //      "\n" +
            //      "selectedSessionTypeId:" +
            //      vm.selectedSessionTypeId +
            //      "\n" +
            //      "upcomingSessionId:" +
            //      vm.upcomingSessionTypeId
            //  );
            //}
          } else {
            //if (this.isMaximized) {
            //  vm.resizePlayer();
            //}
          }
          vm.rightPanel.updateSessionStatus();
        }
      }, 2000);
    },
    BackStage() {
      //alert(vm.livePlayerChannel.includes("_gr"));
      return (
        vm.selectedSessionTypeId == 3 &&
        vm.livePlayerChannel.indexOf("_gr") > -1
      );
    },
    initCurrentSessionTimer() {
      if (currentSessionTimer) {
        clearInterval(currentSessionTimer);
      }
      vm.initCurrentSessionListener();
      currentSessionTimer = setInterval(function () {
        if (vm.selectedSession) {
          var currentTime = parseInt(new Date().getTime() / 1000);
          let backStageFlag = vm.BackStage();
          if (
            currentTime > vm.selectedSession.StartTimeS &&
            currentTime < vm.selectedSession.EndTimeS
          ) {
            let sessionEndsIn = vm.selectedSession.EndTimeS - currentTime;
            if (backStageFlag) {
              sessionEndsIn = vm.selectedSession.SessionStartTime - currentTime;
            }
            if (sessionEndsIn > 0 && sessionEndsIn < 10) {
              vm.prevSessionTypeId = vm.selectedSessionTypeId;
              vm.prevSessionId = vm.selectedSessionId;
            }

            if (
              vm.selectedSession.ShowSessionEndNotificationMessage &&
              !vm.hideNotificationClicked
            ) {
              if (
                sessionEndsIn > 1 &&
                sessionEndsIn <
                  vm.selectedSession.DisplayBeforeSessionEndSecs &&
                !backStageFlag
              ) {
                //if (vm.iAmInUpcomingSession()) {
                //alert("iAmInUpcomingSession");
                vm.showNotification(
                  vm.selectedSession.NotificationMessage.replace(
                    "{{countdown}}",
                    vm.formatTimeForClock(sessionEndsIn)
                  )
                );
                //} else {
                //  let msg =
                //    "Thank you for joining BCRF's Virtual Symposium & Awards Luncheon";
                //  if (vm.event_collectionName.indexOf("C1598003113626") == -1) {
                //    msg = "This session is about to end in {{countdown}}";
                //  }
                //  vm.showNotification(
                //    msg.replace(
                //      "{{countdown}}",
                //      vm.formatTimeForClock(sessionEndsIn)
                //    )
                //  );
                //}
              } else if (sessionEndsIn < 2) {
                vm.hideNotification();
              }
            }
            //FOR AUTO SWITCH SESSION PAGE
            //if (sessionEndsIn < 2) {
            //  //alert(vm.exPageId)
            //  if (vm.exPageId == "sn") {
            //    if (this.isMaximized) {
            //      vm.resizePlayer();
            //    }
            //    vm.allowLeavePage = true;
            //    setTimeout(() => {
            //      router.push("/sessions");
            //    }, 2000);
            //  }
            //  //else {
            //  //	location.reload();
            //  //}
            //}
            let timerVal = vm.formatTimeForClock(sessionEndsIn, backStageFlag);
            $("#sessionEndCountdown").html(timerVal);
            if (
              vm.newDesign &&
              typeof vm.livePlayer.displayTimer == "function"
            ) {
              vm.livePlayer.displayTimer(
                true,
                vm.sessionTimeCounterLabel,
                timerVal,
                sessionEndsIn
              );
            }
            //if (sessionEndsIn == 1) {
            //  vm.stopLivePlayer();
            //}
            vm.prevSessionRunning = true;
          } else if (vm.prevSessionRunning) {
            if (vm.selectedSessionTypeId == 5) {
              vm.initLiveStage();
            } else {
              vm.sessionTimeExceeded = true;
              ////if (vm.exPageId == "sn") {
              if (
                vm.selectedSessionTypeId == 1 ||
                vm.selectedSessionTypeId == 2
              ) {
                //alert("sessionTypeId:" + vm.selectedSessionTypeId);
                //vm.goToNextSession = true;
                vm.hideContinueNotificationClicked = true;
                //router.push(vm.stageurl);
                vm.exPageId = "";
                vm.exSessionId = "";
                vm.stopVideoPlayer();
                vm.initLiveStage();
              } else {
                if (!vm.callStarted && !vm.callSwitchingInProcess) {
                  vm.exPageId = "";
                  vm.exSessionId = "";
                  vm.initLiveStage();
                } else {
                  //alert("sessionTypeId+" + vm.selectedSessionTypeId);
                  if (
                    !vm.hideContinueNotificationClicked &&
                    !vm.displayContinueNotification
                  ) {
                    //vm.showContinueNotification();
                  }
                  let sessionEndsIn = vm.selectedSession.EndTimeS - currentTime;

                  let timerVal = vm.formatTimeForClock(
                    sessionEndsIn,
                    backStageFlag
                  );
                  $("#sessionEndCountdown").html(timerVal);
                  if (
                    vm.newDesign &&
                    typeof vm.livePlayer.displayTimer == "function"
                  ) {
                    vm.livePlayer.displayTimer(
                      true,
                      vm.sessionTimeCounterLabel,
                      timerVal,
                      sessionEndsIn
                    );
                  }
                }
              }
            }
          } else {
            vm.initLiveStage();
            //$("#divCountdownContainer").hide();
            //vm.displayCurrentSessionList();
          }
        } else {
          //alert("sessionEndCountdown");
          $("#sessionEndCountdown").html("");
        }
      }, 1000);
    },
    initCurrentSessionListener() {
      if (currentSessionListener) {
        currentSessionListener();
      }
      if (currentSessionParticipancesListener) {
        currentSessionParticipancesListener();
      }
      if (currentRTListener) {
        currentRTListener();
      }

      if (vm.selectedSessionId != "") {
        let firstLoad = true;
        currentSessionListener = db
          .collection(vm.event_collectionName)
          .doc("SessionList")
          .collection("Sessions")
          .doc(vm.selectedSessionId)
          .onSnapshot((doc) => {
            var data = doc.data();
            let sessions = vm.sessionList.filter(function (item) {
              return item.SessionId == vm.selectedSessionId;
            });
            if (sessions.length > 0) {
              let session = sessions[0];
              let muteAllRequest = data.MuteRequest ? data.MuteRequest : 0;
              let unmuteAllRequest = data.UnmuteRequest
                ? data.UnmuteRequest
                : 0;
              let spotlightRequest = data.SpotlightRequest
                ? data.SpotlightRequest
                : 0;
              let spotlightId = data.SpotlightId ? data.SpotlightId : 0;
              if (firstLoad) {
                vm.muteAllRequest = muteAllRequest;
                vm.unmuteAllRequest = unmuteAllRequest;
                vm.spotlightRequest = spotlightRequest;
                firstLoad = false;
              } else {
                session.SessionTypeDetails = data.SessionTypeDetails;
                session.Description = data.Description ? data.Description : "";
                session.DescriptionShort = data.DescriptionShort
                  ? data.DescriptionShort
                  : "";
                if (data.MappedSpeakers && data.MappedSpeakers.length > 1) {
                  session.MappedSpeakers = data.MappedSpeakers;
                } else {
                  session.MappedSpeakers = [];
                }
                if (data.MappedHosts && data.MappedHosts.length > 1) {
                  session.MappedHosts = [data.MappedHosts[0]];
                } else {
                  session.MappedHosts = [];
                }
                if (data.MappedCoHost) {
                  session.MappedCoHosts = [data.MappedCoHost];
                } else {
                  session.MappedCoHosts = [];
                }

                session.SpeakerLength = session.MappedSpeakers.length;

                session.MappedHosts.forEach(function (item) {
                  if (!item.ProfilePictureURL) {
                    item.ProfilePictureURL = "";
                  }
                  item.NameInitial = common.getInitials(item.Name);
                });
                session.MappedCoHosts.forEach(function (item) {
                  if (!item.ProfilePictureURL) {
                    item.ProfilePictureURL = "";
                  }
                  item.NameInitial = common.getInitials(item.Name);
                });
                session.MappedSpeakers.forEach(function (item) {
                  if (!item.ProfilePictureURL) {
                    item.ProfilePictureURL = "";
                  }
                  item.NameInitial = common.getInitials(item.Name);
                });
                session.ZoomRTMPStarted = data.ZoomRTMPStarted
                  ? data.ZoomRTMPStarted
                  : false;
                vm.livePlayer.updateSessionSpeakers(session);
                if (muteAllRequest > vm.muteAllRequest) {
                  vm.muteAllRequest = muteAllRequest;
                  if (data.ForceMute != undefined) {
                    if (data.RequestedBy != vm.uid) {
                      vm.livePlayer.forceMuteSpeaker(
                        data.RequestedBy,
                        0,
                        data.ForceMute
                      );
                    }
                  }
                } else if (unmuteAllRequest > vm.unmuteAllRequest) {
                  vm.muteAllRequest = muteAllRequest;
                  if (data.RequestedBy != vm.uid) {
                    vm.livePlayer.forceMuteSpeaker(data.RequestedBy, 1);
                  }
                } else if (spotlightRequest > vm.spotlightRequest) {
                  vm.spotlightRequest = spotlightRequest;
                  //if (data.RequestedBy != vm.uid) {
                  vm.livePlayer.forceSpotlight(spotlightId);
                  //}
                }
              }
              let oldEndRequest = 0;
              let newEndRequest = 0;
              let endedBy = 0;
              if (session.EndRequest) {
                oldEndRequest = session.EndRequest;
              }
              if (data.EndRequest) {
                newEndRequest = data.EndRequest;
              }
              if (data.EndedBy) {
                endedBy = data.EndedBy;
              }
              if (newEndRequest > oldEndRequest) {
                session.EndRequest = newEndRequest;
                //if (session.SessionTypeDetails.TypeID == 1) {
                //  //
                //} else if (session.SessionTypeDetails.TypeID == 2) {
                //  //
                //} else if (session.SessionTypeDetails.TypeID == 3) {
                if (endedBy != vm.uid) {
                  console.log("endedByHostPopup");
                  //alert("This meeting has been ended by host");
                  $("#endedByHostPopup").modal({ backdrop: "static" }, "show");
                  setTimeout(() => {
                    $("#endedByHostPopup").modal("hide");
                    vm.stopLivePlayer();
                  }, 5000);
                } else {
                  vm.stopLivePlayer();
                }
                router.push(vm.stageUrl);
                vm.livePlayer.onCallEndedByHost();
                //} else if (session.SessionTypeDetails.TypeID == 4) {
                //  //
                //}
              } else {
                let flag = false;
                if ([1, 2].includes(session.SessionTypeDetails.TypeID)) {
                  if (data.SessionTypeDetails.TypeID == 1) {
                    if (
                      data.SessionTypeDetails.VideoURL !=
                      vm.selectedSession.SessionTypeDetails.VideoURL
                    ) {
                      //vm.stopVideoPlayer();
                      //setTimeout(() => {
                      //  vm.startVideoPlayer();
                      //}, 1000);
                      if (vm.exPageId == "") {
                        flag = true;
                        vm.initLiveStage();
                        //router.push(vm.stageurl);
                      }
                    }
                  } else if (data.SessionTypeDetails.TypeID == 2) {
                    if (
                      data.SessionTypeDetails.LiveStreamURL !=
                      vm.selectedSession.SessionTypeDetails.LiveStreamURL
                    ) {
                      //vm.stopLiveStream();
                      //setTimeout(() => {
                      //  vm.startLiveStream();
                      //}, 1000);
                      if (vm.exPageId == "") {
                        flag = true;
                        vm.initLiveStage();
                        //router.push(vm.stageurl);
                      }
                    }
                  }
                }
                if (!flag) {
                  if (data.SessionTypeDetails) {
                    vm.rightPanel.setupTabs(
                      data.SessionTypeDetails,
                      null,
                      vm.agendaFilterOption,
                      true
                    );
                  }
                }
              }
            }
          });
      }

      if (vm.selectedRoundTableId != "" && vm.selectedRoundTable) {
        let firstLoad = true;
        currentRTListener = db
          .collection(vm.event_collectionName)
          .doc("RoundTableList")
          .collection("RoundTables")
          .doc(vm.selectedRoundTableId)
          .onSnapshot((doc) => {
            var data = doc.data();
            if (vm.selectedRoundTable) {
              let muteAllRequest = data.MuteRequest ? data.MuteRequest : 0;
              let unmuteAllRequest = data.UnmuteRequest
                ? data.UnmuteRequest
                : 0;
              let spotlightRequest = data.SpotlightRequest
                ? data.SpotlightRequest
                : 0;
              let spotlightId = data.SpotlightId ? data.SpotlightId : 0;
              if (firstLoad) {
                vm.muteAllRequest = muteAllRequest;
                vm.unmuteAllRequest = unmuteAllRequest;
                vm.spotlightRequest = spotlightRequest;
                firstLoad = false;
              } else if (muteAllRequest > vm.muteAllRequest) {
                vm.muteAllRequest = muteAllRequest;
                if (data.ForceMute != undefined) {
                  if (data.RequestedBy != vm.uid) {
                    vm.livePlayer.forceMuteSpeaker(
                      data.RequestedBy,
                      0,
                      data.ForceMute
                    );
                  }
                }
              } else if (unmuteAllRequest > vm.unmuteAllRequest) {
                vm.muteAllRequest = muteAllRequest;
                if (data.RequestedBy != vm.uid) {
                  vm.livePlayer.forceMuteSpeaker(data.RequestedBy, 1);
                }
              } else if (spotlightRequest > vm.spotlightRequest) {
                vm.spotlightRequest = spotlightRequest;
                //if (data.RequestedBy != vm.uid) {
                vm.livePlayer.forceSpotlight(spotlightId);
                //}
              }

              let oldEndRequest = 0;
              let newEndRequest = 0;
              let endedBy = 0;
              if (vm.selectedRoundTable.EndRequest) {
                oldEndRequest = vm.selectedRoundTable.EndRequest;
              }
              if (data.EndRequest) {
                newEndRequest = data.EndRequest;
              }
              if (data.EndedBy) {
                endedBy = data.EndedBy;
              }
              if (newEndRequest > oldEndRequest) {
                vm.selectedRoundTable.EndRequest = newEndRequest;
                if (endedBy != vm.uid) {
                  //alert("This meeting has been ended by host");
                  $("#endedByHostPopup").modal({ backdrop: "static" }, "show");
                  setTimeout(() => {
                    $("#endedByHostPopup").modal("hide");
                    vm.stopRoundTable();
                  }, 5000);
                } else {
                  vm.stopRoundTable();
                }
                router.push(vm.stageUrl);
                $("#divRoundTablesContainer").hide();
                vm.livePlayer.onCallEndedByHost();
              }
            }
          });
      }
    },
    iAmInUpcomingSession() {
      let flag = false;
      let currentSessionEndTime = vm.selectedSession.EndTimeS;
      for (var i = 0; i < vm.sessionList.length; i++) {
        let objSession = vm.sessionList[i];
        if (objSession.StartTimeS >= currentSessionEndTime) {
          if (
            objSession.SessionTypeDetails.TypeID !=
            vm.GlobalKeysData.RoundTableTypeID
          ) {
            if (vm.sessionList[i].AttendeeType < 4) {
              flag = true;
              break;
            }
          } else {
            if (vm.sessionList[i].AvailSeatType < 4) {
              flag = true;
              break;
            }
          }
          break;
        }
      }
      return flag;
    },
    tryAutoSwitchSession() {
      //alert("tryAutoSwitchSession");
      var currentTime = parseInt(new Date().getTime() / 1000);
      let currentSessionId = "";
      let currentSession;
      let upcomingSessionCount = 0;

      let upcomingSession = null;
      let backStageFlag = false;
      let onDemandFlag = false;
      vm.sessionList.forEach((objSession) => {
        if (currentSessionId == "") {
          if (vm.exPageId != "" || vm.exSessionId != "") {
            if (
              objSession.SessionTypeDetails.TypeID == 1 &&
              currentTime > objSession.EndTimeS
            ) {
              onDemandFlag = true;
              //alert(onDemandFlag);
            } else if (
              objSession.SessionTypeDetails.TypeID == 3 &&
              currentTime < objSession.StartTimeS
            ) {
              if ([1, 2].includes(objSession.AttendeeType)) {
                backStageFlag = true;
                //alert(backStageFlag);
              }
            }
          }
          // alert(backStageFlag)
          // alert(onDemandFlag)
          //if (
          //  backStageFlag ||
          //  onDemandFlag ||
          //  (currentTime > objSession.StartTimeS &&
          //    (vm.exPageId != "" ||
          //      (vm.exPageId == "" && currentTime < objSession.EndTimeS)))
          //)
          if (
            backStageFlag ||
            onDemandFlag ||
            (currentTime > objSession.StartTimeS &&
              currentTime < objSession.EndTimeS)
          ) {
            currentSessionId = objSession.SessionId;
            currentSession = objSession;
            objSession.IsLive = true;
            objSession.StatusDisplayText = vm.$t("livestage.live");
            objSession.StatusClass = "active-session";
            objSession.LinkClass = "ongoing-status";
          } else {
            if (
              vm.countdownSeconds <= 0 &&
              currentTime < objSession.StartTimeS
            ) {
              vm.upcomingSessionTypeId = objSession.SessionTypeDetails.TypeID;
              vm.countdownSeconds = objSession.StartTimeS - currentTime;
              //alert(vm.countdownSeconds);
            }
            //alert("vm.countdownSeconds:"+vm.countdownSeconds);
          }
        }
      });
      if (vm.upcomingSessionCount > 0 && vm.selectedSessionTypeId == -1) {
        vm.selectedSessionTypeId = 0;
      }
      if (vm.exPageId == "") {
        if (currentSessionId == "") {
          vm.sessionList.forEach((objSession) => {
            if (upcomingSessionCount == 0) {
              //alert("upcomingSessionCount:" + upcomingSessionCount);
              if (currentTime < objSession.StartTimeS) {
                vm.upcomingSessionId = objSession.SessionId;
                upcomingSessionCount++;
                currentTime = objSession.StartTimeS;
              }
            } else {
              //alert("upcomingSessionCount:" + upcomingSessionCount);
              if (
                currentTime == objSession.StartTimeS &&
                currentTime < objSession.EndTimeS
              ) {
                vm.upcomingSessionId = "";
                upcomingSessionCount++;
              }
            }
            if (
              upcomingSession == null &&
              currentTime <= objSession.StartTimeS
            ) {
              //alert("upcomingSession found");
              upcomingSession = objSession;
            }
          });
        }
      }
      let changeUpcomingSessionInfo = false;
      if (upcomingSession == null) {
        vm.upcomingSession = null;
      } else if (vm.upcomingSession == null) {
        vm.upcomingSession = upcomingSession;
        changeUpcomingSessionInfo = true;
      } else if (upcomingSession.SessionId != upcomingSession.SessionId) {
        vm.upcomingSession = upcomingSession;
        changeUpcomingSessionInfo = true;
      }
      if (changeUpcomingSessionInfo == true) {
        // alert(backStageFlag)
        // alert(onDemandFlag)
        if (!backStageFlag && !onDemandFlag) {
          vm.displayTimerSessionInfo(upcomingSession, false);
        }
      }
      //alert("tryAutoSwitchSession:" + currentSessionId);
      //alert("tryAutoSwitchSession:" + vm.selectedSessionId);
      vm.upcomingSessionCount = upcomingSessionCount;
      if (currentSessionId == "") {
        if (vm.selectedSessionId != "") {
          let prevSessionTypeId = vm.selectedSessionTypeId;
          //vm.prevSessionTypeId = vm.selectedSessionTypeId;
          vm.selectedSessionId = "";
          vm.selectedSession = null;
          vm.selectedSessionTypeId = 0;
          vm.switchStage(prevSessionTypeId);
          //this.startVideoPlayer();
        } else if (upcomingSessionCount == 0) {
          //router.push("/sessions");
          let prevSessionTypeId = vm.selectedSessionTypeId;
          //vm.prevSessionTypeId = vm.selectedSessionTypeId;
          vm.selectedSessionId = "";
          vm.selectedSession = null;
          if (vm.exPageId == "sn") {
            //router.push(vm.stageurl);
            vm.exPageId = "";
            vm.exSessionId = "";
            vm.initLiveStage();
          } else {
            vm.selectedSessionTypeId = -1;
            vm.switchStage(prevSessionTypeId);
          }
        }
      } else {
        //alert(vm.selectedSessionId);
        //alert(currentSessionId);
        //$("#divCountdownContainer").hide();
        //vm.displayCurrentSessionList();
        if (vm.selectedSessionId != currentSessionId) {
          vm.selectedSessionId = currentSessionId;
          vm.selectedSession = currentSession;
          //alert("go to meeting");
          //router.push("/meeting");
          let prevSessionTypeId = vm.selectedSessionTypeId;
          //alert(currentSession.SessionTypeDetails.TypeID);
          vm.selectedSessionTypeId = currentSession.SessionTypeDetails.TypeID;
          vm.displayTimerSessionInfo(currentSession, true);
          vm.switchStage(prevSessionTypeId, currentSessionId);

          vm.displayCurrentSessionList();
          //vm.initCurrentSessionTimer();
          //this.startVideoPlayer(currentSession);
        }
      }
    },
    displayTimerSessionInfo(session, isLive) {
      if (session) {
        let sessionCount = vm.getUpcomingSessionCount();
        var currentTime = parseInt(new Date().getTime() / 1000);
        if (sessionCount > 1) {
          $("#hSessionTitle").html("");
          $("#hSessionTrack").html("");
          $("#pHeaderSessionName").html("");
          $("#pHeaderSessionName").attr("attr", "");
          $("#hSessionTime").html("");
          $("#spanSessionType").html("");
          $("#liSessionTypeIcons").hide();
          $("#menuSessionInfo p").html("");

          let sessionHeader = vm.$t("livestage.nextsessionstartsin");
          $("#hSessionHeader").html(sessionHeader);
        } else {
          $("#hSessionTitle").html(session.Name);
          $("#hSessionTrack").html(session.TrackName);
          $("#pHeaderSessionName").html(session.Name);
          $("#pHeaderSessionName").attr("attr", session.Name);
          $("#hSessionTime").html(
            session.StartTimeLabel + " - " + session.EndTimeLabel
          );
          $("#liSessionTypeIcons").show();
          $("#menuSessionInfo p").html(session.Name);
          if (session.SessionTypeDetails.TypeID == 5) {
            let typeLabel = "In-Person";
            if (
              session.SessionTypeDetails.InPersonLabel &&
              session.SessionTypeDetails.InPersonLabel.length > 0
            ) {
              typeLabel = session.SessionTypeDetails.InPersonLabel;
            }
            $("#spanSessionType").html(typeLabel);
            if (
              session.SessionTypeDetails.InPersonIcon &&
              session.SessionTypeDetails.InPersonIcon.length > 0
            ) {
              $("#imgInPersonSessionTypeIcon").attr(
                "src",
                session.SessionTypeDetails.InPersonIcon
              );
            }
            if (
              session.SessionTypeDetails.InPersonURL &&
              session.SessionTypeDetails.InPersonURL.length > 0
            ) {
              vm.InPersonURL = session.SessionTypeDetails.InPersonURL;
            }
          } else {
            $("#spanSessionType").html(session.SessionTypeDetails.TypeName);
          }
          let sessionDurationS = session.StartTimeS - currentTime;
          vm.countdownSeconds = sessionDurationS;
          let sessionHeader = "";
          if (
            session.SessionTypeDetails.TypeID ==
            vm.GlobalKeysData.OnDemandTypeID
          ) {
            sessionHeader = vm.$t("livestage.ondemandstartsin");
          } else if (
            session.SessionTypeDetails.TypeID ==
            vm.GlobalKeysData.LiveStreamTypeID
          ) {
            sessionHeader = vm.$t("livestage.livestreamstartsin");
          } else if (
            session.SessionTypeDetails.TypeID ==
            vm.GlobalKeysData.LivePanelTypeID
          ) {
            sessionHeader = vm.$t("livestage.livepanelstartsin");
          } else if (
            session.SessionTypeDetails.TypeID ==
            vm.GlobalKeysData.RoundTableTypeID
          ) {
            sessionHeader = vm.$t("livestage.roundtablestartsin");
          } else if (
            session.SessionTypeDetails.TypeID ==
            vm.GlobalKeysData.InPersonTypeID
          ) {
            sessionHeader = vm.$t("livestage.sessionstartsin");
          }
          $("#hSessionHeader").html(sessionHeader);
        }
        if (isLive) {
          vm.onUpcommingEnd();
        } else {
          vm.startUpcomingSessionClock();
          vm.onUpcommingStart();
        }
      } else {
        vm.switchStage(0);
      }
    },
    joinInPersonSession(InPersonURL) {
      if (InPersonURL && InPersonURL.startsWith("/")) {
        vm.$router.push(InPersonURL);
      } else {
        window.open(InPersonURL, "_blank");
        vm.postLeaderboardAction("SNVW");
      }
    },
    onUpcommingStart() {
      $("#liProceedManuallyWrap").hide();
      $("#upcomingTimer").removeClass("d-none");
      $("#upcomingTimer").addClass("d-flex");
      //$("#hSessionTitle").hide();
      //$("#hSessionTrack").hide();
      //$("#hSessionTime").hide();
      $("#hSessionHeader").show();
      $("#divCountdownSessionStatus").hide();
    },
    onUpcommingEnd() {
      if (vm.upcomingSessionTypeId == 5 || vm.selectedSessionTypeId == 5) {
        if (vm.InPersonURL.length > 0) {
          $("#liProceedManuallyWrap").show();
        } else {
          $("#liProceedManuallyWrap").hide();
        }
      } else {
        $("#liProceedManuallyWrap").show();
      }
      $("#upcomingTimer").addClass("d-none");
      $("#upcomingTimer").removeClass("d-flex");
      //$("#hSessionTitle").show();
      //$("#hSessionTrack").show();
      //$("#hSessionTime").show();
      $("#hSessionHeader").hide();
      $("#divCountdownSessionStatus").show();
    },
    getCurrentSessionCount() {
      let cTime = parseInt(new Date().getTime() / 1000);
      let result = 0;
      if (
        vm.sessionSettingsLoaded &&
        vm.sessionsLoaded &&
        vm.mySessionsLoaded
      ) {
        vm.sessionList.forEach(function (item) {
          let flag = true;
          if (vm.agendaFilterOption == 1) {
            flag = false;
            if (vm.mySessions.includes(item.SessionId)) {
              flag = true;
            }
          }
          if (flag) {
            if (cTime > item.StartTimeS && cTime < item.EndTimeS) {
              result++;
            }
            //if (item.IsLive) {
            //  result++;
            //}
          }
        });
      }
      //alert("result:" + result);
      return result;
    },
    getUpcomingSessionCount() {
      let sessionId = "";
      let cTime = parseInt(new Date().getTime() / 1000);
      let result = 0;
      if (
        vm.sessionSettingsLoaded &&
        vm.sessionsLoaded &&
        vm.mySessionsLoaded
      ) {
        vm.sessionList.forEach(function (item) {
          let flag = true;
          if (vm.agendaFilterOption == 1) {
            flag = false;
            if (vm.mySessions.includes(item.SessionId)) {
              flag = true;
            }
          }
          if (flag) {
            if (sessionId == "") {
              if (item.StartTimeS > cTime) {
                result++;
                cTime = item.StartTimeS;
                sessionId = item.SessionId;
              }
            } else {
              if (cTime == item.StartTimeS) {
                result++;
              }
            }
          }
        });
      }
      //alert("result:" + result);
      return result;
    },
    switchStage(prevSessionTypeId, currentSessionId) {
      //$("#hSessionTitle").html("");
      //$("#hSessionTrack").html("");
      //$("#hSessionTime").html("");
      //$("#pHeaderSessionName").html("");
      //$("#pHeaderSessionName").attr("title", "");
      //$('[data-toggle="tooltip"]').tooltip();
      //console.log("prevSessionTypeId: " + vm.prevSessionTypeId);
      console.log("currentSessionId: " + currentSessionId);
      if (prevSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
        vm.stopVideoPlayer();
        vm.initLiveStage();
        return;
      } else if (prevSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID) {
        vm.stopLiveStream();
        vm.initLiveStage();
        return;
      } else if (prevSessionTypeId == vm.GlobalKeysData.LivePanelTypeID) {
        vm.stopLivePlayer();
        vm.initLiveStage();
        return;
      } else if (prevSessionTypeId == vm.GlobalKeysData.RoundTableTypeID) {
        vm.stopRoundTable();
        vm.initLiveStage();
        return;
      }
      if (vm.upcomingSessionCount == 0 && vm.selectedSession == null) {
        //router.push("/sessions");
        vm.selectedSessionTypeId = -1;
        //vm.initLiveStage();
        if (this.isMaximized) {
          //vm.resizePlayer();
        }
        //return;
      }
      //alert("selectedSessionTypeId: " + vm.selectedSessionTypeId);
      if (vm.selectedSessionTypeId != -1) {
        $("#divCountdownContainer").show();
      }
      if (vm.selectedSession == undefined || vm.selectedSession == null) {
        $("#sessionEndCountdown").hide();
      } else {
        $("#sessionEndCountdown").show();
      }

      $("#divLiveVideoContainer").hide();
      $("#divLiveStreamContainer").hide();
      $("#divLivePanelContainer").hide();
      $("#divLivePanelContainer").addClass("d-none");
      $("#divRoundTablesContainer").hide();
      $("#divRoundTablesContainer").removeClass("multi-session-popup");
      //$("#divSessionEndedContainer").hide();
      if (vm.selectedSessionTypeId > 0) {
        $("#divCountdownContainer").hide();
        let sessions = vm.sessionList.filter(function (item) {
          return item.SessionId == vm.exSessionId;
        });
        if (sessions.length == 1) {
          vm.autoJoinSession = true;
        } else {
          sessions = vm.currentSessions;
          if (sessions.length == 1) {
            vm.autoJoinSession = true;
          }
        }
        if (vm.autoJoinSession && !vm.IsManuallyStopped) {
          if (
            sessions[0].SessionTypeDetails.TypeID !=
            vm.GlobalKeysData.InPersonTypeID
          ) {
            if (
              sessions[0].IsZoomRTMP &&
              vm.IsZoomRTMPOptionsEnabled
              //&& (vm.sessionList[0].IsHost || vm.sessionList[0].IsSpeaker)
            ) {
              if (vm.exPageId == "sn") {
                vm.onStartSession(sessions[0].SessionId);
              } else {
                $("#divSessionsContainer").show();
              }
            } else {
              if (sessions[0].SessionTypeDetails.TypeID == 2) {
                setTimeout(() => {
                  vm.startSession(sessions[0].SessionId);
                }, 3000);
              } else {
                vm.startSession(sessions[0].SessionId);
              }
            }
          } else {
            $("#divSessionsContainer").show();
          }
          //alert(vm.sessionList.length);
        } else {
          //if (currentSessionId && !vm.IsManuallyStopped) {
          //  vm.startSession(currentSessionId);
          //} else {
          $("#divSessionsContainer").show();
          //}
        }
        vm.autoJoinSession = false;
        vm.IsManuallyStopped = false;
        return;
      }
      vm.autoJoinSession = false;
      vm.IsManuallyStopped = false;
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
        $("#divCountdownContainer").hide();
        $("#divLiveVideoContainer").show();
        //$("#hSessionTitle").html(vm.selectedSession.Name);
        //$("#pHeaderSessionName").html(vm.selectedSession.Name);
        //$("#pHeaderSessionName").attr("title", vm.selectedSession.Name);
        vm.startVideoPlayer();
      } else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID
      ) {
        $("#divCountdownContainer").hide();
        $("#divLiveStreamContainer").show();
        //$("#pHeaderSessionName").html(vm.selectedSession.Name);
        //$("#pHeaderSessionName").attr("title", vm.selectedSession.Name);
        vm.startLiveStream();
      } else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.LivePanelTypeID
      ) {
        $("#divCountdownContainer").hide();
        $("#divLivePanelContainer").show();
        $("#divLivePanelContainer").removeClass("d-none");
        //$("#pHeaderSessionName").html(vm.selectedSession.Name);
        //$("#pHeaderSessionName").attr("title", vm.selectedSession.Name);
        vm.startLivePanel();
      } else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID
      ) {
        $("#divCountdownContainer").hide();
        $("#divRoundTablesContainer").show();
        //$("#pHeaderSessionName").html(vm.selectedSession.Name);
        //$("#pHeaderSessionName").attr("title", vm.selectedSession.Name);
        vm.displayRoundTables();
      } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.InPersonTypeID) {
        vm.startInPersonSession(1);
      } else if (vm.selectedSessionTypeId == -1) {
        //vm.sessionsLoaded = true;
        $("#divCountdownContainer").hide();
        //$("#divSessionEndedContainer").show();
        //$("#hSessionEndedText").html("No more Active Sessions in Live Stage");
        //$("#pHeaderSessionName").html(vm.selectedSession.Name);
        //$("#pHeaderSessionName").attr("title", vm.selectedSession.Name);
        //$("#hSessionEndedLink").html("Click Here");
        //alert("switchStage: prevSessionTypeId: " + vm.prevSessionTypeId);
        //if (vm.prevSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
        //  vm.stopVideoPlayer();
        //} else if (vm.prevSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID) {
        //  vm.stopLiveStream();
        //} else if (vm.prevSessionTypeId == vm.GlobalKeysData.LivePanelTypeID) {
        //  vm.stopLivePlayer();
        //} else if (vm.prevSessionTypeId == vm.GlobalKeysData.RoundTableTypeID) {
        //  vm.stopRoundTable();
        //}
      }
      //$('[data-toggle="tooltip"]').tooltip();
      //OnDemandTypeID: 1,
      //LiveStreamTypeID: 2,
      //LivePanelTypeID: 3,
      //RoundTableTypeID: 4,
    },
    startInPersonSession(option) {
      vm.stopVideoPlayer();
      vm.stopLiveStream();
      vm.stopLivePlayer();
      setTimeout(() => {
        if (option == 0) {
          vm.selectedSessionTypeId = vm.upcomingSessionTypeId;
          vm.selectedSession = vm.upcomingSession;
          vm.selectedSessionId = vm.upcomingSession.SessionId;
          //alert(vm.selectedSession);
          //alert(vm.selectedSessionId);
          //alert(vm.selectedSessionTypeId);
        }
        $("#sessionEndCountdown").show();
        vm.initCurrentSessionTimer();

        vm.applyPlayerBroadcastSettings(
          vm.GlobalKeysData.InPersonTypeID,
          vm.selectedSession.SessionId,
          ""
        );
        vm.SessionLogo = vm.selectedSession.Logo;
        vm.SessionLogoLink = vm.selectedSession.LogoLink;

        vm.callStarted = true;
        //vm.setupRightPanel(
        //  vm.uid,
        //  vm.selectedSession.AttendeeType,
        //  vm.livePlayerChannel,
        //  vm.GlobalKeysData.InPersonTypeID,
        //  vm.speakerProfiles,
        //  vm.selectedSession
        //);
        vm.rightPanelVisible = false;
        vm.joinSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
        vm.initSessionJoinLeaveListener(vm.selectedSessionId);
        vm.currentStage = 2;
        vm.startKeepMeActiveInSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
      }, 3000);
    },
    formatTimeForClock(seconds, backStageFlag) {
      let isNegetive = false;
      if (seconds < 0) {
        isNegetive = true;
        seconds = seconds * -1;
      }
      let formattedVal = "";
      let tempVal = seconds % 60;
      formattedVal =
        tempVal < 10 ? "0" + tempVal.toString() : tempVal.toString();

      seconds = parseInt((seconds - tempVal) / 60);
      tempVal = seconds % 60;
      formattedVal =
        (tempVal < 10 ? "0" + tempVal.toString() : tempVal.toString()) +
        ":" +
        formattedVal;

      seconds = parseInt((seconds - tempVal) / 60);
      tempVal = seconds % 24;
      if (tempVal > 0) {
        formattedVal = tempVal.toString() + ":" + formattedVal;
      }

      tempVal = parseInt((seconds - tempVal) / 24);
      if (tempVal > 0) {
        formattedVal =
          tempVal.toString() +
          (tempVal > 1 ? " Days " : " Day ") +
          formattedVal;
        seconds = parseInt((seconds - tempVal) / 24);
      }
      if (backStageFlag) {
        if (isNegetive) {
          vm.sessionTimeCounterLabel = vm.backStageTimeExceedsByLabel;
          formattedVal += " " + vm.backStageTimeExceedsBySuffix;
        } else {
          vm.sessionTimeCounterLabel = vm.backStageTimeEndsInLabel;
        }
      } else {
        if (isNegetive) {
          vm.sessionTimeCounterLabel = vm.sessionTimeExceedsByLabel;
        } else {
          vm.sessionTimeCounterLabel = vm.sessionTimeEndsInLabel;
        }
      }
      return formattedVal;
    },
    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      return formattedtime;
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              vm.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                vm.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          vm.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            vm.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      vm.AddAnalitics(event, "click");
      vm.LeftSectionClicked();
    },
    LeftSectionClicked() {
      //Close RightPanel
    },
    //onResizePlayer(isManual) {
    //  //if (vm.exStageUrl) {
    //  //  vm.$emit("onResizeStage", isManual, vm.isMaximized);
    //  //} //else {
    //  vm.resizePlayer(isManual);
    //  //}
    //},
    resizePlayer(isManual) {
      //alert("resizePlayer:" + !vm.isMaximized);
      if (!isManual) {
        isManual = false;
      }
      if (vm.exStageUrl) {
        vm.$emit("onResizeStage", isManual, !vm.isMaximized);
      }

      if (vm.isMaximized) {
        ////if (isManual) {
        vm.isMaximized = false;
        vm.AdjustPlayeHeight();
        vm.closeFullscreen();
        //}
      } else {
        vm.isMaximized = true;
        vm.AdjustPlayeHeight();
        if (isManual) {
          vm.openFullscreen();
        }
      }
      //vm.IsFullScreenCurrently();
      if (vm.selectedSessionTypeId == 1) {
        vm.videoPlayerEmbeded.startEmbed();
      } else if (vm.selectedSessionTypeId == 2) {
        vm.streamPlayerEmbeded.startEmbed();
      }
    },
    exitFullScreenHandler() {
      if (
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement !== null
      ) {
        if (vm.isMaximized) {
          vm.resizePlayer();
        }
      }
    },
    openFullscreen() {
      let elem = document.getElementById("vueplayer");
      ///let elem = document.getElementById("LiveStage");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    IsFullScreenCurrently() {
      var full_screen_element =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement ||
        null;

      // If no element is in full-screen
      if (full_screen_element === null) {
        //alert("FULL SCREEN");
        return false;
      } else {
        //alert("SCREEN");
        return true;
      }
    },
    AdjustPlayeHeight() {
      if (!vm.isMaximized) {
        $("#app").removeClass("player-full-screen");
        if ($("#topmenu")) {
          $("#topmenu").removeClass("d-none");
        }
        if ($("#leftMenuParent")) {
          if (!vm.exStageUrl) {
            $("#leftMenuParent").removeClass("d-none");
          }
        }
        if ($("#leftmenu")) {
          if (!vm.exStageUrl) {
            $("#leftmenu").hide();
          }
        }
      } else {
        if ($("#topmenu")) {
          $("#topmenu").addClass("d-none");
        }
        $("#app").addClass("player-full-screen");
        if ($("#leftMenuParent")) {
          if (!vm.exStageUrl) {
            $("#leftMenuParent").addClass("d-none");
          }
        }
        if ($("#leftmenu")) {
          if (!vm.exStageUrl) {
            $("#leftmenu").hide();
          }
        }
      }
    },
    closeEndeRequestPopup() {
      $("#endedRequestPopup").modal("hide");
    },
    closeEndedByHostPopup() {
      $("#endedByHostPopup").modal("hide");
      if (vm.selectedSessionTypeId == 1) {
        //
      } else if (vm.selectedSessionTypeId == 2) {
        //
      } else if (vm.selectedSessionTypeId == 3) {
        vm.stopLivePlayer();
      } else if (vm.selectedSessionTypeId == 4) {
        vm.stopRoundTable();
      } else if (vm.selectedRoundTableId != "" && vm.selectedRoundTable) {
        vm.stopRoundTable();
      }
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal({ backdrop: "static" }, "show");
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (vm.retryType == "sn") {
        vm.startLivePanel();
      } else if (vm.retryType == "rtmp") {
        if (vm.tempSessionId && vm.tempAction) {
          vm.rtmpActions(vm.tempSessionId, vm.tempAction);
        }
      } else if (vm.retryType == "rt") {
        if (vm.tempTableId) {
          vm.startRoundTable(vm.tempTableId);
        }
      } else if (vm.retryType == "o2o") {
        vm.startOneToOneMeeting();
      }
    },
    startLivePanel() {
      console.log();
      //alert("" + vm.selectedSessionId);
      //alert("" + vm.selectedSessionTypeId);
      //alert("" + vm.upcomingSessionTypeId);
      vm.recordingStarted = false;
      if (
        vm.selectedSession.StreamingClient &&
        vm.selectedSession.StreamingClient.trim().toLowerCase() == "zoom"
      ) {
        vm.retryType = "sn";
        vm.displayCountdownTimer = false;
        vm.onUpcommingEnd();
        if (
          vm.selectedSession.Zoom_Detail &&
          vm.selectedSession.Zoom_Detail.id
        ) {
          var hostList = [];
          var speakerList = [];

          vm.selectedSession.MappedHosts.map(function (value) {
            hostList.push(value.AttendeeId);
          });

          vm.selectedSession.MappedSpeakers.map(function (value) {
            speakerList.push(value.AttendeeId);
          });

          if (hostList.indexOf(vm.uid) > -1) {
            if (vm.selectedSession.IsZoomRTMP && vm.IsZoomRTMPOptionsEnabled) {
              vm.StartZoomRTMPForAttendee(
                vm.selectedSession.ZoomRTMPMUX_detail
              );
            } else {
              window.open(vm.selectedSession.Zoom_Detail.start_url, "_blank");
              vm.postLeaderboardAction("SNVW");
            }
          } else if (speakerList.indexOf(vm.uid) > -1) {
            if (vm.selectedSession.IsZoomRTMP) {
              if (vm.IsZoomRTMPOptionsEnabled) {
                vm.StartZoomRTMPForAttendee(
                  vm.selectedSession.ZoomRTMPMUX_detail
                );
              } else {
                if (
                  vm.selectedSession.Zoom_Detail &&
                  vm.selectedSession.Zoom_Detail.join_url
                ) {
                  let headers = {
                    Authorization: "Bearer " + vm.getSessionToken(),
                    "content-type": "application/json",
                  };
                  let requestData = {
                    email: vm.email,
                    name: vm.name,
                    first_name: vm.firstName,
                    last_name: vm.lastName,
                    webinarid: vm.selectedSession.Zoom_Detail.id,
                    meeting_type: "webinar",
                    make_speaker: true,
                    //address: "",
                    //phone: vm.phone,
                    //industry: "",
                    //org: vm.company,
                    //job_title: vm.title,
                  };
                  axios
                    .post(APIs.AddAttendeesToZoom, requestData, {
                      headers: headers,
                    })
                    .then((response) => {
                      vm.hideLoader();
                      if (
                        response &&
                        response.data &&
                        response.data.status == 0 &&
                        response.data.data.id &&
                        response.data.data.join_url &&
                        response.data.data.join_url != ""
                      ) {
                        window.open(response.data.data.join_url, "_blank");
                        vm.postLeaderboardAction("SNVW");
                        //var link =
                        //  vm.selectedSession.Zoom_Detail.join_url +
                        //  "&uname=" +
                        //  vm.firstName.trim() +
                        //  "%20" +
                        //  vm.lastName.trim();
                        //window.open(link, "_blank");
                        //vm.postLeaderboardAction("SNVW");
                      } else {
                        vm.retryJoinInZoomPopup();
                      }
                    })
                    .catch((error) => {
                      vm.hideLoader();
                      console.log(error);
                      vm.retryJoinInZoomPopup();
                    });
                } else {
                  alert(vm.zoomErrorMsg);
                }
              }
              //if (
              //  vm.selectedSession.Zoom_Detail &&
              //  vm.selectedSession.Zoom_Detail.join_url
              //) {
              //  vm.rtmpActions(0, vm.selectedSession.SessionId);
              //} else {
              //  alert(vm.zoomErrorMsg);
              //}
            } else {
              vm.showLoader();

              let headers = {
                Authorization: "Bearer " + vm.getSessionToken(),
                "content-type": "application/json",
              };
              let requestData = {
                email: vm.email,
                name: vm.name,
                first_name: vm.firstName,
                last_name: vm.lastName,
                webinarid: vm.selectedSession.Zoom_Detail.id,
                meeting_type: "webinar",
                make_speaker: true,
                //address: "",
                //phone: vm.phone,
                //industry: "",
                //org: vm.company,
                //job_title: vm.title,
              };
              axios
                .post(APIs.AddAttendeesToZoom, requestData, {
                  headers: headers,
                })
                .then((response) => {
                  vm.hideLoader();
                  if (
                    response &&
                    response.data &&
                    response.data.status == 0 &&
                    response.data.data.id &&
                    response.data.data.join_url &&
                    response.data.data.join_url != ""
                  ) {
                    window.open(response.data.data.join_url, "_blank");
                    vm.postLeaderboardAction("SNVW");
                    //window.open(response.data.join_url, "_blank");

                    //let headers = {
                    //  Authorization: "Bearer " + vm.getSessionToken(),
                    //  "content-type": "application/json",
                    //};
                    //let requestData = {
                    //  email: vm.email,
                    //  name: vm.firstName + " " + vm.lastName,
                    //  webinarid: vm.selectedSession.Zoom_Detail.id,
                    //};
                    //axios
                    //  .post(APIs.AddSpeakersToZoom, requestData, {
                    //    headers: headers,
                    //  })
                    //  .then((response1) => {
                    //    if (response1.data && response1.data.id) {
                    //      window.open(response.data.join_url, "_blank");
                    //      vm.postLeaderboardAction("SNVW");
                    //    } else {
                    //      //alert(vm.zoomErrorMsg);
                    //      vm.retryJoinInZoomPopup();
                    //    }
                    //    vm.hideLoader();
                    //  })
                    //  .catch(function (error) {
                    //    console.error("addspeakers: ", error);
                    //    //alert(vm.zoomErrorMsg);
                    //    vm.hideLoader();
                    //    vm.retryJoinInZoomPopup();
                    //  });
                  } else {
                    //alert(vm.zoomErrorMsg);
                    vm.retryJoinInZoomPopup();
                  }
                })
                .catch(function (error) {
                  console.error("addattendees: ", error);
                  //alert(vm.zoomErrorMsg);
                  vm.hideLoader();
                  vm.retryJoinInZoomPopup();
                });
            }
          } else {
            if (vm.selectedSession.IsZoomRTMP) {
              //$("#divSessionsContainer").hide();
              vm.StartZoomRTMPForAttendee(
                vm.selectedSession.ZoomRTMPMUX_detail
              );
              //$("#divSessionsContainer").hide();
              //vm.rtmpActions(0, vm.selectedSession.SessionId);
            } else {
              let headers = {
                Authorization: "Bearer " + vm.getSessionToken(),
                "content-type": "application/json",
              };
              let requestData = {
                email: vm.email,
                name: vm.name,
                first_name: vm.firstName,
                last_name: vm.lastName,
                webinarid: vm.selectedSession.Zoom_Detail.id,
                meeting_type: "webinar",
                make_speaker: false,
                //address: "",
                //phone: vm.phone,
                //industry: "",
                //org: vm.company,
                //job_title: vm.title,
              };
              axios
                .post(APIs.AddAttendeesToZoom, requestData, {
                  headers: headers,
                })
                .then((response) => {
                  vm.hideLoader();
                  if (
                    response &&
                    response.data &&
                    response.data.status == 0 &&
                    response.data.data.id &&
                    response.data.data.join_url &&
                    response.data.data.join_url != ""
                  ) {
                    window.open(response.data.data.join_url, "_blank");
                    vm.postLeaderboardAction("SNVW");
                  } else {
                    //alert(vm.zoomErrorMsg);
                    vm.retryJoinInZoomPopup();
                  }
                })
                .catch(function (error) {
                  console.error("addattendees: ", error);
                  //alert(vm.zoomErrorMsg);
                  vm.hideLoader();
                  vm.retryJoinInZoomPopup();
                });
            }
          }
        } else {
          //alert(vm.zoomErrorMsg);
          vm.hideLoader();
          vm.retryJoinInZoomPopup();
        }
      } else {
        //var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // if (
        //   screen.width < 767 &&
        //   obj.AgoraPlayerBrowserSupportInMobile == false
        // ) {
        //   vm.allowLeavePage = true;
        //   router.push("/screeninfo");
        // } else if (
        //   screen.width >= 768 &&
        //   screen.width <= 1024 &&
        //   obj.AgoraPlayerBrowserSupportInIPad == false
        // ) {
        //   vm.allowLeavePage = true;
        //   router.push("/screeninfo");
        // } else {
          vm.stopVideoPlayer();
          vm.stopLiveStream();
          //alert(vm.clientId);
          //alert(obj.eventid);
          vm.IsBackStage = false;
          if (vm.selectedSession) {
            if (
              vm.selectedSession.StartTimeS >
              parseInt(new Date().getTime() / 1000)
            ) {
              vm.IsBackStage = true;
            }
          }
          vm.initCurrentSessionTimer();
          vm.livePlayerChannel = vm.getChannelName();
          //alert("startLivePanel: " + vm.livePlayerChannel);
          vm.applyPlayerBroadcastSettings(
            vm.GlobalKeysData.LivePanelTypeID,
            vm.selectedSession.SessionId,
            ""
          );
          vm.SessionLogo = vm.selectedSession.Logo;
          vm.SessionLogoLink = vm.selectedSession.LogoLink;

          let playerLogo = vm.currentPlayerLogo();
          let playerLogoLink = vm.currentPlayerLogoLink();
          vm.livePlayer.StartCall(
            vm.clientId,
            vm.eventId,
            vm.livePlayerChannel,
            vm.GlobalKeysData.LivePanelTypeID,
            vm.selectedSession,
            null,
            null,
            vm.selectedSession.AttendeeType,
            {
              AutoStartRecording: vm.AutoStartRecording,
              playerLogo: playerLogo,
              playerLogoLink: playerLogoLink,
            }
          );
          $("#divSessionsContainer").hide();
          $("#divLivePanelContainer").show();
          $("#divLivePanelContainer").removeClass("d-none");
          vm.callStarted = true;
          //vm.setupRightPanel(vm.uid, 3, vm.livePlayerChannel);
          vm.setupRightPanel(
            vm.uid,
            vm.selectedSession.AttendeeType,
            vm.livePlayerChannel,
            vm.GlobalKeysData.LivePanelTypeID,
            vm.speakerProfiles,
            vm.selectedSession
          );
          vm.joinSession(
            vm.selectedSessionId,
            vm.uid,
            vm.selectedSession.AttendeeType
          );
          vm.initSessionJoinLeaveListener(vm.selectedSessionId);
          vm.currentStage = 2;
          vm.startKeepMeActiveInSession(
            vm.selectedSessionId,
            vm.uid,
            vm.selectedSession.AttendeeType
          );
        // }
      }
    },
    stopLivePlayer() {
      vm.livePlayer.onEndCall();
      vm.hideRightPanel();
      vm.leaveSession(vm.selectedSessionId, vm.uid);
      vm.stopKeepMeActiveInSession();
    },
    StartZoomRTMPForAttendee(ZoomRTMPMUX_detail) {
      if (retryPlayStreamTimer) {
        clearInterval(retryPlayStreamTimer);
      }
      console.log(ZoomRTMPMUX_detail);
      if (
        ZoomRTMPMUX_detail &&
        ZoomRTMPMUX_detail.data &&
        ZoomRTMPMUX_detail.data.playbackUrl
      ) {
        vm.rtmpDialog.sessionId = vm.selectedSessionId;
        vm.rtmpDialog.session = vm.selectedSession;
        $("#divSessionsContainer").hide();
        $("#divLivePanelContainer").hide();
        $("#divLivePanelContainer").addClass("d-none");
        $("#divLiveStreamContainer").show();
        //vm.stopVideoPlayer();
        vm.initCurrentSessionTimer();
        vm.livePlayerChannel = vm.getChannelName();
        vm.applyPlayerBroadcastSettings(
          vm.GlobalKeysData.LivePanelTypeID,
          vm.selectedSessionId,
          vm.selectedRoundTableId,
          true
        );
        vm.streamPlayerOptions.controls == false;
        vm.playStream(ZoomRTMPMUX_detail.data.playbackUrl, 0);
        $("#divCountdownContainer").hide();
        vm.callStarted = true;
        vm.setupRightPanel(
          vm.uid,
          vm.selectedSession.AttendeeType,
          vm.livePlayerChannel,
          vm.GlobalKeysData.LivePanelTypeID,
          vm.speakerProfiles,
          vm.selectedSession,
          undefined,
          undefined,
          undefined,
          "",
          "",
          true
        );
        vm.joinSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
        vm.initSessionJoinLeaveListener(vm.selectedSessionId);
        vm.currentStage = 2;
        vm.startKeepMeActiveInSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
        if (
          vm.selectedSession &&
          vm.selectedSession.SessionTypeDetails &&
          vm.selectedSession.SessionTypeDetails.AudiencePoll
        ) {
          vm.rightPanel.startPoll();
        }
      }
    },
    startKeepMeActiveInSession(sessionId, attendeeId, attendeeType) {
      if (scheduleSessionTimer) {
        clearInterval(scheduleSessionTimer);
      }
      //alert(vm.heartBitInterval);
      if (vm.sendLiveHeartBit) {
        scheduleSessionTimer = setInterval(function () {
          //alert(attendeeType);
          vm.keepMeActiveInSession(sessionId, attendeeId, attendeeType);
        }, vm.heartBitInterval * 1000);
      }
    },
    stopKeepMeActiveInSession() {
      if (scheduleSessionTimer) {
        clearInterval(scheduleSessionTimer);
      }
    },
    startKeepMeActiveInRoundTable(tableId, attendeeId, availSeatType) {
      if (scheduleRTTimer) {
        clearInterval(scheduleRTTimer);
      }
      //alert(vm.heartBitInterval);
      if (vm.sendLiveHeartBit) {
        scheduleRTTimer = setInterval(function () {
          //alert(vm.selectedRoundTable.AvailSeatType);
          //alert(tableId);
          //alert(attendeeId);
          vm.keepMeActiveInRoundTable(tableId, attendeeId, availSeatType);
        }, vm.heartBitInterval * 1000);
      }
    },
    stopKeepMeActiveInRoundTable() {
      if (scheduleRTTimer) {
        clearInterval(scheduleRTTimer);
      }
    },
    //VIDEO PLAYER START
    onVideoPlayerVolumeChange(player) {
      console.log("video player volume changed!", player);
      //////let volumeLevel = parseFloat(player.techGet_("volume"));
      //////volumeLevel = isNaN(volumeLevel) ? 1 : volumeLevel;
      //////vm.volumeLevel = parseInt(volumeLevel * 100);
      //////vm.muted = player.muted();

      //if (player.muted()) {
      //  vm.volumeLevel = 0;
      //}
      //alert(vm.volumeLevel);
    },
    onVideoPlayerPlay(player) {
      //////player.muted(vm.muted);
      console.log("video player play!", player);
      //player.usingNativeControls_ = false;
      //player.removeTechControlsListeners_();
      //this.removeClass("vjs-using-native-controls");
    },
    onVideoPlayerReady(player) {
      //alert("onVideoPlayerReady");
      //alert($(window).findControl("vjs_video_3"));
      //alert($(window).querySelector("#ag-canvas"));
      console.log("player ready!", player);
      //vm.player.usingNativeControls_ = false;
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeClass("vjs-using-native-controls");
      //vm.player.techCall_("setPlaysinline", false);
      //if (vm.player.tech_) {
      //  vm.player.techCall_("setAutoplay", false);
      //}
      //controls autoplay muted aspectRatio allow="autoplay; fullscreen"
      //setTimeout(() => {
      //  //alert();
      //  //vm.player.autoplay(true);
      //  //vm.player.trigger("loadstart");
      //  //vm.player.trigger("firstplay");
      //  //vm.player.manualAutoplay_(vm.player.autoplay());
      //  //vm.player.options_.autoplay = true;
      //  //let promise;
      //  // if muted defaults to true
      //  // the only thing we can do is call play
      //  //promise = vm.player.play();
      //  //promise.catch(false);
      //  vm.player.play();
      //}, 5000);
      player.play();
      setTimeout(() => {
        vm.addVideoPlayerComponent("divLiveVideoContainer");
      }, 5000);
    },
    playVideo: function (source, timeElapsed) {
      console.log(source);
      console.log(timeElapsed);
      //console.log("vm.videoPlayer - before:" + vm.videoPlayer);
      vm.streamPlayer.reset();
      vm.videoPlayer.reset(); // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
      var type = "application/x-mpegurl";
      if (typeof source == "string") {
        //alert("string");
        if (source.toLowerCase().endsWith(".mp4")) {
          type = "video/mp4";
        }
        const video = {
          //autoplay: true,
          //controls: true,
          //techOrder: ["flash", "html5"],
          //sourceOrder: true,
          //Promise: vm.player.options_.Promise,
          withCredentials: false,
          type: type,
          src: source,
          //sources: [
          //  {
          //    type: "rtmp/mp4",
          //    src: "application/x-mpegurl",
          //  },
          //],
        };
        vm.videoPlayer.src(video);
      } else if (Array.isArray(source)) {
        //alert("array");
        let playList = [];
        type = "application/x-mpegurl";
        source.forEach(function (item) {
          if (item.toLowerCase().endsWith(".mp4")) {
            type = "video/mp4";
          }
          //alert(item);
          playList.push({
            sources: [
              {
                src: item,
                type: type,
              },
            ],
            //poster: "http://media.w3.org/2010/05/sintel/poster.png",
          });
        });
        vm.videoPlayer.playlist(playList);
        //vm.videoPlayer.playlist([
        //  {
        //    sources: [
        //      {
        //        src: source,
        //        type: "application/x-mpegurl",
        //      },
        //    ],
        //    //poster: "http://media.w3.org/2010/05/sintel/poster.png",
        //  },
        //  {
        //    sources: [
        //      {
        //        src:
        //          "https://d33b4sxjxxyff6.cloudfront.net/oauat/c1612521935067/1612780997545/8127000/oauat16127809975458127000rt/a74419dd1f4eacf249c2b2bc6ae4e6a7_OAUAT_1612780997545_8127000_rt.m3u8",
        //        type: "application/x-mpegurl",
        //      },
        //    ],
        //    //poster: "http://media.w3.org/2010/05/sintel/poster.png",
        //  },
        //]);

        //// Play through the playlist automatically.
        vm.videoPlayer.playlist.autoadvance(0);
      }

      //console.log("vm.videoPlayer - after:" + vm.videoPlayer);
      vm.videoPlayer.currentTime(timeElapsed);
      vm.videoPlayer.play();
      //vm.videoPlayer.muted(true);
      $("#divLiveVideoContainer .vjs-tech")[0].style.backgroundColor =
        vm.VideoPlayerBackgroundColor;
      $("#divLiveVideoContainer .vjs-poster").removeClass("vjs-hidden");
      $("#divLiveVideoContainer .vjs-poster")[0].style.backgroundColor =
        vm.VideoPlayerBackgroundColor;
      //$("#divLiveVideoContainer .vjs-poster")[0].style.background =
      //  vm.VideoPlayerBackgroundColor +
      //  " url('http://media.w3.org/2010/05/sintel/poster.png') no-repeat center center";
      $("#divLiveVideoContainer .vjs-big-play-button")[0].style.setProperty(
        "background-color",
        vm.VideoPlayerPlayButtonColor,
        "important"
      );
      //setTimeout(() => {
      //  alert(vm.videoPlayer.videoTracks());
      //  alert(vm.videoPlayer.videoTracks().length);
      //}, 10000);

      //setTimeout(() => {
      //$(":root").css("--click-here-to-proceed", "PLAY");
      $(".vjs-big-play-button").attr("data-after", vm.PlayButtonText);
      //}, 2000);
      //alert(timeElapsed);
    },
    startVideoPlayer: function () {
      vm.recordingStarted = false;
      //vm.hideRightPanel();
      vm.stopLiveStream();
      if (vm.selectedSession != undefined && vm.selectedSession != null) {
        vm.initCurrentSessionTimer();
        vm.livePlayerChannel = vm.getChannelName();
        vm.applyPlayerBroadcastSettings(
          vm.GlobalKeysData.OnDemandTypeID,
          vm.selectedSessionId,
          vm.selectedRoundTableId
        );
        //alert(vm.livePlayerChannel)
        //alert(new Date().getTime());
        //alert(vm.selectedSession.StartTimeS);
        vm.videoPlayerOptions.controls == true;
        let timeElapsed =
          parseInt(new Date().getTime() / 1000) - vm.selectedSession.StartTimeS;
        if (vm.exPageId != "") {
          timeElapsed = 0;
        }
        vm.playVideo(
          vm.selectedSession.SessionTypeDetails.VideoURL,
          timeElapsed
        );
        vm.callStarted = true;

        //alert(vm.uid);
        //alert(vm.livePlayerChannel);
        //alert(vm.GlobalKeysData.OnDemandTypeID);
        //alert(vm.speakerProfiles);
        //alert(vm.selectedSession);

        vm.setupRightPanel(
          vm.uid,
          vm.selectedSession.AttendeeType,
          vm.livePlayerChannel,
          vm.GlobalKeysData.OnDemandTypeID,
          vm.speakerProfiles,
          vm.selectedSession
        );
        vm.joinSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
        vm.initSessionJoinLeaveListener(vm.selectedSessionId);

        setTimeout(function () {
          if (vm.selectedSessionTypeId === vm.GlobalKeysData.OnDemandTypeID) {
            //alert("OnDemandTypeID "+vm.selectedSessionTypeId +"==="+ vm.GlobalKeysData.OnDemandTypeID)
            $("#divLiveStreamContainer").insertAfter("#divLiveVideoContainer");
            vm.videoPlayerEmbeded.initEmbed(
              vm.selectedSessionId,
              "embedLiveVideo"
            );
          }
        }, 500);

        vm.currentStage = 2;
        vm.startKeepMeActiveInSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
      } else {
        //vm.src = "";
        vm.stopVideoPlayer();
      }
    },
    stopVideoPlayer: function () {
      //vm.src = "";
      vm.callStarted = false;
      vm.videoPlayer.reset();
      vm.hideRightPanel();
      vm.leaveSession(vm.selectedSessionId, vm.uid);
      vm.stopKeepMeActiveInSession();
    },
    addVideoPlayerComponent(parentId) {
      let parentControl = document.querySelector("#" + parentId);
      if (parentControl) {
        let vjsSpacer = document.querySelector(
          "#" + parentId + " .vjs-custom-control-spacer"
        );
        if (vjsSpacer) {
          //VIEWERS COUNT
          let viewer = document.querySelector("#" + parentId + " .vjs-viewer");
          if (!viewer) {
            viewer = document.createElement("div");
            viewer.setAttribute("class", "vjs-viewer");

            let viewersCount = document.createElement("span");
            viewersCount.setAttribute("class", "vjs-viewer-count");
            viewer.appendChild(viewersCount);

            let node = document.createTextNode(vm.sessionAttendeeCount);
            viewersCount.appendChild(node);

            vjsSpacer.appendChild(viewer);
            vm.DisplayViewersCount();
          }

          //LEAVE BUTTON
          if (parentId == "divLiveVideoContainer") {
            let leaveBtn = document.querySelector(
              "#" + parentId + " .vjs-leave-btn"
            );
            if (!vm.HideLiveStreamLeaveButton && !leaveBtn) {
              leaveBtn = document.createElement("div");
              leaveBtn.setAttribute("class", "vjs-leave-btn");
              let node = document.createTextNode("Leave");
              leaveBtn.appendChild(node);

              leaveBtn.addEventListener("click", function () {
                //vm.stopVideoPlayer();
                //setTimeout(() => {
                //  vm.initLiveStage();
                //  vm.exPageId = "";
                //  vm.exSessionId = "";
                //  router.push(vm.stageurl);
                //  vm.initLiveStage();
                //}, 1000);
                $("#popupPageLeaveConfirm").modal("show");
              });
              vjsSpacer.appendChild(leaveBtn);
            }
          } else if (parentId == "divLiveStreamContainer") {
            let leaveBtn = document.querySelector(
              "#" + parentId + " .vjs-leave-btn"
            );
            if (!vm.HideLiveStreamLeaveButton && !leaveBtn) {
              leaveBtn = document.createElement("div");
              leaveBtn.setAttribute("class", "vjs-leave-btn");
              let node = document.createTextNode("Leave");
              leaveBtn.appendChild(node);

              leaveBtn.addEventListener("click", function () {
                //vm.stopLiveStream();
                //setTimeout(() => {
                //  vm.exPageId = "";
                //  vm.exSessionId = "";
                //  router.push(vm.stageurl);
                //  vm.initLiveStage();
                //}, 1000);
                $("#popupPageLeaveConfirm").modal("show");
              });
              vjsSpacer.appendChild(leaveBtn);
            }
          }
          //let leaveBtn = document.querySelector(
          //  "#" + parentId + " .vjs-leave-btn"
          //);
          //if (!leaveBtn) {
          //  leaveBtn = document.createElement("div");
          //  leaveBtn.setAttribute("class", "vjs-leave-btn");
          //  let node = document.createTextNode("Leave");
          //  leaveBtn.appendChild(node);

          //  leaveBtn.addEventListener("click", function () {
          //    if (parentId == "divLiveVideoContainer") {
          //      vm.stopVideoPlayer();
          //      setTimeout(() => {
          //        vm.initLiveStage();
          //        vm.exPageId = "";
          //        vm.exSessionId = "";
          //      }, 1000);
          //    } else if (parentId == "divLiveStreamContainer") {
          //      vm.stopLiveStream();
          //      setTimeout(() => {
          //        vm.exPageId = "";
          //        vm.exSessionId = "";
          //        vm.initLiveStage();
          //      }, 1000);
          //    }
          //  });
          //  vjsSpacer.appendChild(leaveBtn);
          //}
        }
      }
      console.log(parentId);
    },

    onStreamPlayerVolumeChange(player) {
      console.log("stream player volume change!", player);
      //////let volumeLevel = parseFloat(player.techGet_("volume"));
      //////volumeLevel = isNaN(volumeLevel) ? 1 : volumeLevel;
      //////vm.volumeLevel = parseInt(volumeLevel * 100);
      //////vm.muted = player.muted();
      //if (player.muted()) {
      //  vm.volumeLevel = 0;
      //}
      //alert(vm.volumeLevel);
    },
    savePlayerLog(actionLabel) {
      let logId = new Date().getTime().toString();
      let logObj = new Object({
        sessionId: vm.selectedSessionId,
        roundTableId: vm.selectedRoundTableId,
        clientUserId: vm.uid,
        LogText: actionLabel,
        CreatedDate: new Date(),
      });

      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection("PlayerLog")
        .doc(logId)
        .set(logObj)
        .then(function () {
          //alert("Success");
        })
        .catch(function (error) {
          console.log(error);
          //alert("Failure");
        });
    },
    onStreamPlayerPlay(player) {
      vm.savePlayerLog("Play");
      //////player.muted(vm.muted);
      console.log("stream player play!", player);
      //player.usingNativeControls_ = false;
      //player.removeTechControlsListeners_();
      //this.removeClass("vjs-using-native-controls");
    },
    onStreamPlayerReady(player) {
      vm.savePlayerLog("Ready");
      //alert("onStreamPlayerReady");
      //alert($(window).findControl("vjs_video_3"));
      //alert($(window).querySelector("#ag-canvas"));
      console.log("player ready!", player);
      //vm.player.usingNativeControls_ = false;
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeClass("vjs-using-native-controls");
      //vm.player.techCall_("setPlaysinline", false);
      //if (vm.player.tech_) {
      //  vm.player.techCall_("setAutoplay", false);
      //}
      //controls autoplay muted aspectRatio allow="autoplay; fullscreen"
      //setTimeout(() => {
      //  //alert();
      //  //vm.player.autoplay(true);
      //  //vm.player.trigger("loadstart");
      //  //vm.player.trigger("firstplay");
      //  //vm.player.manualAutoplay_(vm.player.autoplay());
      //  //vm.player.options_.autoplay = true;
      //  //let promise;
      //  // if muted defaults to true
      //  // the only thing we can do is call play
      //  //promise = vm.player.play();
      //  //promise.catch(false);
      //  vm.player.play();
      //}, 5000);
      //player.play();
      setTimeout(() => {
        vm.addVideoPlayerComponent("divLiveStreamContainer");
      }, 5000);
    },
    //      "pause",
    //      "waiting",
    //      "playing",
    //      "volumechange",
    //      "ended",
    //      "error",

    onStreamPlayerError(player) {
      vm.savePlayerLog("Error");
      console.log(player);
      //setTimeout(() => {
      //  player.load();
      //}, 10000);
      //vm.showSnackbar(player.error_.message, "info", "top");
      if (retryPlayStreamTimer) {
        clearInterval(retryPlayStreamTimer);
      }
      vm.isStreamReady = false;
      if (vm.enableRetry) {
        vm.retryCounter = vm.retryInterval;
        if (retryPlayStreamTimer) {
          clearInterval(retryPlayStreamTimer);
        }
        retryPlayStreamTimer = setInterval(function () {
          if (vm.retryCounter > 0) {
            vm.retryCounter -= 1;
          }
          if (vm.retryCounter == 0) {
            if (retryPlayStreamTimer) {
              clearInterval(retryPlayStreamTimer);
            }
            vm.retryPlayStream();
          }
        }, 1000);
      }
      //retryPlayStreamTimer = setInterval(function () {
      //  vm.retryPlayStream();
      //}, 10000);
      //setTimeout(() => {
      //  vm.retryPlayStream();
      //}, 10000);
    },

    retryPlayStream() {
      var flag = false;
      if (!flag) {
        vm.hideLoader();
        //return;
      }
      if (vm.selectedSession != undefined && vm.selectedSession != null) {
        if (
          vm.selectedSession.StreamingClient &&
          vm.selectedSession.StreamingClient.trim().toLowerCase() == "zoom"
        ) {
          if (
            vm.selectedSession.ZoomRTMPMUX_detail &&
            vm.selectedSession.ZoomRTMPMUX_detail.data &&
            vm.selectedSession.ZoomRTMPMUX_detail.data.playbackUrl
          ) {
            vm.playStream(
              vm.selectedSession.ZoomRTMPMUX_detail.data.playbackUrl,
              0,
              true
            );
            //vm.streamPlayer.play();
          }
        } else {
          if (vm.selectedSession.SessionTypeDetails.LiveStreamURL) {
            let timeElapsed =
              parseInt(new Date().getTime() / 1000) -
              vm.selectedSession.StartTimeS;
            vm.playStream(
              vm.selectedSession.SessionTypeDetails.LiveStreamURL,
              timeElapsed,
              true
            );
          }
        }
      }
    },
    playStream: function (source, timeElapsed, isRetry) {
      vm.isStreamReady = true;
      const video = {
        //autoplay: true,
        //controls: true,
        //techOrder: ["flash", "html5"],
        //sourceOrder: true,
        //Promise: vm.player.options_.Promise,
        withCredentials: false,
        type: "application/x-mpegurl",
        src: source,
        //sources: [
        //  {
        //    type: "rtmp/mp4",
        //    src: "application/x-mpegurl",
        //  },
        //],
      };
      vm.videoPlayer.reset();
      vm.streamPlayer.reset(); // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
      vm.streamPlayer.src(video);
      $("#divLiveStreamContainer .vjs-tech")[0].style.backgroundColor =
        vm.VideoPlayerBackgroundColor;
      $("#divLiveStreamContainer .vjs-poster").removeClass("vjs-hidden");
      $("#divLiveStreamContainer .vjs-poster")[0].style.backgroundColor =
        vm.VideoPlayerBackgroundColor;
      //$("#divLiveStreamContainer .vjs-poster")[0].style.background =
      //  vm.VideoPlayerBackgroundColor +
      //  " url('http://media.w3.org/2010/05/sintel/poster.png') no-repeat center center";
      $("#divLiveStreamContainer .vjs-big-play-button")[0].style.setProperty(
        "background-color",
        vm.VideoPlayerPlayButtonColor,
        "important"
      );
      if (!isRetry && vm.exStageUrl) {
        vm.streamPlayer.muted(true);
      }
      setTimeout(() => {
        vm.streamPlayer.play();
      }, 1000);
      //if (
      //  vm.selectedSession &&
      //  vm.selectedSession.IsZoomRTMP &&
      //  (vm.selectedSession.IsHost || vm.selectedSession.IsSpeaker)
      //) {
      //  vm.streamPlayer.muted(true);
      //}
      // vm.player.load()
      //vm.player.trigger("usingnativecontrols");
      //vm.player.trigger("usingcustomcontrols");
      //vm.player.usingNativeControls_ = false;
      //vm.player.autoplay(true);

      //////vm.streamPlayer.muted(vm.muted);
      //////vm.streamPlayer.volume(vm.volumeLevel / 100);
      //vm.streamPlayer.currentTime(timeElapsed);
      // if (!(vm.$browserDetect.isIOS && vm.$browserDetect.isChromeIOS)) {
      //   setTimeout(() => {
      //     vm.streamPlayer.play();
      //   }, 3000);
      // }
      //vm.streamPlayer.muted(true);
      setTimeout(() => {
        vm.hideLoader();
      }, 1000);
      console.log(timeElapsed);
      //setTimeout(() => {
      //$(":root").css("--click-here-to-proceed", "PLAY");
      $(".vjs-big-play-button").attr("data-after", vm.PlayButtonText);
      $(".vjs-error-display.vjs-modal-dialog").attr(
        "data-after",
        "Live Streaming will begin soon..."
      );
      //}, 2000);
    },
    startLiveStream() {
      if (retryPlayStreamTimer) {
        clearInterval(retryPlayStreamTimer);
      }
      vm.recordingStarted = false;
      //vm.hideRightPanel();
      vm.stopVideoPlayer();
      if (vm.selectedSession != undefined && vm.selectedSession != null) {
        vm.initCurrentSessionTimer();
        vm.livePlayerChannel = vm.getChannelName();
        vm.applyPlayerBroadcastSettings(
          vm.GlobalKeysData.LiveStreamTypeID,
          vm.selectedSessionId,
          vm.selectedRoundTableId
        );
        vm.streamPlayerOptions.controls == false;
        let timeElapsed =
          parseInt(new Date().getTime() / 1000) - vm.selectedSession.StartTimeS;
        vm.playStream(
          vm.selectedSession.SessionTypeDetails.LiveStreamURL,
          timeElapsed
        );
        vm.callStarted = true;
        vm.setupRightPanel(
          vm.uid,
          vm.selectedSession.AttendeeType,
          vm.livePlayerChannel,
          vm.GlobalKeysData.LiveStreamTypeID,
          vm.speakerProfiles,
          vm.selectedSession
        );
        vm.joinSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
        vm.initSessionJoinLeaveListener(vm.selectedSessionId);

        setTimeout(function () {
          if (vm.selectedSessionTypeId === vm.GlobalKeysData.LiveStreamTypeID) {
            //alert(vm.selectedSessionTypeId +"==="+ vm.GlobalKeysData.LiveStreamTypeID)
            $("#divLiveVideoContainer").insertAfter("#divLiveStreamContainer");
            vm.streamPlayerEmbeded.initEmbed(
              vm.selectedSessionId,
              "embedLiveStream"
            );
          }
        }, 500);

        vm.currentStage = 2;
        vm.startKeepMeActiveInSession(
          vm.selectedSessionId,
          vm.uid,
          vm.selectedSession.AttendeeType
        );
      } else {
        //vm.src = "";
        vm.stopLiveStream();
      }
    },
    stopLiveStream: function () {
      //vm.src = "";
      vm.callStarted = false;
      vm.streamPlayer.reset();
      vm.hideRightPanel();
      vm.leaveSession(vm.selectedSessionId, vm.uid);
      vm.stopKeepMeActiveInSession();
    },
    //VIDEO PLAYER END

    initSessionJoinLeaveListener: function (sessionId) {
      //alert();
      let firstLoad = true;
      if (sessionId == "") {
        return;
      }
      if (currentSessionParticipancesListener) {
        currentSessionParticipancesListener();
      }
      var participancesCollectionName =
        "/" +
        vm.event_collectionName +
        "/SessionList/Sessions/" +
        sessionId +
        "/Participances";
      // console.log(participancesCollectionName);
      //if (sessionId == "") {
      //  alert("initSessionJoinLeaveListener");
      //}
      currentSessionParticipancesListener = db
        .collection(participancesCollectionName)
        // .where("IsActive", "==", true)
        .onSnapshot((querySnapshot) => {
          // console.log("listner callded");
          if (!firstLoad) {
            let changes = querySnapshot.docChanges();
            changes.forEach(function (change) {
              if (change.type == "modified") {
                let data = change.doc.data();
                if (vm.uid == data.AttendeeId) {
                  let muteRequest = data.MuteRequest ? data.MuteRequest : 0;
                  let unmuteRequest = data.UnmuteRequest
                    ? data.UnmuteRequest
                    : 0;
                  let leaveRequest = data.LeaveRequest ? data.LeaveRequest : 0;
                  if (muteRequest > vm.muteRequest) {
                    vm.muteRequest = muteRequest;
                    if (data.ForceMute != undefined) {
                      if (data.RequestedBy != vm.uid) {
                        vm.livePlayer.forceMuteSpeaker(
                          data.RequestedBy,
                          0,
                          data.ForceMute
                        );
                      }
                    }
                  } else if (unmuteRequest > vm.unmuteRequest) {
                    vm.unmuteRequest = unmuteRequest;
                    if (data.RequestedBy != vm.uid) {
                      vm.livePlayer.forceMuteSpeaker(data.RequestedBy, 1);
                    }
                  } else if (leaveRequest > vm.leaveRequest) {
                    vm.leaveRequest = leaveRequest;
                    vm.livePlayer.onEndCall();
                  }
                }
              }
            });
          }
          let attendeeCount = 0;
          let currentAttendeeList = [];
          querySnapshot.forEach((doc) => {
            var participant = doc.data();
            // console.log(curDoc);
            if (firstLoad) {
              if (vm.uid == participant.AttendeeId) {
                if (participant.MuteRequest) {
                  vm.muteRequest = participant.MuteRequest;
                }
                if (participant.UnmuteRequest) {
                  vm.unmuteRequest = participant.UnmuteRequest;
                }
                if (participant.LeaveRequest) {
                  vm.leaveRequest = participant.LeaveRequest;
                }
              }
            }
            let attType = 0;
            if (participant.AttendeeType) {
              attType = participant.AttendeeType;
            }
            if (participant.IsActive) {
              attendeeCount++;
            }
            if (participant.IsActive && attType == 4) {
              currentAttendeeList.push(participant);
            }
          });
          //alert(currentAttendeeList.length);
          $("#spanAttendeeCount").text(attendeeCount);
          if (
            vm.newDesign &&
            typeof vm.livePlayer.displayViewersCount == "function"
          ) {
            if ([3, 4].includes(vm.selectedSessionTypeId)) {
              if (
                vm.selectedSessionTypeId == 3 &&
                vm.selectedSession.IsZoomRTMP
              ) {
                vm.sessionAttendeeCount = attendeeCount;
                $("#divLiveStreamContainer .vjs-viewer-count").html(
                  attendeeCount
                );
              } else {
                vm.livePlayer.displayViewersCount(true, attendeeCount);
              }
            } else if (vm.selectedSessionTypeId == 1) {
              vm.sessionAttendeeCount = attendeeCount;
              $("#divLiveVideoContainer .vjs-viewer-count").html(attendeeCount);
            } else if (vm.selectedSessionTypeId == 2) {
              vm.sessionAttendeeCount = attendeeCount;
              $("#divLiveStreamContainer .vjs-viewer-count").html(
                attendeeCount
              );
            }
          }

          vm.rightPanel.UpdateAttendeePanel(currentAttendeeList);
          //console.log(members);
          firstLoad = false;
        });
    },
    joinSession(sessionId, attendeeId, attendeeType) {
      //alert(attendeeType);
      if (sessionId == "" || attendeeId == "") {
        return;
      }
      var participancesCollectionName =
        "/" +
        vm.event_collectionName +
        "/SessionList/Sessions/" +
        sessionId +
        "/Participances/" +
        attendeeId;
      var sessionPath =
        "/" + vm.event_collectionName + "/SessionList/Sessions/" + sessionId;
      //if (sessionId == "") {
      //  alert("joinSession");
      //}
      // alert(participancesCollectionName);
      db.doc(participancesCollectionName)
        .get()
        .then((doc) => {
          //alert(doc.exists);
          if (doc.exists) {
            let userAgent = navigator.userAgent;
            db.doc(participancesCollectionName)
              .update({
                AttendeeType: attendeeType,
                IsActive: true,
                LastActiveTimestamp: new Date(),
                UserAgent: userAgent,
                userIP: "",
              })
              .then(function () {
                vm.createPresence(
                  sessionId,
                  participancesCollectionName,
                  sessionPath,
                  true
                );
              })
              .catch(function (error) {
                console.error("Error creating Sessions: ", error);
              });
          } else {
            //alert("doc.exists");
            if (attendeeType > 0) {
              let userAgent = navigator.userAgent;
              db.doc(participancesCollectionName)
                .set({
                  AttendeeId: vm.uid,
                  AttendeeType: attendeeType,
                  Company: vm.company,
                  Country: vm.country,
                  Designation: vm.designation,
                  FirstName: vm.firstName,
                  LastName: vm.lastName,
                  Name: vm.name,
                  ProfilePictureURL: vm.profilePictureURL,
                  IsActive: true,
                  JoinTime: new Date(),
                  LastActiveTimestamp: new Date(),
                  LeaveTime: null,
                  SessionId: sessionId,
                  UserAgent: userAgent,
                  userIP: "",
                })
                .then(function () {
                  vm.createPresence(
                    sessionId,
                    participancesCollectionName,
                    sessionPath,
                    true
                  );
                })
                .catch(function (error) {
                  console.error("Error creating Sessions: ", error);
                });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    keepMeActiveInSession(sessionId, attendeeId, attendeeType) {
      //alert(attendeeType);
      if (sessionId == "" || attendeeId == "") {
        return;
      }
      var participancesCollectionName =
        "/" +
        vm.event_collectionName +
        "/SessionList/Sessions/" +
        sessionId +
        "/Participances/" +
        attendeeId;
      //if (sessionId == "") {
      //  alert("keepMeActiveInSession");
      //}
      // alert(participancesCollectionName);
      db.doc(participancesCollectionName)
        .get()
        .then((doc) => {
          if (doc.exists) {
            db.doc(participancesCollectionName)
              .update({
                AttendeeType: attendeeType,
                IsActive: true,
                LastActiveTimestamp: new Date(),
              })
              .then(function () {
                //
              })
              .catch(function (error) {
                console.error("Error creating Sessions: ", error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    leaveSession(sessionId, attendeeId) {
      if (sessionId == "") {
        sessionId = vm.prevSessionTypeId;
      }
      if (sessionId == "" || attendeeId == "") {
        return;
      }

      vm.stopKeepMeActiveInSession();
      var participancesCollectionName =
        "/" +
        vm.event_collectionName +
        "/SessionList/Sessions/" +
        sessionId +
        "/Participances/" +
        attendeeId;
      var sessionPath =
        "/" + vm.event_collectionName + "/SessionList/Sessions/" + sessionId;

      db.doc(participancesCollectionName)
        .get()
        .then((doc) => {
          if (doc.exists) {
            db.doc(participancesCollectionName)
              .update({
                IsActive: false,
                LeaveTime: new Date(),
              })
              .then(function () {
                vm.createPresence(
                  sessionId,
                  participancesCollectionName,
                  sessionPath,
                  false
                );
              })
              .catch(function (error) {
                console.error("Error creating Sessions: ", error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toggleMoreSessionActions(sessionId, e) {
      //alert(sessionId);
      if (sessionId) {
        if (
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").hasClass(
            "d-none"
          )
        ) {
          $(".on-demand-dropdown").addClass("d-none");
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").removeClass(
            "d-none"
          );
        } else {
          $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
            "d-none"
          );
        }
      } else {
        $(".on-demand-dropdown").addClass("d-none");
      }
      if (e) {
        e.stopPropagation();
      }
    },
    StartRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      vm.sessionList.forEach(function (session) {
        if (session.SessionId == sessionId) {
          //alert(session.Name);
          if (session.SessionTypeDetails.TypeID == 3) {
            let headers = {
              "content-type": "application/json",
            };
            let bodyData = {
              meetingid: session.Zoom_Detail.id,
              stream_url: session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url,
              stream_key:
                session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey,
              page_url: session.ZoomRTMPMUX_detail.data.playbackUrl,
            };
            vm.showLoader();
            axios
              .post(APIs.EnableZoomRTMPStreaming, bodyData, {
                headers: headers,
              })
              .then((response) => {
                vm.hideLoader();
                //alert("RTMP Started");
                if (response.data.code == 1) {
                  db.collection(vm.event_collectionName)
                    .doc("SessionList")
                    .collection("Sessions")
                    .doc(sessionId)
                    .update({
                      ZoomRTMPEnable_Status: response.data,
                      ZoomRTMPStarted: true,
                    })
                    .then(function () {
                      //resolve(response.data);
                      $(
                        "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      ).addClass("d-none");
                      //vm.rightPanel.updateRTMPStatus(sessionId, true);
                      vm.showSnackbar(
                        "RTMP Streaming started successfully.",
                        "info",
                        "top"
                      );
                    })
                    .catch(function (error) {
                      //$(
                      //  "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      //).addClass("d-none");
                      console.error(
                        "Error updating ZoomRTMPEnable_Status: ",
                        error
                      );
                      vm.showSnackbar(
                        "Error on Start RTMP Streaming.",
                        "error",
                        "top"
                      );
                    });
                }
              })
              .catch((error) => {
                vm.hideLoader();
                //alert("Error: " + error);
                console.log(error);
                vm.showSnackbar(
                  "Error on Start RTMP Streaming.",
                  "error",
                  "top"
                );
              });
          }
        }
      });
      if (e) {
        e.stopPropagation();
      }
    },
    StopRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      vm.sessionList.forEach(function (session) {
        if (session.SessionId == sessionId) {
          //alert(session.Name);
          if (session.SessionTypeDetails.TypeID == 3) {
            let headers = {
              "content-type": "application/json",
            };
            let bodyData = {
              meetingid: session.Zoom_Detail.id,
            };
            vm.showLoader();
            axios
              .post(APIs.DisableZoomRTMPStreaming, bodyData, {
                headers: headers,
              })
              .then((response) => {
                vm.hideLoader();
                //alert("RTMP Started");
                if (response.data.status == 0) {
                  db.collection(vm.event_collectionName)
                    .doc("SessionList")
                    .collection("Sessions")
                    .doc(sessionId)
                    .update({
                      ZoomRTMPEnable_Status: response.data,
                      ZoomRTMPStarted: false,
                    })
                    .then(function () {
                      //resolve(response.data);
                      $(
                        "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      ).addClass("d-none");
                      //vm.rightPanel.updateRTMPStatus(sessionId, false);
                      vm.showSnackbar(
                        "RTMP Streaming stopped successfully.",
                        "info",
                        "top"
                      );
                    })
                    .catch(function (error) {
                      //$(
                      //  "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      //).addClass("d-none");
                      console.error(
                        "Error updating ZoomRTMPEnable_Status: ",
                        error
                      );
                      vm.showSnackbar(
                        "Error on Stop RTMP Streaming.",
                        "error",
                        "top"
                      );
                    });
                }
              })
              .catch((error) => {
                vm.hideLoader();
                //alert("Error: " + error);
                console.log(error);
                vm.showSnackbar(
                  "Error on Stop RTMP Streaming.",
                  "error",
                  "top"
                );
              });
          }
        }
      });
      if (e) {
        e.stopPropagation();
      }
    },
    ZoomRTMPStatusListener(objSession) {
      if (!objSession.ZoomRTMPListener) {
        let firstLoad = true;
        objSession.ZoomRTMPListener = db
          .collection(vm.event_collectionName)
          .doc("SessionList")
          .collection("Sessions")
          .doc(objSession.SessionId)
          .onSnapshot((doc) => {
            var data = doc.data();
            if (!firstLoad) {
              objSession.ZoomRTMPStarted = data.ZoomRTMPStarted
                ? data.ZoomRTMPStarted
                : false;
              objSession.ZoomMeetingStarted = data.MeetingStarted
                ? data.MeetingStarted
                : false;

              //if (!objSession.ZoomRTMPStarted) {
              //  objSession.IsLive = false;
              //}
              if (objSession.SessionId == vm.rtmpDialog.sessionId) {
                vm.rtmpDialog.session = objSession;
                vm.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();
              }
              vm.rightPanel.updateRTMPStatus(
                objSession.SessionId,
                objSession.ZoomMeetingStarted,
                objSession.ZoomRTMPStarted
              );
            }
            vm.ZoomRTMPStarted = data.ZoomRTMPStarted
              ? data.ZoomRTMPStarted
              : false;
            firstLoad = false;
          });
      }
    },
    rtmpActions(action, sessionId) {
      let flag = true;
      if (action == 0) {
        vm.rtmpDialog.key += 1;
        vm.rtmpDialog.sessionId = "";
        vm.rtmpDialog.session = null;
        vm.rtmpDialog.rtmpOptions.sessionId = "";
        vm.rtmpDialog.rtmpOptions.session = null;
        vm.rtmpDialog.rtmpOptions.hasZoomLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        vm.rtmpDialog.rtmpOptions.viewersCount = 0;
        vm.rtmpDialog.rtmpOptions.streamUrl = "";
        vm.rtmpDialog.rtmpOptions.zoomUrl = "";
        if (sessionId) {
          let sessions = vm.sessionList.filter((item) => {
            return item.SessionId == sessionId;
          });
          if (sessions.length > 0) {
            vm.rtmpDialog.sessionId = sessionId;
            vm.rtmpDialog.session = sessions[0];
            vm.rtmpDialog.rtmpOptions.sessionId = sessionId;
            vm.rtmpDialog.rtmpOptions.uid = vm.uid;
            vm.rtmpDialog.rtmpOptions.event_collectionName =
              vm.event_collectionName;
            if (sessions[0].IsHost) {
              vm.rtmpDialog.rtmpOptions.title = "Welcome Session Host";
            } else if (sessions[0].IsSpeaker) {
              vm.rtmpDialog.rtmpOptions.title = "Welcome Session Speaker";
            } else {
              vm.rtmpDialog.rtmpOptions.title = "Welcome Session Attendee";
            }
            vm.rtmpDialog.rtmpOptions.streamUrl =
              sessions[0].ZoomRTMPMUX_detail.data.playbackUrl;
            vm.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();
            vm.initParticipantsListener(vm.rtmpDialog.sessionId);
          } else {
            flag = false;
          }
        } else {
          flag = false;
        }
      }
      if (flag) {
        if (action == -1) {
          vm.hideLoader();
          vm.rtmpDialog.state = false;
          vm.rtmpDialog.key += 1;
          //vm.rtmpComponent.stopStreaming();
          if (vm.tempVolumeLevel > 0) {
            vm.volumeLevel = vm.tempVolumeLevel;
          }
          vm.volumeChanged(vm.volumeLevel);
          if (ZoomRTMPParticipantsListener) {
            ZoomRTMPParticipantsListener();
            ZoomRTMPParticipantsListener = null;
          }
        } else if (action == 0) {
          vm.hideLoader();
          vm.rtmpDialog.state = true;
          vm.tempVolumeLevel = vm.volumeLevel;
          vm.volumeChanged(0);
          setTimeout(() => {
            vm.rtmpComponent.startStreaming();
          }, 100);
        } else if (action == 1) {
          //vm.rtmpDialog.state = false;
          let session = vm.rtmpDialog.session;
          if (session) {
            if (session.IsZoomRTMP) {
              if (session.IsZoomRTMP && session.IsHost) {
                window.open(session.Zoom_Detail.start_url, "_blank");
                vm.postLeaderboardAction("SNVW");
              } else if (session.IsSpeaker) {
                vm.retryType = "rtmp";
                vm.tempSessionId = sessionId;
                vm.tempAction = action;
                vm.showLoader();
                let headers = {
                  Authorization: "Bearer " + vm.getSessionToken(),
                  "content-type": "application/json",
                };
                let requestData = {
                  email: vm.email,
                  name: vm.name,
                  first_name: vm.firstName,
                  last_name: vm.lastName,
                  meetingid: session.Zoom_Detail.id,
                  //address: "",
                  //phone: vm.phone,
                  //industry: "",
                  //org: vm.company,
                  //job_title: vm.title,
                };
                axios
                  .post(APIs.AddAttendeesToZoom, requestData, {
                    headers: headers,
                  })
                  .then((response) => {
                    vm.hideLoader();
                    if (
                      response &&
                      response.data &&
                      response.data.status == 0 &&
                      response.data.data.id &&
                      response.data.data.join_url &&
                      response.data.data.join_url != ""
                    ) {
                      window.open(response.data.data.join_url, "_blank");
                      //var link =
                      //  session.Zoom_Detail.join_url +
                      //  "&uname=" +
                      //  vm.firstName.trim() +
                      //  "%20" +
                      //  vm.lastName.trim();
                      //window.open(link, "_blank");
                      vm.postLeaderboardAction("SNVW");
                    } else {
                      vm.retryJoinInZoomPopup();
                    }
                  })
                  .catch((error) => {
                    vm.hideLoader();
                    console.log(error);
                    vm.retryJoinInZoomPopup();
                  });
              }
            }
          }
        } else if (action == 2) {
          vm.rtmpDialog.rtmpOptions.startProcessing = true;
          vm.StartRTMPStreaming(vm.rtmpDialog.rtmpOptions.sessionId);
          setTimeout(() => {
            vm.rtmpDialog.rtmpOptions.startProcessing = false;
          }, 2000);
        } else if (action == 3) {
          vm.rtmpDialog.rtmpOptions.stopProcessing = true;
          vm.StopRTMPStreaming(vm.rtmpDialog.sessionId);
          setTimeout(() => {
            vm.rtmpDialog.rtmpOptions.stopProcessing = false;
          }, 2000);
        } else if (action == 4) {
          vm.rtmpDialog.state = false;
          vm.rtmpDialog.key += 1;
          let session = vm.rtmpDialog.session;
          if (session) {
            if (
              session.IsZoomRTMP &&
              session.ZoomMeetingStarted &&
              session.ZoomRTMPStarted
            ) {
              vm.onStartSession(session.SessionId);
            }
          }
          //vm.GoForInternalPlayer(vm.rtmpDialog.sessionId);
        }
      }
    },
    initParticipantsListener(sessionId) {
      if (ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener();
        ZoomRTMPParticipantsListener = null;
      }
      if (!ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener = db
          .collection(vm.event_collectionName)
          .doc("SessionList")
          .collection("Sessions")
          .doc(sessionId)
          .collection("Participances")
          .onSnapshot((querySnapshot) => {
            var viewersCount = 0;
            querySnapshot.forEach((doc) => {
              if (doc.data().IsActive) {
                viewersCount++;
              }
            });
            vm.rtmpDialog.rtmpOptions.viewersCount = viewersCount;
          });
      }
      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection("Session")
        .doc(sessionId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let data = doc.data();
            vm.rtmpDialog.rtmpOptions.chatEnabled = data.ChatEnabled
              ? data.ChatEnabled
              : false;
            vm.rtmpDialog.rtmpOptions.qnaEnabled = data.QnAEnabled
              ? data.QnAEnabled
              : false;
            //vm.rtmpDialog.rtmpOptions.attendeeEnabled = data.AttendeeEnabled
            //  ? data.AttendeeEnabled
            //  : false;
          }
        });
    },
    startInteractionWithAudience(sessionId) {
      //$(".tooltip").tooltip("hide");
      //$(".modal").modal("hide");
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      if (sessionId) {
        window.open(location.origin + vm.stageUrl + "/" + sessionId, "_blank");
      }
    },
    unreadChatCountChanged(val) {
      vm.$emit("unreadChatCountChanged", val);
    },
    unreadQnACountChanged(val) {
      vm.$emit("unreadQnACountChanged", val);
    },
    setNextMeetingData(meetingId, meeting) {
      vm.livePlayer.setNextMeetingData(meetingId, meeting);
    },
    startMeeting(meetingId) {
      //alert("LS:" + meetingId);
      if (vm.exMeetingId != meetingId) {
        vm.showLoader();
        let waitTime = 1;
        if (vm.callStarted) {
          vm.callSwitchingInProcess = true;
          setTimeout(() => {
            vm.stopMeeting();
          }, 1000);
          waitTime = 5000;
        }
        setTimeout(() => {
          router.push(vm.stageUrl + "/" + meetingId + "_o2o");
          vm.exMeetingId = meetingId;
          vm.startOneToOneMeeting();
          vm.hideLoader();
        }, waitTime);
      }
    },
    stopMeeting() {
      vm.livePlayer.onEndCall();
      vm.hideRightPanel();
    },
    startSession(sessionId, restartSession, e) {
      if (e) {
        vm.exRoundTableId = "";
        $("#divRoundTablesContainer").hide();
        $("#divRoundTablesContainer").removeClass("multi-session-popup");
      }
      let sessions = vm.sessionList.filter(function (item) {
        return item.SessionId == sessionId;
      });
      if (sessions.length > 0) {
        let currentTime = parseInt(new Date().getTime() / 1000);
        if (
          !(
            sessions[0].StartTimeS < currentTime &&
            sessions[0].EndTimeS > currentTime
          )
        ) {
          vm.exPageId = "";
          vm.exSessionId = "";
          vm.IsManuallyStopped = true;
          router.push(vm.stageUrl);
          //return;
        }
        let session = sessions[0];
        if (session.SessionTypeDetails.TypeID == 3) {
          if (
            session.StreamingClient &&
            session.StreamingClient.trim().toLowerCase() == "zoom" &&
            session.IsZoomRTMP &&
            (session.IsHost || session.IsSpeaker)
          ) {
            if (session.Zoom_Detail && session.Zoom_Detail.id) {
              vm.rtmpActions(0, session.SessionId);
            } else {
              alert(vm.zoomErrorMsg);
            }
          } else {
            vm.onStartSession(sessionId, restartSession);
          }
        } else {
          vm.onStartSession(sessionId, restartSession);
        }
      } else {
        vm.onStartSession(sessionId, restartSession);
      }
    },
    onStartSession(sessionId, restartSession) {
      if (retryPlayStreamTimer) {
        clearInterval(retryPlayStreamTimer);
      }
      let sessions = vm.sessionList.filter(function (item) {
        return item.SessionId == sessionId;
      });
      if (sessions.length > 0) {
        if (sessions[0].SessionTypeDetails.TypeID == 5) {
          //return;
        }
        let currentTime = parseInt(new Date().getTime() / 1000);
        if (
          !(
            sessions[0].StartTimeS < currentTime &&
            sessions[0].EndTimeS > currentTime
          )
        ) {
          vm.exPageId = "";
          vm.exSessionId = "";
          vm.IsManuallyStopped = true;
          router.push(vm.stageUrl);
          //return;
        }
      }
      vm.recordingStarted = false;
      //  alert(sessionId);
      //if (vm.selectedSessionId != sessionId) {
      vm.showLoader();
      let waitTime = 1;
      if (vm.selectedSessionTypeId != "" && vm.callStarted) {
        vm.callSwitchingInProcess = true;
        if (vm.selectedSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
          //alert("stopVideoPlayer");
          vm.stopVideoPlayer();
          //vm.initLiveStage();
          $("#divLiveVideoContainer").hide();
        } else if (
          vm.selectedSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID
        ) {
          vm.stopLiveStream();
          $("#divLiveStreamContainer").hide();
        } else if (
          vm.selectedSessionTypeId == vm.GlobalKeysData.LivePanelTypeID
        ) {
          vm.stopLivePlayer();
          $("#divLiveVideoContainer").hide();
          $("#divLiveStreamContainer").hide();
          $("#divLivePanelContainer").hide();
          $("#divLivePanelContainer").addClass("d-none");
        } else if (
          vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID
        ) {
          vm.stopRoundTable();
          $("#divLiveVideoContainer").hide();
          $("#divLiveStreamContainer").hide();
          $("#divLivePanelContainer").hide();
          $("#divLivePanelContainer").addClass("d-none");
          $("#divRoundTablesContainer").hide();
          $("#divRoundTablesContainer").removeClass("multi-session-popup");
        }
        if (vm.callStarted || restartSession) {
          waitTime = 2000;
        }
      }
      let selectedSessions = vm.sessionList.filter(function (item) {
        return item.SessionId == sessionId;
      });
      vm.stageClicked();
      if (selectedSessions.length == 0) {
        //alert("Need to load");
        vm.loadSessionsComplete = false;
        vm.exSessionId = sessionId;
        vm.loadAllSessions(sessionId);
        if (sessionId != "" && vm.exRoundTableId != "") {
          router.push(vm.stageUrl + "/" + sessionId + "/" + vm.exRoundTableId);
        } else {
          router.push(vm.stageUrl + "/" + sessionId);
        }
        return;
      }
      //alert(sessionId);
      //alert(waitTime);
      //alert(vm.selectedSessionTypeId);
      //alert(vm.selectedSessionId);
      //alert(vm.callStarted);
      setTimeout(() => {
        if (sessionId != "" && vm.exRoundTableId != "") {
          router.push(vm.stageUrl + "/" + sessionId + "/" + vm.exRoundTableId);
        } else {
          router.push(vm.stageUrl + "/" + sessionId);
        }
        vm.callSwitchingInProcess = false;
        vm.selectedSessionId = "";
        vm.selectedSessionTypeId = 0;
        vm.roundTableList.forEach(function (rt) {
          if (rt.Listener) {
            rt.Listener();
          }
        });
        vm.roundTableList = [];
        vm.allRoundTablesLoaded = false;
        vm.switchTableVisible = false;
        //$("#divSessionsContainer").hide();
        //$("#divSessionEndedContainer").hide();
        let sessions = vm.sessionList.filter(function (item) {
          return item.SessionId == sessionId;
        });
        if (sessions.length > 0) {
          let session = sessions[0];
          vm.selectedSessionId = sessionId;
          vm.selectedSession = session;
          vm.selectedSessionTypeId = session.SessionTypeDetails.TypeID;

          $("#pHeaderSessionName").html(session.Name);
          $("#pHeaderSessionName").attr("attr", session.Name);
          $("#menuSessionInfo p").html(session.Name);

          if (
            session.SessionTypeDetails.TypeID ==
            vm.GlobalKeysData.InPersonTypeID
          ) {
            if (session.SessionTypeDetails.InPersonURL) {
              vm.joinInPersonSession(session.SessionTypeDetails.InPersonURL);
              //window.open(session.SessionTypeDetails.InPersonURL, "_blank");
              //vm.postLeaderboardAction("SNVW");
            }
          } else if (
            vm.selectedSessionTypeId == vm.GlobalKeysData.OnDemandTypeID
          ) {
            $("#divLivePanelContainer").hide();
            $("#divLivePanelContainer").addClass("d-none");
            $("#divSessionsContainer").hide();
            $("#divLiveVideoContainer").show();
            vm.startVideoPlayer();
          } else if (
            vm.selectedSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID
          ) {
            $("#divLivePanelContainer").hide();
            $("#divLivePanelContainer").addClass("d-none");
            $("#divSessionsContainer").hide();
            $("#divLiveStreamContainer").show();
            vm.startLiveStream();
          } else if (
            vm.selectedSessionTypeId == vm.GlobalKeysData.LivePanelTypeID
          ) {
            //$("#divSessionsContainer").hide();
            //$("#divLivePanelContainer").show();
            //$("#divLivePanelContainer").removeClass("d-none");
            vm.startLivePanel();
          } else if (
            vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID
          ) {
            $("#divSessionsContainer").hide();
            //$("#divRoundTablesContainer").show();
            vm.displayRoundTables();
          }
        }
        vm.hideLoader();
      }, waitTime);
      //}
    },

    //ROUND TABLE START
    LoadRoundTableSettings() {
      db.collection(vm.event_collectionName)
        .doc("Settings")
        .collection("Roundtable")
        .doc("RoundtableSettings")
        .onSnapshot(function (doc) {
          if (doc.exists) {
            let data = doc.data();
            if (typeof data.ShowSpeakerList != undefined) {
              vm.roundtableSettings.isSpeakerTabVisible = data.ShowSpeakerList;
            }
            if (typeof data.ShowAttendeeList != undefined) {
              vm.roundtableSettings.isAttendeeTabVisible =
                data.ShowAttendeeList;
            }
            if (typeof data.EnableGroupChat != undefined) {
              vm.roundtableSettings.isChatTabVisible = data.EnableGroupChat;
            }
            if (typeof data.EnableRaiseHand != undefined) {
              vm.roundtableSettings.isRaiseHandTabVisible =
                data.EnableRaiseHand;
            }
            if (typeof data.AllowAudienceViewText != undefined) {
              vm.roundtableSettings.AllowAudienceViewText =
                data.AllowAudienceViewText;
            }
            if (typeof data.SeatGrabText != undefined) {
              vm.roundtableSettings.SeatGrabText = data.SeatGrabText;
            }
            if (typeof data.TableFullText != undefined) {
              vm.roundtableSettings.TableFullText = data.TableFullText;
            }
            if (typeof data.ShowFilter != undefined) {
              vm.roundtableSettings.ShowFilter = data.ShowFilter;
            }
            if (typeof data.ShowSearch != undefined) {
              vm.roundtableSettings.ShowSearch = data.ShowSearch;
            }
            if (typeof data.AllowScreenShare != undefined) {
              vm.roundtableSettings.AllowScreenShare = data.AllowScreenShare;
            }
            if (typeof data.AllowRecording != undefined) {
              vm.roundtableSettings.AllowRecording = data.AllowRecording;
            }
            if (
              vm.roundtableSettings.AllowRecording &&
              typeof data.AutoStartRecording != undefined
            ) {
              vm.roundtableSettings.AutoStartRecording =
                data.AutoStartRecording;
            }
            if (
              data.RoundTableSettingsLogoLink &&
              data.RoundTableSettingsLogoLink != ""
            ) {
              vm.RoundTableSettingsLogoLink = data.RoundTableSettingsLogoLink;
            }
          }
        });
    },
    displayRoundTables() {
      vm.showRoundTableList = false;
      //alert("displayRoundTables");
      vm.recordingStarted = false;
      if (vm.exRoundTableId == "") {
        vm.stopRoundTable();
        vm.initCurrentSessionTimer();
      }
      vm.selectedRoundTableId = "";
      vm.selectedRoundTable = null;
      vm.roundTableList.forEach(function (rt) {
        if (rt.Listener) {
          rt.Listener();
        }
      });
      vm.roundTableList = [];
      let topicId = "";

      //alert(topicId);
      if (vm.selectedSession) {
        topicId = vm.selectedSession.SessionTypeDetails.RoundTableTopic.TopicId;
      }
      //alert(topicId);
      //alert(vm.event_collectionName);
      //if (vm.searchtext.trim() != "") {
      //db.collection(vm.event_collectionName)
      //  .doc("Settings")
      //  .collection("Roundtable")
      //  .doc("RoundtableSettings")
      //  .onSnapshot(function (doc) {
      //    if (doc.exists) {
      //      let data = doc.data();
      //      if (typeof data.ShowSpeakerList != undefined) {
      //        vm.isSpeakerTabVisible = data.ShowSpeakerList;
      //      }
      //      if (typeof data.ShowAttendeeList != undefined) {
      //        vm.isAttendeeTabVisible = data.ShowAttendeeList;
      //      }
      //      if (typeof data.EnableGroupChat != undefined) {
      //        vm.isChatTabVisible = data.EnableGroupChat;
      //      }
      //      if (typeof data.EnableRaiseHand != undefined) {
      //        vm.isRaiseHandTabVisible = data.EnableRaiseHand;
      //      }
      //    }
      let rtListRef = db
        .collection(vm.event_collectionName)
        .doc("RoundTableList")
        .collection("RoundTables")
        .where("IsPublished", "==", true);
      if (
        vm.exPageId == "" ||
        (vm.exPageId == "sn" && vm.selectedSessionTypeId == 4)
      ) {
        rtListRef = rtListRef.where("Topic.TopicId", "==", topicId);
      } else if (vm.exRoundTableId != "") {
        rtListRef = rtListRef.where("TableId", "==", vm.exRoundTableId);
      }
      rtListRef
        .get()
        .then((querySnapshot) => {
          vm.roundTableList.forEach(function (rt) {
            if (rt.Listener) {
              rt.Listener();
            }
          });
          vm.roundTableList = [];
          //alert("querySnapshot:" + querySnapshot.docs.length);
          querySnapshot.forEach((doc) => {
            var isMappedasAttendee = false;
            var isHost = false;
            var hostId = "0";
            let table = doc.data();

            var preassinedAtt = table.MappedAttendees;
            var preAssisgnedAtt = preassinedAtt.filter(function (value) {
              return value.AttendeeId == vm.uid;
            });
            if (preAssisgnedAtt.length > 0) {
              isMappedasAttendee = true;
            }
            var host = table.Host;
            if (host && host.length > 0) {
              hostId =
                host[0].AttendeeId == undefined ? "0" : host[0].AttendeeId;
              if (host[0].AttendeeId == vm.uid) {
                isHost = true;
              }
            }

            if (!table.PreAssigned) {
              vm.openRoundTablesCount++;
            }

            if (
              isHost ||
              isMappedasAttendee ||
              table.SpectatorEnabled ||
              !table.PreAssigned
            ) {
              var tbObj = new Object();
              //alert(doc.id);
              tbObj.TableId = doc.id;
              tbObj.HostId = hostId;
              //console.log(doc.id + "HostId:- " + hostId);
              tbObj.Name = table.TableName;
              tbObj.TableName = table.TableName;
              tbObj.RoundtableLogo = table.RoundtableLogo;
              tbObj.Occupied = table.Occupied;
              //tbObj.Capacity = parseInt(table.Capacity);
              tbObj.CustomLink = table.CustomLink;
              tbObj.StreamingClient = "";
              tbObj.StreamingClientLink = "";
              if (table.StreamingClient && table.StreamingClient.trim() != "") {
                tbObj.StreamingClient = table.StreamingClient.trim();
              }
              tbObj.Capacity = isNaN(table.Capacity) ? 12 : table.Capacity;
              if (tbObj.Capacity < 2) {
                tbObj.Capacity = 2;
              } else if (tbObj.Capacity > 16) {
                if (tbObj.StreamingClient.toLowerCase() != "zoom") {
                  tbObj.Capacity = 16;
                }
              }
              tbObj.IsHost = isHost;
              tbObj.IsMappedasAttendee = isMappedasAttendee;
              tbObj.PreAssigned = table.PreAssigned;
              tbObj.SpectatorEnabled = table.SpectatorEnabled;
              tbObj.IsTableFull = false;
              tbObj.MePresent = false;
              tbObj.Host = table.Host;
              tbObj.MappedAttendees = table.MappedAttendees;
              tbObj.AllowAutoJoin =
                isHost == true || isMappedasAttendee == true;
              tbObj.AvailSeatType = 4;

              if (isHost) {
                tbObj.AvailSeatType = 1;
              } else if (isMappedasAttendee) {
                tbObj.AvailSeatType = 3;
              }
              if (table.RoundtableLogo) {
                tbObj.Logo = table.RoundtableLogo;
              } else {
                tbObj.Logo = "";
              }
              if (table.RoundtableLogoLink) {
                tbObj.LogoLink = table.RoundtableLogoLink;
              } else {
                tbObj.LogoLink = "";
              }
              if (
                table.StreamingClientLink &&
                table.StreamingClientLink.trim() != ""
              ) {
                tbObj.StreamingClientLink = table.StreamingClientLink.trim();
              }
              if (tbObj.StreamingClient.toLowerCase() == "zoom") {
                //tbObj.Capacity = 300;
                tbObj.Zoom_Detail = doc.data().Zoom_Detail;
                //tbObj.AllowAutoJoin = false;
              }
              //let capacity = tbObj.Capacity.toString();
              //if (capacity.length == 1) {
              //  capacity = "0" + capacity;
              //}
              //tbObj.imgsrc = rtImagesHostInactive[tbObj.Capacity - 1][0];

              tbObj.JoinButtonLabel = vm.rtSettings.SeatGrabText;
              tbObj.JoinButtonClass = "";

              //tbObj.EndedByHost = false;
              //if (doc.data().EndedByHost) {
              //  tbObj.EndedByHost = doc.data().EndedByHost;
              //}
              tbObj.EndRequest = 0;
              if (doc.data().EndRequest) {
                tbObj.EndRequest = doc.data().EndRequest;
              }

              //if (
              //  tbObj.Name.toLowerCase().includes(vm.searchtext.toLowerCase())
              //) {
              table.SessionId = vm.selectedSessionId;

              if (
                tbObj.AvailSeatType < 4 ||
                !tbObj.PreAssigned ||
                tbObj.SpectatorEnabled
              ) {
                vm.roundTableList.push(tbObj);
              }
              //}
            }
          });
          setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip();
          }, 1000);
          //RT JOIN AND LEAVE LISTENER
          //alert(vm.roundTableList.length)
          //vm.roundTableListeners.forEach(function (item) {
          //  if (item) {
          //    item();
          //  }
          //});
          vm.roundTableList.forEach(function (rt) {
            if (rt.Listener) {
              rt.Listener();
            }
          });
          if (vm.roundTableList.length > 0) {
            vm.hasZoomTable = false;
            for (var j = 0; j < vm.roundTableList.length; j++) {
              if (
                vm.roundTableList[j].StreamingClient.toLowerCase() == "zoom"
              ) {
                if (vm.exRoundTableId == vm.roundTableList[j].TableId) {
                  vm.hasZoomTable = true;
                }
                vm.roundTablesLoadedCount++;
                if (vm.roundTableList.length == vm.roundTablesLoadedCount) {
                  vm.allRTParticipancesLoaded = true;
                  if (vm.exRoundTableId == "") {
                    $("#divRoundTablesContainer").show();
                  } else {
                    //vm.tryAutoJoinRoundTable();
                    vm.callSwitchingInProcess = true;
                    $("#divRoundTablesContainer").hide();
                    $("#divRoundTablesContainer").removeClass(
                      "multi-session-popup"
                    );
                    vm.startRoundTable(vm.exRoundTableId);
                  }
                }
                vm.roundTableList[j].listener = db
                  .collection(vm.event_collectionName)
                  .doc("RoundTableList")
                  .collection("RoundTables")
                  .doc(vm.roundTableList[j].TableId)
                  .onSnapshot((doc) => {
                    var table = doc.data();
                    var tables = vm.roundTableList.filter(function (t) {
                      return t.TableId == table.TableId;
                    });
                    if (tables.length > 0) {
                      tables[0].Occupied = table.Occupied;
                      if (tables[0].Occupied < tables[0].Capacity) {
                        tables[0].IsTableFull = false;
                        tables[0].JoinButtonLabel = vm.rtSettings.SeatGrabText;
                        tables[0].JoinButtonClass = "";
                      } else {
                        tables[0].IsTableFull = true;
                        tables[0].JoinButtonLabel = vm.rtSettings.TableFullText;
                        tables[0].JoinButtonClass = "rt-no-slots";
                      }
                    }
                  });
              } else {
                var participancesCollectionName =
                  "/" +
                  vm.event_collectionName +
                  "/RoundTableList/RoundTables/" +
                  vm.roundTableList[j].TableId +
                  "/Participances";
                // console.log(participancesCollectionName);

                let firstLoad = true;
                vm.roundTableList[j].Listener = db
                  .collection(participancesCollectionName)
                  // .where("IsActive", "==", true)
                  .onSnapshot((querySnapshot) => {
                    // console.log("listner callded");
                    if (!firstLoad) {
                      let changes = querySnapshot.docChanges();
                      changes.forEach(function (change) {
                        if (change.type == "modified") {
                          let data = change.doc.data();
                          if (vm.uid == data.AttendeeId) {
                            let muteRequest = data.MuteRequest
                              ? data.MuteRequest
                              : 0;
                            let unmuteRequest = data.UnmuteRequest
                              ? data.UnmuteRequest
                              : 0;
                            let leaveRequest = data.LeaveRequest
                              ? data.LeaveRequest
                              : 0;
                            if (muteRequest > vm.muteRequest) {
                              vm.muteRequest = muteRequest;
                              if (data.ForceMute != undefined) {
                                if (data.RequestedBy != vm.uid) {
                                  vm.livePlayer.forceMuteSpeaker(
                                    data.RequestedBy,
                                    0,
                                    data.ForceMute
                                  );
                                }
                              }
                            } else if (unmuteRequest > vm.unmuteRequest) {
                              vm.unmuteRequest = unmuteRequest;

                              if (data.RequestedBy != vm.uid) {
                                vm.livePlayer.forceMuteSpeaker(
                                  data.RequestedBy,
                                  1
                                );
                              }
                            } else if (leaveRequest > vm.leaveRequest) {
                              vm.leaveRequest = leaveRequest;
                              vm.livePlayer.onEndCall();
                              //alert(vm.leaveRequest);
                              //$("#endedRequestPopup").modal(
                              //  { backdrop: "static" },
                              //  "show"
                              //);
                              //setTimeout(() => {
                              //  $("#endedRequestPopup").modal("hide");
                              //}, 5000);
                            }
                          }
                        }
                      });
                    }

                    var members = [];
                    let attendeeCount = 0;
                    var pTableId;
                    let currentGuestList = [];
                    let currentAttendeeList = [];
                    let iAmInTheTable = false;
                    querySnapshot.forEach((doc) => {
                      var participant = doc.data();
                      // console.log(curDoc);
                      if (firstLoad) {
                        if (vm.uid == participant.AttendeeId) {
                          if (participant.MuteRequest) {
                            vm.muteRequest = participant.MuteRequest;
                          }
                          if (participant.UnmuteRequest) {
                            vm.unmuteRequest = participant.UnmuteRequest;
                          }
                          if (participant.LeaveRequest) {
                            vm.leaveRequest = participant.LeaveRequest;
                          }
                        }
                      }
                      pTableId = participant.TableId;
                      let attType = 1;
                      if (
                        participant.AttendeeType != undefined &&
                        participant.AttendeeType != null
                      ) {
                        attType = participant.AttendeeType;
                      }
                      //alert(attType);
                      if (participant.IsActive && attType > 0 && attType < 4) {
                        if (participant.AttendeeId == vm.uid) {
                          iAmInTheTable = true;
                        }
                        members.push(participant);
                      }
                      if (pTableId == vm.selectedRoundTableId) {
                        if (participant.IsActive) {
                          attendeeCount++;
                        }
                        if (participant.IsActive && attType == 4) {
                          currentAttendeeList.push(participant);
                        }
                        if (participant.IsActive && attType == 3) {
                          currentGuestList.push(participant);
                        }
                      }
                      firstLoad = false;
                    });
                    vm.updateSinglTable(pTableId, members, iAmInTheTable);
                    if (pTableId == vm.selectedRoundTableId) {
                      //alert(currentAttendeeList.length);
                      $("#spanAttendeeCount").text(attendeeCount);
                      if (
                        vm.newDesign &&
                        typeof vm.livePlayer.displayViewersCount == "function"
                      ) {
                        vm.livePlayer.displayViewersCount(true, attendeeCount);
                      }
                      vm.livePlayer.UpdateRTGuests(currentGuestList);
                      vm.rightPanel.UpdateGuestPanel(currentGuestList);
                      vm.rightPanel.UpdateAttendeePanel(currentAttendeeList);
                    }
                    //console.log(members);
                  });
                //vm.roundTableListeners.push(lstnr);
              }
            }
            //alert(vm.roundTableList.length);
            //if (vm.roundTableList.length == 1) {
            //  if (vm.roundTableList[0].AllowAutoJoin) {
            //    vm.startRoundTable(vm.roundTableList[0].TableId);
            //  }
            //}
            //if (!vm.hasZoomTable) {
            if (vm.roundTableList.length == 1) {
              if (vm.exRoundTableId != "") {
                //alert("tryAutoJoinRoundTable")
                //vm.tryAutoJoinRoundTable();
              } else {
                //vm.tryAutoJoinRoundTable();
              }
            } else {
              if (vm.exRoundTableId != "") {
                //vm.tryAutoJoinRoundTable();
              }
            }
            //} else {
            //  //alert("allRTParticipancesLoaded");
            //  if (!vm.allRTParticipancesLoaded) {
            //    vm.roundTablesLoadedCount++;
            //    if (vm.roundTableList.length == vm.roundTablesLoadedCount) {
            //      vm.allRTParticipancesLoaded = true;
            //    }
            //  }
            //}
            vm.allRoundTablesLoaded = true;
          } else {
            vm.allRoundTablesLoaded = true;
            //vm.showNextUpcomingSession();
          }
        }) //querySnapshot.forEach(doc =>  ENDING PART
        .catch((error) => {
          console.log(error);
        });
      //});
    },
    updateSinglTable: function (tableId, members, iAmInTheTable) {
      var filteredTables = vm.roundTableList.filter(function (tbl) {
        return tbl.TableId == tableId;
      });
      //if (vm.uid == "42001") {
      //	alert(tableId);
      //}
      //alert(filteredTables.length);
      if (filteredTables.length > 0) {
        let table = filteredTables[0];
        //if (vm.uid == "42001") {
        //  alert(table.HostId);
        //}
        table.Occupied = members.length;
        //var attendees = members.filter(function (value) {
        //  return (
        //    value.AttendeeId != table.HostId &&
        //    //value.AttendeeId != vm.uid &&
        //    value.IsActive == true
        //  );
        //});
        //var hosts = members.filter(function (value) {
        //  return value.AttendeeId == table.HostId && value.IsActive == true;
        //});
        let ids = members.filter(function (value) {
          return value.AttendeeId == vm.uid;
        });
        if (ids.length > 0) {
          table.MePresent = true;
        } else {
          table.MePresent = false;
        }
        if (table.Occupied > table.Capacity) {
          table.Occupied = table.Capacity;
        }
        let vacant = table.Capacity;
        if (table.HostId != vm.uid) {
          vacant--;
        }
        vacant -= ids.length;

        table.JoinButtonLabel = vm.rtSettings.SeatGrabText;
        table.JoinButtonClass = "";
        table.IsTableFull = false;
        if (table.HostId == vm.uid) {
          //Join As Host
          table.AvailSeatType = 1;
          //} else if (table.CoHostId == vm.uid) {
          //  //Join As CoHost
        } else if (table.PreAssigned) {
          if (table.AttendeeType == 3) {
            //Join As Speaker
            table.AvailSeatType = 3;
          } else if (table.SpectatorEnabled) {
            //Join As Audience
            table.AvailSeatType = 4;
            table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
            table.JoinButtonClass = "rt-spectate";
          }
        } else if (iAmInTheTable) {
          //Already Joined
          table.AvailSeatType = 3;
        } else if (vacant > 0) {
          //Join As Speaker
          table.AvailSeatType = 3;
        } else if (table.SpectatorEnabled) {
          //Join As Audience
          table.AvailSeatType = 4;
          table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
          table.JoinButtonClass = "rt-spectate";
          //alert("spectate");
        } else {
          table.IsTableFull = true;
          table.AvailSeatType = 0;
          table.JoinButtonLabel = vm.rtSettings.TableFullText;
          table.JoinButtonClass = "rt-no-slots";
        }
        vm.roundTableList = vm.roundTableList.filter(function () {
          return true;
        });

        if (!vm.allRTParticipancesLoaded) {
          vm.roundTablesLoadedCount++;
          if (vm.roundTableList.length == vm.roundTablesLoadedCount) {
            vm.allRTParticipancesLoaded = true;
            if (vm.exRoundTableId == "") {
              $("#divRoundTablesContainer").show();
            } else {
              //vm.tryAutoJoinRoundTable();
              vm.callSwitchingInProcess = true;
              $("#divRoundTablesContainer").hide();
              $("#divRoundTablesContainer").removeClass("multi-session-popup");
              vm.startRoundTable(vm.exRoundTableId);
            }
          }
        }
        //setTimeout(() => {
        //  $('[data-toggle="tooltip"]').tooltip();
        //}, 10000);
      }
    },
    tryAutoJoinRoundTable() {
      if (rtAutoJoinTimer) {
        clearInterval(rtAutoJoinTimer);
      }
      if (!vm.allRTParticipancesLoaded) {
        rtAutoJoinTimer = setInterval(() => {
          if (vm.allRTParticipancesLoaded) {
            let rTables = [];
            if (vm.exRoundTableId == "") {
              rTables = vm.roundTableList.filter(function (item) {
                return item.AllowAutoJoin || !item.IsTableFull;
              });
            } else {
              rTables = vm.roundTableList.filter(function (item) {
                return vm.exRoundTableId == item.TableId && !item.IsTableFull;
              });
            }
            //alert("AllowAutoJoin:" + rTables.length);
            if (rTables.length == 1) {
              //if(rTables[0].AllowAutoJoin)
              clearInterval(rtAutoJoinTimer);
              vm.startRoundTable(rTables[0].TableId);
            } else {
              vm.showRoundTableList = true;
              if (vm.exPageId != "") {
                if (vm.exRoundTableId == "") {
                  //
                }
                vm.allowLeavePage = true;
                router.push(vm.redirectToPath);
              }
              //vm.showNextUpcomingSession();
              //alert("showNextUpcomingSession");
            }
            //clearInterval(rtAutoJoinTimer);
          }
        }, 100);
      }
    },
    retryStartRoundTable() {
      vm.startRoundTable(vm.tempRoundTableId);
    },
    retryCancelRoundTable() {
      $("#rtTableFullRetryPopup").modal("hide");
    },
    stayHereCancel() {
      $("#stayHereConfirmPopup").modal("hide");
      vm.allowLeavePage = true;
      router.push(vm.redirectToPath);
    },
    stayHere() {
      $("#stayHereConfirmPopup").modal("hide");
      vm.showLoader();
      let docPath = "";
      if (vm.leaveTypeId && vm.leaveDocId) {
        if ([1, 2, 3].includes(vm.leaveTypeId)) {
          docPath = "SessionList/Sessions/" + vm.leaveDocId + "/Participances";
        } else if (vm.leaveTypeId == 4) {
          docPath =
            "RoundTableList/RoundTables/" + vm.leaveDocId + "/Participances";
        } else {
          docPath = "UserVideoActivity";
          if (vm.leaveTypeId == vm.GlobalKeysData.O2OTypeID) {
            docPath += "/OneToOneMeeting/" + vm.leaveDocId + "/Participances";
          } else if (vm.leaveTypeId == vm.GlobalKeysData.E2OTypeID) {
            docPath += "/ExhibitorMeeting/" + vm.leaveDocId + "/Participances";
          }
        }
        if (docPath) {
          vm.callSwitchingInProcess = true;
          vm.LeaveRequest = new Date().getTime();
          let headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + vm.getSessionToken(),
          };
          let requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: vm.clientId,
              eventId: vm.eventId,
              deviceId: "",
            },
            data: {
              docId: vm.leaveDocId,
              docPath: "RoundTableList/RoundTables",
            },
          };
          axios
            .post(APIs.LeaveSession, requestData, {
              headers: headers,
            })
            .then((responseData1) => {
              console.log(responseData1);
              vm.LeaveRequest = new Date().getTime();
              let headers = {
                "content-type": "application/json",
                Authorization: "Bearer " + vm.getSessionToken(),
              };
              let requestData = {
                collection: docPath,
                instance: vm.event_collectionName,
                data: {
                  LeaveRequest: vm.LeaveRequest,
                  RequestedBy: vm.uid,
                  id: vm.uid,
                },
              };
              axios
                .put(APIs.WriteObject, requestData, {
                  headers: headers,
                })
                .then((responseData) => {
                  //alert("Mute all");
                  console.log(responseData);
                  setTimeout(() => {
                    vm.hideLoader();

                    if (vm.leaveTypeId == 4) {
                      if (joinHereTimer) {
                        clearInterval(joinHereTimer);
                      }
                      let rTables = vm.roundTableList.filter(function (item) {
                        return item.TableId == vm.leaveDocId;
                      });
                      if (rTables.length > 0) {
                        if (
                          !rTables[0].MePresent &&
                          vm.allRTParticipancesLoaded
                        ) {
                          vm.startRoundTable(vm.leaveDocId);
                        } else {
                          joinHereTimer = setInterval(() => {
                            let rTables = vm.roundTableList.filter(function (
                              item
                            ) {
                              return item.TableId == vm.leaveDocId;
                            });
                            if (rTables.length > 0) {
                              if (
                                !rTables[0].MePresent &&
                                vm.allRTParticipancesLoaded
                              ) {
                                clearInterval(joinHereTimer);
                                vm.startRoundTable(vm.leaveDocId);
                              }
                            }
                          }, 2000);
                        }
                      }
                    }
                  }, 5000);
                })
                .catch(function (error) {
                  console.error("Error on mute all: ", error);
                });
            })
            .catch(function (error) {
              console.error("Error on mute all: ", error);
            });
        }
      }
    },
    stayHere1() {
      $("#stayHereConfirmPopup").modal("hide");
      vm.showLoader();
      let docPath = "";
      if (vm.leaveTypeId && vm.leaveDocId) {
        if ([1, 2, 3].includes(vm.leaveTypeId)) {
          docPath = "SessionList/Sessions/" + vm.leaveDocId + "/Participances";
        } else if (vm.leaveTypeId == 4) {
          docPath =
            "RoundTableList/RoundTables/" + vm.leaveDocId + "/Participances";
        } else {
          docPath = "UserVideoActivity";
          if (vm.leaveTypeId == vm.GlobalKeysData.O2OTypeID) {
            docPath += "/OneToOneMeeting/" + vm.leaveDocId + "/Participances";
          } else if (vm.leaveTypeId == vm.GlobalKeysData.E2OTypeID) {
            docPath += "/ExhibitorMeeting/" + vm.leaveDocId + "/Participances";
          }
        }
        if (docPath) {
          vm.callSwitchingInProcess = true;
          vm.LeaveRequest = new Date().getTime();
          let headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + vm.getSessionToken(),
          };
          let requestData = {
            collection: docPath,
            instance: vm.event_collectionName,
            data: {
              LeaveRequest: vm.LeaveRequest,
              RequestedBy: vm.uid,
              id: vm.uid,
            },
          };
          axios
            .put(APIs.WriteObject, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //alert("Mute all");
              console.log(responseData);
              setTimeout(() => {
                vm.hideLoader();

                if (vm.leaveTypeId == 4) {
                  if (joinHereTimer) {
                    clearInterval(joinHereTimer);
                  }
                  let rTables = vm.roundTableList.filter(function (item) {
                    return item.TableId == vm.leaveDocId;
                  });
                  if (rTables.length > 0) {
                    if (!rTables[0].MePresent && vm.allRTParticipancesLoaded) {
                      vm.startRoundTable(vm.leaveDocId);
                    } else {
                      joinHereTimer = setInterval(() => {
                        let rTables = vm.roundTableList.filter(function (item) {
                          return item.TableId == vm.leaveDocId;
                        });
                        if (rTables.length > 0) {
                          if (
                            !rTables[0].MePresent &&
                            vm.allRTParticipancesLoaded
                          ) {
                            clearInterval(joinHereTimer);
                            vm.startRoundTable(vm.leaveDocId);
                          }
                        }
                      }, 2000);
                    }
                  }
                }
              }, 5000);
            })
            .catch(function (error) {
              console.error("Error on mute all: ", error);
            });
        }
      }
    },
    getQueryParam(url, param) {
      var result = "";
      if (url && url.includes("?")) {
        var qryStr = url.split("?")[1];
        var query = {};
        var pairs = qryStr.split("&");
        for (var i = 0; i < pairs.length; i += 1) {
          var pair = pairs[i].split("=");
          query[decodeURIComponent(pair[0])] = decodeURIComponent(
            pair[1] || ""
          );
        }
        if (pair[param]) {
          result = pair[param];
        }
      }
      return result;
    },
    startRoundTable(tableId) {
      vm.showLoader();
      vm.showRoundTableList = false;
      //alert("tableId: " + tableId);
      let rTbls = vm.roundTableList.filter(function (item) {
        return item.TableId == tableId;
      });
      if (rTbls.length == 0) {
        return;
      } else if (rTbls[0].IsTableFull) {
        return;
      }
      if (tableId == vm.selectedRoundTableId) {
        $("#divLivePanelContainer").show();
        $("#divLivePanelContainer").removeClass("d-none");
        if (
          vm.selectedRoundTable &&
          vm.selectedRoundTable.StreamingClient.toLowerCase() == "web"
        ) {
          vm.hideLoader();
          return;
        }
      }
      //alert(rTbls[0].StreamingClient);
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (rTbls[0].StreamingClient.toLowerCase() == "zoom") {
        vm.retryType = "rt";
        vm.tempTableId = tableId;
        vm.hideLoader();
        var attendeeId = obj.user[0].id;
        var first_name = obj.user[0].fname;
        var last_name = obj.user[0].lname;
        if (rTbls[0].Host[0].AttendeeId == attendeeId) {
          var hlink =
            rTbls[0].Zoom_Detail.start_url +
            "&uname=" +
            first_name.trim() +
            "%20" +
            last_name.trim();
          window.open(hlink, "_blank");
          vm.postLeaderboardAction("RTSN");
        } else {
          vm.showLoader();
          //bus.$emit("toggleLoader", true);
          let headers = {
            Authorization: "Bearer " + vm.getSessionToken(),
            "content-type": "application/json",
          };
          let requestData = {
            email: vm.email,
            name: vm.name,
            first_name: vm.firstName,
            last_name: vm.lastName,
            meetingid: rTbls[0].Zoom_Detail.id,
            //address: "",
            //phone: vm.phone,
            //industry: "",
            //org: vm.company,
            //job_title: vm.title,
          };
          axios
            .post(APIs.AddAttendeesToZoom, requestData, {
              headers: headers,
            })
            .then((response) => {
              vm.hideLoader();
              if (
                response &&
                response.data &&
                response.data.status == 0 &&
                response.data.data.id &&
                response.data.data.join_url &&
                response.data.data.join_url != ""
              ) {
                vm.ZoomWebCall = false;
                if (!vm.ZoomWebEmbedEnabled) {
                  window.open(response.data.data.join_url, "_blank");
                } else {
                  var tk = vm.getQueryParam(response.data.data.join_url, "tk");
                  if (!tk) {
                    tk = rTbls[0].Zoom_Detail.tk;
                  }
                  if (tk) {
                    vm.ZoomWebCall = true;
                    vm.ZoomWebCallKey++;
                    var qryStr =
                      "?autojoin=true&name=" +
                      vm.name +
                      "&email=" +
                      vm.email +
                      "&role=0&mid=" +
                      rTbls[0].Zoom_Detail.id +
                      "&pwd=" +
                      rTbls[0].Zoom_Detail.password +
                      "&tk=" +
                      tk;
                    //window.open(vm.ZoomWebEmbedExternalURL + qryStr, "_blank");
                    vm.ZoomWebURL = vm.ZoomWebEmbedExternalURL + qryStr;

                    vm.meetingNumber = rTbls[0].Zoom_Detail.id;
                    vm.tk = tk;
                    setTimeout(() => {
                      vm.startZoomWebCall = true;
                      //vm.onRoundTableStart(tableId, rTbls[0]);
                    }, 1000);
                    vm.ShowPlayerRightPanel = false;

                    $("#divRoundTablesContainer").hide();
                    $("#divRoundTablesContainer").removeClass(
                      "multi-session-popup"
                    );
                    $("#divLivePanelContainer").show();
                    $("#divLivePanelContainer").removeClass("d-none");
                  } else {
                    window.open(response.data.data.join_url, "_blank");
                  }
                }
                if (vm.selectedSessionId == "") {
                  vm.postLeaderboardAction("RTOT");
                } else {
                  //vm.postLeaderboardAction("SNVW");
                  vm.postLeaderboardAction("RTSN");
                }
              } else {
                vm.retryJoinInZoomPopup();
              }
            })
            .catch((error) => {
              vm.hideLoader();
              //bus.$emit("toggleLoader", false);
              console.log(error);
              vm.retryJoinInZoomPopup();
            });
          //var link =
          //  rTbls[0].Zoom_Detail.join_url +
          //  "&uname=" +
          //  first_name.trim() +
          //  "%20" +
          //  last_name.trim();
          //window.open(link, "_blank");
          //vm.postLeaderboardAction("RTSN");
        }
      } else if (rTbls[0].StreamingClient.toLowerCase() == "custom") {
        //alert(vm.exPageId);
        //alert(vm.exExhibitorRT);
        //alert(vm.exSponsorRT);
        if (vm.exPageId == "sn") {
          vm.callSwitchingInProcess = true;
          if (
            vm.selectedRoundTable &&
            vm.selectedRoundTable.StreamingClient.toLowerCase() == "web"
          ) {
            vm.stopRoundTable();
          }
          vm.postLeaderboardAction("RTSN");
          vm.showRoundTableList = true;
          setTimeout(() => {
            vm.hideLoader();
            vm.callSwitchingInProcess = false;
            vm.selectedRoundTableId = tableId;
            vm.selectedRoundTable = rTbls[0];
            $("#divLivePanelContainer").hide();
            $("#divLivePanelContainer").addClass("d-none");
            $("#divRoundTablesContainer").show();
            window.open(rTbls[0].CustomLink, "_blank");
            //$("#divRoundTablesContainer").addClass("multi-session-popup");
          }, 1000);
        }
        //vm.callSwitchingInProcess = false;
        // else if (vm.exExhibitorRT) {
        //     vm.postLeaderboardAction("RTEB");
        // } else if (vm.exSponsorRT) {
        //     vm.postLeaderboardAction("RTEB");
        // }
      } else {
        // if (
        //   screen.width < 767 &&
        //   obj.AgoraPlayerBrowserSupportInMobile == false
        // ) {
        //   vm.hideLoader();
        //   vm.allowLeavePage = true;
        //   router.push("/screeninfo");
        // } else if (
        //   screen.width >= 768 &&
        //   screen.width <= 1024 &&
        //   obj.AgoraPlayerBrowserSupportInIPad == false
        // ) {
        //   vm.hideLoader();
        //   vm.allowLeavePage = true;
        //   router.push("/screeninfo");
        // } else {
          //alert("");
          $(".tooltip").tooltip("hide");
          vm.stopVideoPlayer();
          vm.stopLiveStream();
          let waitTime = 1;
          //alert(vm.selectedRoundTableId);
          if (vm.selectedRoundTableId != "" || vm.exRoundTableId != "") {
            if (vm.selectedRoundTableId == tableId) {
              return;
            } else {
              vm.callSwitchingInProcess = true;
              waitTime = 2000;
              vm.stopRoundTable();
            }
          }
          setTimeout(() => {
            vm.presence = null;
            let rTables = vm.roundTableList.filter(function (item) {
              return item.TableId == tableId;
            });
            if (rTables.length > 0 && !rTables[0].IsTableFull) {
              //if (rTables[0].MePresent) {
              //  //if (joinHereTimer) {
              //  //  clearInterval(joinHereTimer);
              //  //}
              //  //joinHereTimer = setInterval(() => {
              //  //	let rTables = vm.roundTableList.filter(function (item) {
              //  //		return item.TableId == vm.leaveDocId;
              //  //	});
              //  //	if (rTables.length > 0) {
              //  //		if (
              //  //			!rTables[0].MePresent &&
              //  //			vm.allRTParticipancesLoaded
              //  //		) {
              //  //			clearInterval(joinHereTimer);
              //  //			vm.startRoundTable(vm.leaveDocId);
              //  //		}
              //  //	}
              //  //}, 2000);
              //  vm.leaveTypeId = 4;
              //  vm.leaveDocId = rTables[0].TableId;
              //  $("#stayHereConfirmPopup").modal(
              //    { backdrop: "static" },
              //    "show"
              //  );
              //  vm.hideLoader();
              //  return;
              //}
              vm.callSwitchingInProcess = false;

              if (vm.leaveAndJoinViaAPI) {
                let headers = {
                  "content-type": "application/json",
                  Authorization: "Bearer " + vm.getSessionToken(),
                };
                let requestData = {
                  key: {
                    instanceId: "OA_UAT",
                    clientId: vm.clientId,
                    eventId: vm.eventId,
                  },
                  data: {
                    docId: tableId,
                    docPath: "RoundTableList/RoundTables",
                    user: {
                      Email: vm.email,
                      Designation: vm.designation,
                      FirstName: vm.firstName,
                      LastName: vm.lastName,
                      Name: vm.name,
                      Company: vm.company,
                      Country: vm.country,
                      ProfilePictureURL: vm.profilePictureURL,
                    },
                  },
                };
                axios
                  .post(APIs.JoinSession, requestData, {
                    headers: headers,
                  })
                  .then((responseData) => {
                    vm.hideLoader();
                    //alert("JoinSession Success: " + responseData.data.status);
                    console.log(responseData);
                    if (
                      responseData &&
                      responseData.data &&
                      responseData.data.status >= 0
                    ) {
                      vm.onRoundTableStart(tableId, rTables[0]);
                    } else {
                      vm.showRoundTableList = true;
                    }
                  })
                  .catch((error) => {
                    //alert("JoinSession Failure");
                    vm.showRoundTableList = true;
                    console.log("Start RT: " + error);
                  });
              } else {
                vm.selectedRoundTableId = "";
                vm.selectedRoundTable = null;
                var participancesCollectionName =
                  "/" +
                  vm.event_collectionName +
                  "/RoundTableList/RoundTables/" +
                  tableId +
                  "/Participances";
                db.collection(participancesCollectionName)
                  .where("IsActive", "==", true)
                  .get()
                  .then((querySnapshot) => {
                    vm.hideLoader();
                    let occupied = querySnapshot.docs.length;
                    let hosts = querySnapshot.docs.filter(function (doc) {
                      return doc.data().AttendeeId == rTables[0].HostId;
                    });
                    if (hosts.length == 0) {
                      occupied++;
                    }
                    //alert("Capacity: " + rTables[0].Capacity + "/" + occupied);
                    if (
                      rTables[0].Capacity > occupied ||
                      rTables[0].AvailSeatType == 4
                    ) {
                      //JOIN
                      vm.onRoundTableStart(tableId, rTables[0]);
                    } else {
                      vm.tempRoundTableId = tableId;
                      //alert(vm.tempRoundTableId);
                      $("#rtTableFullRetryPopup").modal(
                        { backdrop: "static" },
                        "show"
                      );
                    }
                  });
              }
            } else {
              //vm.stopRoundTable();
            }
          }, waitTime);
        // }
      }
    },
    onRoundTableStart(tableId, rTable) {
      vm.selectedRoundTableId = tableId;
      vm.selectedRoundTable = rTable;
      vm.initCurrentSessionTimer();
      vm.livePlayerChannel = vm.getChannelName();
      vm.applyPlayerBroadcastSettings(
        vm.GlobalKeysData.RoundTableTypeID,
        vm.selectedSessionId,
        vm.selectedRoundTableId
      );
      vm.RoundTableLogo = vm.selectedRoundTable.Logo;
      vm.RoundTableLogoLink = vm.selectedRoundTable.LogoLink;
      //let playerLogo = vm.currentPlayerLogo();
      //let playerLogoLink = vm.currentPlayerLogoLink();
      let settings = vm.roundtableSettings;
      settings.playerLogo = vm.currentPlayerLogo();
      settings.playerLogoLink = vm.currentPlayerLogoLink();
      vm.hideLoader();
      vm.livePlayer.StartCall(
        vm.clientId,
        vm.eventId,
        vm.livePlayerChannel,
        vm.GlobalKeysData.RoundTableTypeID,
        vm.selectedSession,
        vm.selectedRoundTable,
        null,
        vm.selectedRoundTable.AvailSeatType,
        settings
      );
      vm.callStarted = true;
      vm.setupRightPanel(
        vm.uid,
        vm.selectedRoundTable.AvailSeatType,
        vm.livePlayerChannel,
        vm.GlobalKeysData.RoundTableTypeID,
        vm.speakerProfiles,
        vm.selectedSession,
        vm.selectedRoundTable,
        null,
        vm.roundtableSettings
      );
      $("#divLivePanelContainer").show();
      $("#divLivePanelContainer").removeClass("d-none");
      $("#divRoundTablesContainer").hide();
      $("#divRoundTablesContainer").removeClass("multi-session-popup");
      vm.currentStage = 2;

      if (!vm.leaveAndJoinViaAPI) {
        vm.joinRoundTable(
          vm.selectedRoundTableId,
          vm.uid,
          vm.selectedRoundTable.AllowAutoJoin,
          vm.selectedRoundTable.AvailSeatType
        );
      }
      var participanceCollectionName =
        "/" +
        vm.event_collectionName +
        "/RoundTableList/RoundTables/" +
        tableId +
        "/Participances/" +
        vm.uid;
      var sessionPath =
        "/" +
        vm.event_collectionName +
        "/RoundTableList/RoundTables/" +
        tableId;
      //alert(vm.roundTableList.length);
      if (vm.roundTableList.length > 1) {
        //alert(vm.roundTableList.length);
        vm.switchTableVisible = true;
        if (typeof vm.livePlayer.displaySwitchTable == "function") {
          vm.livePlayer.displaySwitchTable(true);
        }
      }
      vm.startKeepMeActiveInRoundTable(
        vm.selectedRoundTableId,
        vm.uid,
        vm.selectedRoundTable.AvailSeatType
      );
      vm.showRoundTableList = true;
      if (vm.selectedSessionId != "" && tableId != vm.exRoundTableId) {
        router.push(vm.stageUrl + "/" + vm.selectedSessionId + "/" + tableId);
      }
      //alert("before presence");
      vm.createPresence(tableId, participanceCollectionName, sessionPath, true);
      //if (typeof vm.livePlayer.displaySwitchTable == "function") {
      //  vm.livePlayer.displaySwitchTable(vm.roundTableList.length > 1);
      //}
    },
    stopRoundTable() {
      vm.livePlayer.onEndCall();
      vm.hideRightPanel();
      vm.stopKeepMeActiveInRoundTable();
    },
    joinRoundTable(tableId, attendeeId, isAttendeeMapped, availSeatType) {
      //alert();
      //console.log(isAttendeeMapped);
      var participancesCollectionName =
        "/" +
        vm.event_collectionName +
        "/RoundTableList/RoundTables/" +
        tableId +
        "/Participances/" +
        attendeeId;
      var sessionPath =
        "/" +
        vm.event_collectionName +
        "/RoundTableList/RoundTables/" +
        tableId;
      db.doc(participancesCollectionName)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let userAgent = navigator.userAgent;
            if (doc.data().UserAgent == "") {
              db.doc(participancesCollectionName)
                .update({
                  AttendeeType: availSeatType,
                  IsActive: true,
                  JoinTime: doc.data().JoinTime
                    ? doc.data().JoinTime
                    : new Date(),
                  LastActiveTimestamp: new Date(),
                  UserAgent: userAgent,
                  userIP: "",
                })
                .then(function () {
                  vm.createPresence(
                    tableId,
                    participancesCollectionName,
                    sessionPath,
                    true
                  );
                })
                .catch(function (error) {
                  console.error("Error creating Sessions: ", error);
                });
            } else {
              db.doc(participancesCollectionName)
                .update({
                  AttendeeType: availSeatType,
                  IsActive: true,
                  LastActiveTimestamp: new Date(),
                  UserAgent: userAgent,
                  userIP: "",
                })
                .then(function () {
                  vm.createPresence(
                    tableId,
                    participancesCollectionName,
                    sessionPath,
                    true
                  );
                })
                .catch(function (error) {
                  console.error("Error creating Sessions: ", error);
                });
            }
          } else {
            if (isAttendeeMapped || availSeatType > 0) {
              //let attendeeType = vm.getRTAttendeeType();
              //if (attendeeType == 4) {
              //  attendeeType == 0;
              //}
              let userAgent = navigator.userAgent;
              db.doc(participancesCollectionName)
                .set({
                  AttendeeId: vm.uid,
                  AttendeeType: availSeatType,
                  Company: vm.company,
                  Country: vm.country,
                  Designation: vm.designation,
                  FirstName: vm.firstName,
                  LastName: vm.lastName,
                  Name: vm.name,
                  ProfilePictureURL: vm.profilePictureURL,
                  IsActive: true,
                  JoinTime: new Date(),
                  LastActiveTimestamp: new Date(),
                  LeaveTime: null,
                  TableId: tableId,
                  UserAgent: userAgent,
                  userIP: "",
                })
                .then(function () {
                  vm.createPresence(
                    tableId,
                    participancesCollectionName,
                    sessionPath,
                    true
                  );
                })
                .catch(function (error) {
                  console.error("Error creating Sessions: ", error);
                });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    keepMeActiveInRoundTable(tableId, attendeeId, availSeatType) {
      var participancesCollectionName =
        "/" +
        vm.event_collectionName +
        "/RoundTableList/RoundTables/" +
        tableId +
        "/Participances/" +
        attendeeId;
      db.doc(participancesCollectionName)
        .get()
        .then((doc) => {
          if (doc.exists) {
            db.doc(participancesCollectionName)
              .update({
                AttendeeType: availSeatType,
                IsActive: true,
                LastActiveTimestamp: new Date(),
              })
              .then(function () {
                //
              })
              .catch(function (error) {
                console.error("Error creating Sessions: ", error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    leaveRoundTable(tableId, attendeeId) {
      vm.stopKeepMeActiveInRoundTable();
      console.log(attendeeId);
      if (vm.leaveAndJoinViaAPI) {
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
            eventId: vm.eventId,
            deviceId: vm.presence.deviceId,
          },
          data: {
            docId: tableId,
            docPath: "RoundTableList/RoundTables",
          },
        };
        axios
          .post(APIs.LeaveSession, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            //alert("LeaveSession Success: "+responseData.data.status);
            console.log(responseData);
            //vm.createPresence(participancesCollectionName, sessionPath, false);
          })
          .catch((error) => {
            console.log("Start RT: " + error);
          });
      } else {
        var participancesCollectionName =
          "/" +
          vm.event_collectionName +
          "/RoundTableList/RoundTables/" +
          tableId +
          "/Participances/" +
          attendeeId;
        var sessionPath =
          "/" +
          vm.event_collectionName +
          "/RoundTableList/RoundTables/" +
          tableId;
        db.doc(participancesCollectionName)
          .get()
          .then((doc) => {
            if (doc.exists) {
              db.doc(participancesCollectionName)
                .update({
                  IsActive: false,
                  LeaveTime: new Date(),
                })
                .then(function () {
                  vm.createPresence(
                    participancesCollectionName,
                    sessionPath,
                    false
                  );
                })
                .catch(function (error) {
                  console.error("Error creating Sessions: ", error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getRTAttendeeType() {
      let userType = 4;
      let hosts = vm.selectedRoundTable.Host.filter(function (item) {
        return item.AttendeeId == vm.uid;
      });
      if (hosts.length > 0) {
        userType = 1;
      } else {
        let guests = vm.selectedRoundTable.MappedAttendees.filter(function (
          item
        ) {
          return item.AttendeeId == vm.uid;
        });
        if (guests.length > 0) {
          userType = 3;
        }
      }
      return userType;
    },
    showNextUpcomingSession() {
      let sessionEnded = true;
      let currentTime = parseInt(new Date().getTime() / 1000);
      let rtSessionIDs = [];
      vm.sessionList.forEach(function (item) {
        if (item.StartTimeS > currentTime) {
          if (
            item.SessionTypeDetails.TypeID != vm.GlobalKeysData.RoundTableTypeID
          ) {
            rtSessionIDs.push(item.SessionId);
          } else {
            sessionEnded = false;
          }
        }
      });

      if (rtSessionIDs.length > 0) {
        //let hasMySession = false;
        //check tables (with topicId) attendee mapping
        //hasMySession = true;
      } else if (sessionEnded) {
        //Show End Message
        vm.selectedSessionTypeId = -1;
        //if (sessionSwitchTimer) {
        //  clearInterval(sessionSwitchTimer);
        //}
      }
    },
    //ROUND TABLE END

    //E2O START
    startOneToOneMeeting() {
      vm.notificationSent = false;
      vm.showLoader();
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // if (
      //   screen.width < 767 &&
      //   obj.AgoraPlayerBrowserSupportInMobile == false
      // ) {
      //   vm.allowLeavePage = true;
      //   router.push("/screeninfo");
      //   vm.hideLoader();
      // } else if (
      //   screen.width >= 768 &&
      //   screen.width <= 1024 &&
      //   obj.AgoraPlayerBrowserSupportInIPad == false
      // ) {
      //   vm.allowLeavePage = true;
      //   router.push("/screeninfo");
      //   vm.hideLoader();
      // } else {
        if (
          obj &&
          obj.MeetingSettings &&
          obj.MeetingSettings.length > 0 &&
          obj.MeetingSettings[0].Duration
        ) {
          let duration = parseInt(obj.MeetingSettings[0].Duration);
          if (isNaN(duration)) {
            duration = 15;
          }

          var meetingCollection =
            "/" +
            vm.event_collectionName +
            "/MeetingList/Meetings/" +
            vm.exMeetingId;
          db.doc(meetingCollection)
            .get()
            .then((doc) => {
              if (doc.exists) {
                $("#divLiveVideoContainer").hide();
                $("#divLiveStreamContainer").hide();
                $("#divSessionsContainer").hide();
                $("#divRoundTablesContainer").hide();
                $("#divRoundTablesContainer").removeClass(
                  "multi-session-popup"
                );

                let requestorId = "";
                let inviteeId = "";
                let requestorName = "";
                let requestorFirstName = "";
                let requestorProfilePictureURL = "";
                let inviteeName = "";
                let inviteeFirstName = "";
                let inviteeProfilePictureURL = "";
                var meeting = doc.data();
                let requestor = meeting.Requestor;
                let invitee = meeting.Invitee;
                if (requestor && requestor.AttendeeId) {
                  requestorId = requestor.AttendeeId;
                  requestorName = requestor.Name;
                  requestorFirstName = requestor.FirstName;
                  requestorProfilePictureURL = requestor.ProfilePictureURL;
                }
                if (invitee && invitee.AttendeeId) {
                  inviteeId = invitee.AttendeeId;
                  inviteeName = invitee.Name;
                  inviteeFirstName = invitee.FirstName;
                  inviteeProfilePictureURL = invitee.ProfilePictureURL;
                }
                if (vm.uid == requestorId || vm.uid == inviteeId) {
                  var curentTime = parseInt(new Date().getTime() / 1000);
                  //alert(meeting.StartDateTime.toDate().getTime());
                  //alert(meeting.Slots[0]);
                  //alert(new Date(meeting.Slots[0]));
                  let startTime =
                    parseInt(new Date(meeting.Slots[0]).getTime() / 1000) -
                    vm.MeetingTimeExceptionSeconds;
                  let endTime = startTime + duration * 60;
                  //alert(meetingStartTime);
                  //alert(meetingEndTime);
                  //alert(startTime);
                  //alert(curentTime);
                  if (curentTime < startTime) {
                    alert("Meeting not yet started.");
                    vm.allowLeavePage = true;
                    router.push(vm.redirectToPath);
                    return;
                  }
                  if (curentTime > endTime) {
                    alert("Meeting ended.");
                    vm.allowLeavePage = true;
                    router.push(vm.redirectToPath);
                    return;
                  }
                  vm.callSwitchingInProcess = false;
                  if (!meeting.StreamingClient) {
                    meeting.StreamingClient = "Web";
                  }
                  if (meeting.StreamingClient.toLowerCase() == "zoom") {
                    vm.retryType = "o2o";
                    if (
                      meeting &&
                      meeting.Host &&
                      meeting.Host.length > 0 &&
                      meeting.Zoom_Detail &&
                      meeting.Zoom_Detail.id
                    ) {
                      if (vm.uid == meeting.Host[0].AttendeeId) {
                        var hlink =
                          meeting.Zoom_Detail.start_url +
                          "&uname=" +
                          vm.firstName.trim() +
                          "%20" +
                          vm.lastName.trim();
                        window.open(hlink, "_blank");
                        vm.postLeaderboardAction("O2OA");
                      } else {
                        vm.showLoader();
                        //bus.$emit("toggleLoader", true);
                        let headers = {
                          Authorization: "Bearer " + vm.getSessionToken(),
                          "content-type": "application/json",
                        };
                        let requestData = {
                          email: vm.email,
                          name: vm.name,
                          first_name: vm.firstName,
                          last_name: vm.lastName,
                          meetingid: meeting.Zoom_Detail.id,
                          //address: "",
                          //phone: vm.phone,
                          //industry: "",
                          //org: vm.company,
                          //job_title: vm.title,
                        };
                        axios
                          .post(APIs.AddAttendeesToZoom, requestData, {
                            headers: headers,
                          })
                          .then((response) => {
                            vm.hideLoader();
                            //bus.$emit("toggleLoader", false);
                            if (
                              response &&
                              response.data &&
                              response.data.status == 0 &&
                              response.data.data.id &&
                              response.data.data.join_url &&
                              response.data.data.join_url != ""
                            ) {
                              window.open(
                                response.data.data.join_url,
                                "_blank"
                              );
                              vm.postLeaderboardAction("O2OA");
                            } else {
                              vm.retryJoinInZoomPopup();
                            }
                          })
                          .catch((error) => {
                            vm.hideLoader();
                            //bus.$emit("toggleLoader", false);
                            console.log(error);
                            vm.retryJoinInZoomPopup();
                          });
                      }
                    } else {
                      alert(vm.zoomErrorMsg);
                    }
                  } else {
                    vm.o2oMeeting = {
                      MeetingTitle:
                        "Room: " +
                        requestorFirstName +
                        " - " +
                        inviteeFirstName,
                      RequestorId: requestorId,
                      RequestorName: requestorName,
                      RequestorProfilePictureURL: requestorProfilePictureURL,
                      InviteeId: inviteeId,
                      InviteeName: inviteeName,
                      InviteeProfilePictureURL: inviteeProfilePictureURL,
                      Duration: duration,
                      StartTime: startTime,
                      EndTime: endTime,
                    };
                    //let startDate = moment(
                    //  vm.GetTimeByZone(meeting.Slots[0], moment.tz.guess())
                    //);
                    //alert(startDate);
                    //let endDate=startDate.
                    vm.livePlayerChannel = vm.getChannelName();
                    //alert(vm.livePlayerChannel);
                    //alert(vm.selectedSessionTypeId);
                    vm.applyPlayerBroadcastSettings(
                      vm.selectedSessionTypeId,
                      "",
                      ""
                    );
                    let attendeeType = 3;
                    if (vm.uid == requestorId) {
                      attendeeType = 1;
                    }
                    let playerLogo = vm.currentPlayerLogo();
                    let playerLogoLink = vm.currentPlayerLogoLink();
                    vm.livePlayer.StartCall(
                      vm.clientId,
                      vm.eventId,
                      vm.livePlayerChannel,
                      vm.selectedSessionTypeId,
                      null,
                      null,
                      null,
                      attendeeType,
                      {
                        playerLogo: playerLogo,
                        playerLogoLink: playerLogoLink,
                      },
                      vm.exMeetingId,
                      vm.o2oMeeting.RequestorId
                    );
                    //alert(vm.exMeetingId);
                    vm.setupRightPanel(
                      vm.uid,
                      attendeeType,
                      vm.livePlayerChannel,
                      vm.selectedSessionTypeId,
                      vm.speakerProfiles,
                      null,
                      null,
                      null,
                      null
                    );
                    $("#pHeaderSessionName").html(vm.o2oMeeting.MeetingTitle);
                    $("#pHeaderSessionName").attr(
                      "attr",
                      vm.o2oMeeting.MeetingTitle
                    );
                    $("#menuSessionInfo p").html(vm.o2oMeeting.MeetingTitle);
                    vm.joinMeeting();
                    //alert("joinMeeting");
                    $("#divLivePanelContainer").show();
                    $("#divLivePanelContainer").removeClass("d-none");
                    vm.initCurrentMeetingTimer();
                    vm.hideLoader();
                  }
                } else {
                  alert("Invalid Meeting");
                  vm.allowLeavePage = true;
                  router.push(vm.redirectToPath);
                  vm.hideLoader();
                }
              } else {
                alert("Invalid Meeting");
                vm.allowLeavePage = true;
                router.push(vm.redirectToPath);
                vm.hideLoader();
              }
            })
            .catch((error) => {
              console.log(error);
              vm.hideLoader();
            });
        } else {
          console.log("Invalid Meeting Settings");
          vm.allowLeavePage = true;
          router.push(vm.redirectToPath);
          vm.hideLoader();
        }
      // }
    },
    getMeetingCurrentStatus: function (StartDateTime, EndDateTime) {
      var dtStartDateTime = new Date(StartDateTime);
      var dtEndDateTime = new Date(EndDateTime);

      var MeetingCurrentStatus = "";
      var dtcurrentDate = new Date();

      if (dtStartDateTime > dtcurrentDate) {
        MeetingCurrentStatus = "Upcoming";
      }
      if (dtStartDateTime < dtcurrentDate && dtEndDateTime < dtcurrentDate) {
        MeetingCurrentStatus = "Meeting Ended";
      }
      if (dtStartDateTime < dtcurrentDate && dtEndDateTime >= dtcurrentDate) {
        MeetingCurrentStatus = "Live";
      }
      return MeetingCurrentStatus;
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    startExhibitorMeeting() {
      vm.notificationSent = false;
      vm.hideLoader();
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // if (
      //   screen.width < 767 &&
      //   obj.AgoraPlayerBrowserSupportInMobile == false
      // ) {
      //   vm.allowLeavePage = true;
      //   router.push("/screeninfo");
      // } else if (
      //   screen.width >= 768 &&
      //   screen.width <= 1024 &&
      //   obj.AgoraPlayerBrowserSupportInIPad == false
      // ) {
      //   vm.allowLeavePage = true;
      //   router.push("/screeninfo");
      // } else {
        vm.livePlayerChannel = vm.getChannelName();
        //alert(vm.livePlayerChannel);
        //alert(vm.selectedSessionTypeId);
        vm.applyPlayerBroadcastSettings(vm.selectedSessionTypeId, "", "");
        let attendeeType = 3;
        if (vm.isE2OMeetingRep) {
          attendeeType = 1;
        }
        let playerLogo = vm.currentPlayerLogo();
        let playerLogoLink = vm.currentPlayerLogoLink();
        vm.livePlayer.StartCall(
          vm.clientId,
          vm.eventId,
          vm.livePlayerChannel,
          vm.selectedSessionTypeId,
          null,
          null,
          null,
          attendeeType,
          {
            playerLogo: playerLogo,
            playerLogoLink: playerLogoLink,
          },
          vm.exMeetingId,
          vm.exAttendee1Id
        );
        //alert(vm.exMeetingId);
        vm.setupRightPanel(
          vm.uid,
          attendeeType,
          vm.livePlayerChannel,
          vm.selectedSessionTypeId,
          vm.speakerProfiles,
          null,
          null,
          null,
          null
        );
        //$("#pHeaderSessionName").html("Meeting");
        //$("#pHeaderSessionName").attr("attr", "Meeting");
        $("#menuSessionInfo p").html("");
        vm.joinMeeting();
        //alert("joinMeeting");
        $("#divLivePanelContainer").show();
        $("#divLivePanelContainer").removeClass("d-none");
      // }
    },
    startVideoChat() {
      //alert("startVideoChat");
      $("#divSessionsContainer").hide();
      $("#divLivePanelContainer").show();
      $("#divLivePanelContainer").removeClass("d-none");
      vm.notificationSent = false;
      //vm.hideLoader();
      // var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // if (
      //   screen.width < 767 &&
      //   obj.AgoraPlayerBrowserSupportInMobile == false
      // ) {
      //   vm.allowLeavePage = true;
      //   router.push("/screeninfo");
      // } else if (
      //   screen.width >= 768 &&
      //   screen.width <= 1024 &&
      //   obj.AgoraPlayerBrowserSupportInIPad == false
      // ) {
      //   vm.allowLeavePage = true;
      //   router.push("/screeninfo");
      // } else {
        vm.livePlayerChannel = vm.getChannelName();
        //alert(vm.livePlayerChannel);
        //alert(vm.selectedSessionTypeId);
        vm.applyPlayerBroadcastSettings(vm.selectedSessionTypeId, "", "");
        let attendeeType = 3;
        if (vm.isE2OMeetingRep) {
          attendeeType = 1;
        }
        let playerLogo = vm.currentPlayerLogo();
        let playerLogoLink = vm.currentPlayerLogoLink();
        //vm.hideLoader();
        vm.livePlayer.StartCall(
          vm.clientId,
          vm.eventId,
          vm.livePlayerChannel,
          vm.selectedSessionTypeId,
          null,
          null,
          null,
          attendeeType,
          {
            playerLogo: playerLogo,
            playerLogoLink: playerLogoLink,
          },
          vm.exMeetingId,
          vm.exAttendee1Id
        );
        //alert(vm.exMeetingId);
        vm.setupRightPanel(
          vm.uid,
          attendeeType,
          vm.livePlayerChannel,
          vm.selectedSessionTypeId,
          vm.speakerProfiles,
          null,
          null,
          null,
          null,
          null
        );
        //$("#pHeaderSessionName").html("Meeting");
        //$("#pHeaderSessionName").attr("attr", "Meeting");
        //$("#menuSessionInfo p").html("");
        vm.joinMeeting();
        //alert("joinMeeting");
        $("#divLivePanelContainer").show();
        $("#divLivePanelContainer").removeClass("d-none");
        setTimeout(() => {
          vm.hideLoader();
        }, 100);
      // }
    },
    joinMeeting(sendNotification) {
      //alert("selectedSessionId:" + vm.selectedSessionTypeId);
      //alert("event_collectionName:" + vm.event_collectionName);
      var collectionName = "/" + vm.event_collectionName + "/UserVideoActivity";
      var sessionPath = "/" + vm.event_collectionName + "/UserVideoActivity";
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
        collectionName += "/OneToOneMeeting";
        sessionPath += "/OneToOneMeeting";
      } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
        collectionName += "/ExhibitorMeeting";
        sessionPath += "/ExhibitorMeeting";
      } else if (vm.selectedSessionTypeId == 100) {
        collectionName += "/ChatRoom";
        sessionPath += "/ChatRoom";
      }
      if (vm.selectedSessionTypeId == 100) {
        collectionName += "/" + vm.roomId + "/Participances/" + vm.uid;
        sessionPath += "/" + vm.roomId;
      } else {
        collectionName += "/" + vm.exMeetingId + "/Participances/" + vm.uid;
        sessionPath += "/" + vm.exMeetingId;
      }
      //
      //alert("sessionPath:" + sessionPath);
      //alert("collectionName:" + collectionName);
      let userAgent = navigator.userAgent;
      db.doc(collectionName)
        .get()
        .then((doc) => {
          //alert();
          if (doc.exists) {
            db.doc(collectionName)
              .update({
                IsActive: true,
                JoinTime: doc.data().JoinTime
                  ? doc.data().JoinTime
                  : new Date(),
                LastActiveTimestamp: new Date(),
                UserAgent: userAgent,
                userIP: "",
              })
              .then(function () {
                if (sendNotification) {
                  vm.sendMeetingNotification(sendNotification, 1);
                }
                vm.createPresence(
                  vm.exMeetingId,
                  collectionName,
                  sessionPath,
                  true
                );
                //alert("updated");
              })
              .catch(function (error) {
                //alert(error);
                console.log("Error creating Sessions: ", error);
              });
          } else {
            db.doc(collectionName)
              .set({
                AttendeeId: vm.uid,
                Company: vm.company,
                Country: vm.country,
                Designation: vm.designation,
                FirstName: vm.firstName,
                LastName: vm.lastName,
                Name: vm.name,
                ProfilePictureURL: vm.profilePictureURL,
                IsActive: true,
                JoinTime: new Date(),
                LastActiveTimestamp: new Date(),
                LeaveTime: null,
                UserAgent: userAgent,
                userIP: "",
              })
              .then(function () {
                if (sendNotification) {
                  vm.sendMeetingNotification(sendNotification, 1);
                }
                vm.createPresence(
                  vm.exMeetingId,
                  collectionName,
                  sessionPath,
                  true
                );
                //alert("added");
              })
              .catch(function (error) {
                //alert(error);
                console.error("Error creating Sessions: ", error);
              });
          }
        })
        .catch((error) => {
          //alert(error);
          console.log(error);
        });
    },
    leaveMeeting() {
      var collectionName = "/" + vm.event_collectionName + "/UserVideoActivity";
      var sessionPath = "/" + vm.event_collectionName + "/UserVideoActivity";
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
        collectionName += "/OneToOneMeeting";
        sessionPath += "/OneToOneMeeting";
      } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
        collectionName += "/ExhibitorMeeting";
        sessionPath += "/ExhibitorMeeting";
      } else if (vm.selectedSessionTypeId == 100) {
        collectionName += "/ChatRoom";
        sessionPath += "/ChatRoom";
      }
      if (vm.selectedSessionTypeId == 100) {
        collectionName += "/" + vm.roomId + "/Participances/" + vm.uid;
        sessionPath += "/" + vm.roomId;
      } else {
        collectionName += "/" + vm.exMeetingId + "/Participances/" + vm.uid;
        sessionPath += "/" + vm.exMeetingId;
      }

      //alert("JoinMeeting:" + collectionName);
      let userAgent = navigator.userAgent;
      db.doc(collectionName)
        .get()
        .then((doc) => {
          if (doc.exists) {
            db.doc(collectionName)
              .update({
                IsActive: false,
                LeaveTime: new Date(),
                LastActiveTimestamp: new Date(),
                UserAgent: userAgent,
                userIP: "",
              })
              .then(function () {
                if (vm.selectedSessionTypeId == 100) {
                  vm.sendMeetingNotification(true, 0);
                }
                vm.createPresence(
                  vm.exMeetingId,
                  collectionName,
                  sessionPath,
                  false
                );
                //alert("leaved");
              })
              .catch(function (error) {
                //alert(error);
                console.error("Error creating Sessions: ", error);
              });
          }
        })
        .catch((error) => {
          //alert(error);
          console.log(error);
        });
    },
    sendMeetingNotification(sendNotification, actionType) {
      if (sendNotification && !vm.notificationSent) {
        vm.notificationSent = true;
      } else {
        return;
      }
      var collectionName = "/" + vm.event_collectionName + "/UserVideoActivity";
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
        collectionName += "/OneToOneMeeting";
      } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
        collectionName += "/ExhibitorMeeting";
      } else if (vm.selectedSessionTypeId == 100) {
        collectionName += "/ChatRoom";
      }
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
        collectionName +=
          "/" +
          vm.exMeetingId +
          "/Participances/" +
          (vm.o2oMeeting.RequestorId == vm.uid
            ? vm.o2oMeeting.InviteeId
            : vm.o2oMeeting.RequestorId);
        db.doc(collectionName)
          .get()
          .then((doc) => {
            //var flag = false;
            //querySnapshot.forEach(function (doc) {
            //  var data = doc.data();
            //  if (data.AttendeeId != vm.uid && data.IsActive) {
            //    flag = true;
            //  }
            //});
            if (!doc.exists || !doc.data().IsActive) {
              //alert("sessionPath:" + sessionPath);
              //alert("collectionName:" + collectionName);
              let headers = {
                "content-type": "application/json",
                Authorization: "Bearer " + vm.getSessionToken(),
              };
              let requestData = {
                key: {
                  instanceId: "OA_UAT",
                  clientId: vm.clientId,
                  eventId: vm.eventId,
                  channelId: vm.exMeetingId + "_o2o",
                  meetingId: vm.exMeetingId,
                  meetingType: "One2OneMeeting/MeetingJoined",
                },
                data: [
                  {
                    AttendeeId:
                      vm.o2oMeeting.RequestorId == vm.uid
                        ? vm.o2oMeeting.InviteeId
                        : vm.o2oMeeting.RequestorId,
                    Name:
                      vm.o2oMeeting.RequestorId == vm.uid
                        ? vm.o2oMeeting.RequestorName
                        : vm.o2oMeeting.InviteeName,
                    ProfilePictureURL:
                      vm.o2oMeeting.RequestorId == vm.uid
                        ? vm.o2oMeeting.RequestorProfilePictureURL
                        : vm.o2oMeeting.InviteeProfilePictureURL,
                  },
                ],
              };
              axios
                .post(APIs.SendMeetingPush, requestData, {
                  headers: headers,
                })
                .then((responseData) => {
                  vm.hideLoader();
                  //alert("SendMeetingPush Success");
                  console.log(responseData);
                })
                .catch((error) => {
                  //alert("SendMeetingPush Failure");
                  console.log("Start RT: " + error);
                });
            }
          })
          .catch((error) => {
            //alert(error);
            console.log(error);
          });
      } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
        if (vm.exAttendee1Id != vm.uid) {
          collectionName +=
            "/" + vm.exMeetingId + "/Participances/" + vm.exAttendee1Id;
          db.doc(collectionName)
            .get()
            .then((doc) => {
              if (doc.exists || doc.data().IsActive) {
                let headers = {
                  "content-type": "application/json",
                  Authorization: "Bearer " + vm.getSessionToken(),
                };
                let requestData = {
                  key: {
                    instanceId: "OA_UAT",
                    clientId: vm.clientId,
                    eventId: vm.eventId,
                    channelId: vm.exMeetingId,
                    meetingId: vm.exExhibitorId,
                    meetingType: "ExhibitorMeeting/VideoCallJoined",
                  },
                  data: [
                    {
                      AttendeeId: vm.exAttendee1Id,
                      Name: vm.name,
                      ProfilePictureURL: vm.profilePictureURL,
                    },
                  ],
                };
                axios
                  .post(APIs.SendMeetingPush, requestData, {
                    headers: headers,
                  })
                  .then((responseData) => {
                    vm.hideLoader();
                    //alert("SendMeetingPush Success");
                    console.log(responseData);
                  })
                  .catch((error) => {
                    //alert("SendMeetingPush Failure");
                    console.log("Start RT: " + error);
                  });
              }
            })
            .catch((error) => {
              //alert(error);
              console.log(error);
            });
        }
      } else if (vm.selectedSessionTypeId == 100) {
        if (vm.uid) {
          collectionName += "/" + vm.roomId + "/Participances/" + vm.uid;
          db.doc(collectionName)
            .get()
            .then((doc) => {
              if (doc.exists || doc.data().IsActive) {
                //vm.sendChatNotification();
                var chatMsg = "";
                if (actionType == 1) {
                  chatMsg = vm.name + " have joined the video call";
                } else if (actionType == 0) {
                  chatMsg = vm.name + " have leaved the video call";
                } else if (actionType == -1) {
                  chatMsg = vm.name + " have declined the video call";
                }
                let headers = {
                  "content-type": "application/json",
                  Authorization: "Bearer " + vm.getSessionToken(),
                };
                let requestData = {
                  key: {
                    instanceId: "OA_UAT",
                    clientId: vm.clientId,
                    eventId: vm.eventId,
                  },
                  data: {
                    roomId: vm.roomId,
                    msgType: "EVENT-NOTIFICATION",
                    msgText: chatMsg,
                    senderId: vm.uid,
                    senderName: vm.name,
                    senderPhotoUrl: vm.profilePictureURL,
                    fileUrl: "",
                  },
                };
                axios
                  .post(APIs.postMessage, requestData, {
                    headers: headers,
                  })
                  .then((responseData) => {
                    vm.hideLoader();
                    //alert("SendMeetingPush Success");
                    console.log(responseData);
                  })
                  .catch((error) => {
                    //alert("SendMeetingPush Failure");
                    console.log("Start RT: " + error);
                  });
              }
            })
            .catch((error) => {
              //alert(error);
              console.log(error);
            });
        }
      }
    },
    sendChatNotification1() {
      var chatMsg = vm.name + " had joined  video call";
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: {
          roomId: vm.roomId,
          msgType: "EVENT-NOTIFICATION",
          msgText: chatMsg,
          senderId: vm.uid,
          senderName: vm.name,
          senderPhotoUrl: vm.profilePictureURL,
          fileUrl: "",
        },
      };
      axios
        .post(APIs.postMessage, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          vm.hideLoader();
          //alert("SendMeetingPush Success");
          console.log(responseData);
        })
        .catch((error) => {
          //alert("SendMeetingPush Failure");
          console.log("Start RT: " + error);
        });
    },
    initCurrentMeetingTimer() {
      if (currentSessionTimer) {
        clearInterval(currentSessionTimer);
      }
      vm.meetingTimeCounterLabel = vm.meetingTimeEndsInLabel;
      currentSessionTimer = setInterval(function () {
        if (vm.o2oMeeting) {
          var currentTime = parseInt(new Date().getTime() / 1000);
          if (
            currentTime > vm.o2oMeeting.StartTime &&
            currentTime < vm.o2oMeeting.EndTime
          ) {
            let sessionEndsIn = vm.o2oMeeting.EndTime - currentTime;

            if (!vm.hideNotificationClicked) {
              if (sessionEndsIn > 1 && sessionEndsIn < 120) {
                //vm.showNotification(
                //  vm.selectedSession.NotificationMessage.replace(
                //    "{{countdown}}",
                //    vm.formatTimeForClock(sessionEndsIn)
                //  )
                //);
                vm.showNotification(
                  "This meeting is about to end in {{countdown}}".replace(
                    "{{countdown}}",
                    vm.formatTimeForClock(sessionEndsIn)
                  )
                );
              } else if (sessionEndsIn < 2) {
                vm.hideNotification();
              }
            }
            $("#sessionEndCountdown").html(
              vm.formatTimeForClock(sessionEndsIn)
            );

            let timerVal = vm.formatTimeForClock(sessionEndsIn);
            if (
              vm.newDesign &&
              typeof vm.livePlayer.displayTimer == "function"
            ) {
              vm.livePlayer.displayTimer(
                true,
                vm.meetingTimeCounterLabel,
                timerVal,
                sessionEndsIn
              );
            }
            vm.prevSessionRunning = true;
            if (sessionEndsIn > 1 && sessionEndsIn < 12000) {
              vm.livePlayer.showNextMeetingJoinLink(true, false);
            }
          } else if (vm.prevSessionRunning) {
            vm.meetingTimeCounterLabel = vm.sessionTimeExceedsByLabel;
            vm.livePlayer.showNextMeetingJoinLink(true, true);
            vm.sessionTimeExceeded = true;
            if (!vm.callStarted) {
              if (!vm.callSwitchingInProcess) {
                vm.allowLeavePage = true;
                router.push(vm.redirectToPath);
              }
            } else {
              let sessionEndsIn = vm.o2oMeeting.EndTime - currentTime;
              $("#sessionEndCountdown").html(
                vm.formatTimeForClock(sessionEndsIn)
              );

              let timerVal = vm.formatTimeForClock(sessionEndsIn);
              if (
                vm.newDesign &&
                typeof vm.livePlayer.displayTimer == "function"
              ) {
                vm.livePlayer.displayTimer(
                  true,
                  vm.meetingTimeCounterLabel,
                  timerVal,
                  sessionEndsIn
                );
              }
            }
          }
        } else {
          //alert("sessionEndCountdown");
          $("#sessionEndCountdown").html("");
        }
      }, 1000);
    },
    //E2O END

    setupRightPanel(
      uid,
      attendeeType,
      channelName,
      sessionTypeId,
      speakerProfiles,
      session,
      roundTable,
      o2oMeeting,
      roundtableSettings,
      isZoomRTMP
    ) {
      if (sessionTypeId == 4 && !roundTable) {
        return;
      }
      vm.rightPanelVisible = true;
      //alert("setupRightPanel:" + vm.callStarted);
      vm.rightPanel.setupRightPanel(
        uid,
        attendeeType,
        channelName,
        sessionTypeId,
        speakerProfiles,
        session,
        roundTable,
        o2oMeeting,
        roundtableSettings,
        vm.agendaFilterOption,
        vm.exPageId,
        vm.exMeetingId,
        isZoomRTMP,
        vm.roomId
      );
      //alert("success");
      vm.rightPanelVisible = true;
    },
    hideRightPanel() {
      vm.rightPanelVisible = false;
    },
    createPresence(entityId, presencePath, sessionPath, isActive) {
      //alert(isActive);
      if (isActive) {
        if (entityId != "" && presencePath != "" && sessionPath != "") {
          if (!vm.presence) {
            vm.presence = {
              entityId: entityId,
              deviceId: new Date().getTime(),
            };
            let userAgent = navigator.userAgent;
            var userStatusDatabaseRef = firebase
              .database()
              .ref(
                "/" +
                  vm.event_collectionName +
                  "/" +
                  vm.uid +
                  "/" +
                  vm.presence.deviceId
              );
            var isOfflineForDatabase = {
              online: false,
              //timestamp: new Date().getTime(), //firebase.database.ServerValue.TIMESTAMP,
            };
            var isOnlineForDatabase = {
              online: true,
              userAgent: userAgent,
              presence: presencePath,
              session: sessionPath,
              //timestamp: new Date().getTime(), //firebase.database.ServerValue.TIMESTAMP,
            };
            realtimeDB = firebase
              .database()
              .ref(".info/connected")
              .on("value", function (snapshot) {
                //alert("connected");
                // If we're not currently connected, don't do anything.
                //alert("connected:" + snapshot.val());
                if (snapshot.val() == false) {
                  return;
                }

                // If we are currently connected, then use the 'onDisconnect()'
                // method to add a set which will only trigger once this
                // client has disconnected by closing the app,
                // losing internet, or any other means.
                //if (realtimeDB.DisconnectRef) {
                //  realtimeDB.DisconnectRef();
                //}
                realtimeDB.DisconnectRef = userStatusDatabaseRef
                  .onDisconnect()
                  //.set(isOfflineForDatabase)
                  .update(isOfflineForDatabase)
                  .then(function () {
                    //alert("onDisconnect");
                    // The promise returned from .onDisconnect().set() will
                    // resolve as soon as the server acknowledges the onDisconnect()
                    // request, NOT once we've actually disconnected:
                    // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

                    // We can now safely set ourselves as 'online' knowing that the
                    // server will mark us as offline once we lose connection.
                    //if (realtimeDB.ConnectRef) {
                    //  realtimeDB.ConnectRef();
                    //}
                    realtimeDB.ConnectRef = userStatusDatabaseRef
                      .set(isOnlineForDatabase)
                      .then(function () {
                        //alert("onConnect");
                      });
                  });
              })
              .catch(function (error) {
                console.log(error);
              });
          } else {
            //make offline previous call
          }
        }
      } else {
        //alert(vm.deviceId);
        if (vm.presence && vm.presence.deviceId) {
          firebase
            .database()
            .ref(
              "/" +
                vm.event_collectionName +
                "/" +
                vm.uid +
                "/" +
                vm.presence.deviceId
            )
            .update({
              online: false,
            })
            .then(function () {})
            .catch(function (error) {
              console.log(error);
            });
          vm.presence = null;
        }
      }
    },
    getChannelName() {
      //sessionId, roundTableId, user1Id, user2Id
      let channelName = "OAUAT_" + vm.eventId.substring("1") + "_";
      //vm.selectedSessionTypeId
      //OnDemand Video
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
        channelName += vm.selectedSessionId;
      }
      //Live Stream
      else if (vm.selectedSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID) {
        channelName += vm.selectedSessionId;
      }
      //Live Panel
      else if (vm.selectedSessionTypeId == vm.GlobalKeysData.LivePanelTypeID) {
        if (
          vm.selectedSession.SessionStartTime >
          parseInt(new Date().getTime() / 1000)
        ) {
          //alert("gr");
          channelName += vm.selectedSessionId + "_gr";
        } else {
          //alert("");
          channelName += vm.selectedSessionId;
        }
      }
      //Round Table
      else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.RoundTableTypeID ||
        vm.exPageId == "rt"
      ) {
        channelName += vm.selectedRoundTableId + "_rt";
      }
      //One to One
      else if (vm.selectedSessionTypeId == vm.GlobalKeysData.O2OTypeID) {
        //channelName += user1Id + "_" + user2Id + "_o2o";
        //channelName += vm.exMeetingId + "_o2o";
        channelName += vm.exMeetingId + "_o2o";
      } else if (vm.selectedSessionTypeId == vm.GlobalKeysData.E2OTypeID) {
        channelName += vm.exExhibitorId + "-" + vm.exAttendee1Id + "_e2o";
      } else if (vm.selectedSessionTypeId == 100) {
        channelName = vm.eventId.substring("1") + "_" + vm.roomId;
      }
      console.log(channelName);
      return channelName;
    },

    getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined
            ? null
            : decodeURIComponent(sParameterName[1]);
        }
      }
    },

    lightOrDark: function () {
      var color = $("#leftmenu").css("background-color");
      // Variables for red, green, blue values
      var r, g, b, hsp;
      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );

        r = color[1];
        g = color[2];
        b = color[3];
      } else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +(
          "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        );

        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
      }

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

      // Using the HSP value, determine whether the color is light or dark
      if (hsp > 127.5) {
        return "light";
      } else {
        return "dark";
      }
    },
  },
};
</script>
<style scoped>
.onair-palyer-wrap,
.live-stage-body,
.page-wrap-inner,
#LiveStage,
#vueplayer,
#app,
html,
body {
  background-color: #000;
}

.on-demand-session-option {
  position: relative;
}
.on-demand-session-option p {
  margin: 0 0 0 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  padding: 0 4px;
}
.on-demand-session-option p span {
  height: 6px;
  width: 6px;
  background: #7f838c;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
  margin: 2px;
}
.on-demand-dropdown {
  position: absolute;
  right: 4px;
  bottom: 100%;
  min-width: 169px;
  background: #fff;
  min-height: 41px;
  padding: 0 15px;
  border-radius: 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  z-index: 999999;
  margin-bottom: 12px;
}
.on-demand-dropdown ul {
  margin: 0;
  padding: 0;
}
.on-demand-dropdown ul li {
  list-style: none;
  font-size: 0.875rem;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
  font-weight: 400;
  cursor: pointer;
}
.on-demand-dropdown ul li:last-child {
  border-bottom: none;
}

#LiveStage .retry-label {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 9;
  color: #fff;
  user-select: none;
}
#LiveStage .player-btn {
  position: absolute !important;
  left: 10px !important;
  bottom: 10px !important;
  z-index: 9;
  color: #fff !important;
}
</style>
